window.validPincodes = [
  {
    "pincode": 110001,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110002,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110003,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110004,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110005,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110006,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110007,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110008,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110009,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110010,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110011,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110012,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110013,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110014,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110015,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110016,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110017,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110018,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110019,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110020,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110021,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110022,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110023,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110024,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110025,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110026,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110027,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110028,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110029,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110030,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110031,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110032,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110033,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110034,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110035,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110036,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110037,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110038,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110039,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110040,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110041,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110042,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110043,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110044,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110045,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110046,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110047,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110048,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110049,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110050,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110051,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110052,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110053,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110054,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110055,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110056,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110057,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110058,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110059,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110060,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110061,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110062,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110063,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110064,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110065,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110066,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110067,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110068,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110069,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110070,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110071,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110072,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110073,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110074,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110075,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110076,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110077,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110078,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110080,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110081,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110082,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110083,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110084,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110085,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110086,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110087,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110088,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110089,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110090,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110091,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110092,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110093,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110094,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110095,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110096,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110097,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110110,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110301,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110505,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 116019,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 120001,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 120002,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121001,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121002,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121003,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121004,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121005,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121006,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121007,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121008,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121009,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121010,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121012,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121013,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121101,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121102,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121103,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121104,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121105,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121106,
    "state": "HARYANA",
    "district": "BALLABGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122001,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122002,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122003,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122004,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122005,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122006,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122007,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122008,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122009,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122010,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122011,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122012,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122015,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122016,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122017,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122018,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122022,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122026,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122032,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122033,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122050,
    "state": "HARYANA",
    "district": "MANESAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122051,
    "state": "HARYANA",
    "district": "MANESAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122052,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122101,
    "state": "HARYANA",
    "district": "MANESAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122102,
    "state": "HARYANA",
    "district": "SOHNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122103,
    "state": "HARYANA",
    "district": "SOHNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122104,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122105,
    "state": "HARYANA",
    "district": "DHARUHERA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122106,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122107,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122413,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122414,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122503,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122504,
    "state": "HARYANA",
    "district": "DHARUHERA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122505,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122506,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123021,
    "state": "HARYANA",
    "district": "Mahendragarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123101,
    "state": "HARYANA",
    "district": "REWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123106,
    "state": "HARYANA",
    "district": "DHARUHERA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123110,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123401,
    "state": "HARYANA",
    "district": "Rewari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123414,
    "state": "HARYANA",
    "district": "REWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123501,
    "state": "HARYANA",
    "district": "Rewari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124001,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124501,
    "state": "HARYANA",
    "district": "Rohtak",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124507,
    "state": "HARYANA",
    "district": "Jhajjar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125001,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125002,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125003,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125004,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125005,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125006,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125050,
    "state": "HARYANA",
    "district": "Fatehabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125055,
    "state": "HARYANA",
    "district": "Sirsa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126101,
    "state": "HARYANA",
    "district": "Jind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127021,
    "state": "HARYANA",
    "district": "Bhiwani",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131001,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131002,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131021,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131027,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131028,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132001,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132103,
    "state": "HARYANA",
    "district": "Panipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133001,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133002,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133003,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133004,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133005,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133006,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134001,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134002,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134003,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134004,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134005,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134007,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134101,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134102,
    "state": "HIMACHAL PRADESH",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134104,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134107,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134109,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134111,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134112,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134113,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134114,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134116,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134117,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 135001,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 135002,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 135003,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136027,
    "state": "HARYANA",
    "district": "Kaithal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136118,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140001,
    "state": "PUNJAB",
    "district": "ROPAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140124,
    "state": "PUNJAB",
    "district": "Rupnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140401,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141001,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141002,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141003,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141004,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141006,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141007,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141008,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141010,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141011,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141012,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141013,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141014,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141015,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141110,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141112,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141114,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141115,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141116,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141118,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141120,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141123,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141401,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141416,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141421,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142001,
    "state": "PUNJAB",
    "district": "Moga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143001,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143002,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143003,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143004,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143005,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143006,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143008,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143101,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143102,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143401,
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143521,
    "state": "PUNJAB",
    "district": "Gurdaspur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143604,
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144000,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144001,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144002,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144003,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144004,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144005,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144006,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144007,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144008,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144012,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144013,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144019,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144020,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144021,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144022,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144023,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144410,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144602,
    "state": "PUNJAB",
    "district": "Kapurthala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145001,
    "state": "PUNJAB",
    "district": "Pathankot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146001,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146105,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147001,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147002,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147003,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147004,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148001,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151001,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151002,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151003,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151005,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151203,
    "state": "PUNJAB",
    "district": "Faridkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152001,
    "state": "PUNJAB",
    "district": "Firozpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152026,
    "state": "PUNJAB",
    "district": "Muktsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152101,
    "state": "PUNJAB",
    "district": "Muktsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152107,
    "state": "PUNJAB",
    "district": "Muktsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152116,
    "state": "PUNJAB",
    "district": "Fazilka",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160001,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160002,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160003,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160008,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160009,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160010,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160011,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160012,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160014,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160015,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160017,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160018,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160019,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160020,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160022,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160023,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160024,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160025,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160026,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160027,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160029,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160030,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160031,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160032,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160033,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160034,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160036,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160037,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160038,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160039,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160040,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160041,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160044,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160047,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160049,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160055,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160059,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160062,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160071,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160101,
    "state": "HARYANA",
    "district": "Chandigarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160102,
    "state": "HARYANA",
    "district": "Chandigarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160103,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160104,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171001,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171002,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171003,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171006,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173210,
    "state": "HARYANA",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173220,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174001,
    "state": "HIMACHAL PRADESH",
    "district": "Bilaspur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174101,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174103,
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175001,
    "state": "HIMACHAL PRADESH",
    "district": "Mandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175002,
    "state": "HIMACHAL PRADESH",
    "district": "Mandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175021,
    "state": "HIMACHAL PRADESH",
    "district": "Mandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175101,
    "state": "HIMACHAL PRADESH",
    "district": "Kullu",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175125,
    "state": "HIMACHAL PRADESH",
    "district": "Kullu",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175131,
    "state": "HIMACHAL PRADESH",
    "district": "BHUNTAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176001,
    "state": "HARYANA",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176002,
    "state": "PUNJAB",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176061,
    "state": "HARYANA",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176215,
    "state": "HARYANA",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176303,
    "state": "PUNJAB",
    "district": "Chamba",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177001,
    "state": "HARYANA",
    "district": "Hamirpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177203,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 200101,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 200102,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201001,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201002,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201003,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201004,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201005,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201006,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201007,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201008,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201009,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201010,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201011,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201012,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201013,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201014,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201101,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201102,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201204,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201206,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201301,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201302,
    "state": "UTTAR PRADESH",
    "district": "MURADNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201303,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201304,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201305,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201306,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201307,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201308,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201309,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201310,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201312,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201313,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201314,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202001,
    "state": "UTTAR PRADESH",
    "district": "Aligarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202002,
    "state": "UTTAR PRADESH",
    "district": "Aligarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202391,
    "state": "UTTAR PRADESH",
    "district": "Aligarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202393,
    "state": "UTTAR PRADESH",
    "district": "Aligarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203001,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203131,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203132,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203133,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203135,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203141,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203201,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203205,
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203206,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203207,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203391,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203392,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203393,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203394,
    "state": "UTTAR PRADESH",
    "district": "JAHANGIRABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204001,
    "state": "UTTAR PRADESH",
    "district": "Mahamaya Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206001,
    "state": "UTTAR PRADESH",
    "district": "Etawah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206002,
    "state": "UTTAR PRADESH",
    "district": "Etawah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206003,
    "state": "UTTAR PRADESH",
    "district": "Etawah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206016,
    "state": "UTTAR PRADESH",
    "district": "Etawah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206131,
    "state": "UTTAR PRADESH",
    "district": "Etawah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206241,
    "state": "UTTAR PRADESH",
    "district": "Auraiya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206244,
    "state": "UTTAR PRADESH",
    "district": "Auraiya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 207001,
    "state": "UTTAR PRADESH",
    "district": "Etah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208001,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208002,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208003,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208004,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208005,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208006,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208007,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208008,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208009,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208010,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208011,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208012,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208013,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208014,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208015,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208016,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208017,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208018,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208019,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208020,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208021,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208022,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208023,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208024,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208025,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208026,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208027,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209101,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209206,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209217,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209304,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209402,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209501,
    "state": "UTTAR PRADESH",
    "district": "Farrukhabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209503,
    "state": "UTTAR PRADESH",
    "district": "Farrukhabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209601,
    "state": "UTTAR PRADESH",
    "district": "Farrukhabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209622,
    "state": "UTTAR PRADESH",
    "district": "Farrukhabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209625,
    "state": "UTTAR PRADESH",
    "district": "Farrukhabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209723,
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209725,
    "state": "UTTAR PRADESH",
    "district": "Kannauj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209729,
    "state": "UTTAR PRADESH",
    "district": "Kannauj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209733,
    "state": "UTTAR PRADESH",
    "district": "Kannauj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209734,
    "state": "UTTAR PRADESH",
    "district": "Kannauj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209736,
    "state": "UTTAR PRADESH",
    "district": "Kannauj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209738,
    "state": "UTTAR PRADESH",
    "district": "Kannauj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209745,
    "state": "UTTAR PRADESH",
    "district": "Farrukhabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209801,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209859,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209860,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209861,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209862,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209868,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209871,
    "state": "UTTAR PRADESH",
    "district": "Unnao",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210001,
    "state": "UTTAR PRADESH",
    "district": "Banda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210120,
    "state": "UTTAR PRADESH",
    "district": "Banda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210123,
    "state": "UTTAR PRADESH",
    "district": "Banda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210128,
    "state": "UTTAR PRADESH",
    "district": "Banda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210205,
    "state": "UTTAR PRADESH",
    "district": "Chitrakoot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210301,
    "state": "UTTAR PRADESH",
    "district": "Hamirpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210427,
    "state": "UTTAR PRADESH",
    "district": "Mahoba",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210431,
    "state": "UTTAR PRADESH",
    "district": "Hamirpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211001,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211002,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211003,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211004,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211005,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211006,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211007,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211008,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211009,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211010,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211011,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211012,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211013,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211014,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211015,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211016,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211017,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211018,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211019,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212207,
    "state": "UTTAR PRADESH",
    "district": "Kaushambi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212402,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212601,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212631,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212653,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212655,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212657,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212664,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212665,
    "state": "UTTAR PRADESH",
    "district": "Fatehpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 220016,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221001,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221002,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221003,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221004,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221005,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221006,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221007,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221008,
    "state": "UTTAR PRADESH",
    "district": "Chandauli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221009,
    "state": "UTTAR PRADESH",
    "district": "Chandauli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221010,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221011,
    "state": "UTTAR PRADESH",
    "district": "Chandauli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221101,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221102,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221103,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221104,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221107,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221108,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221110,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221301,
    "state": "UTTAR PRADESH",
    "district": "Sant Ravidas Nagar (Bhadohi)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221302,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221303,
    "state": "UTTAR PRADESH",
    "district": "Sant Ravidas Nagar (Bhadohi)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221304,
    "state": "UTTAR PRADESH",
    "district": "Sant Ravidas Nagar (Bhadohi)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221306,
    "state": "UTTAR PRADESH",
    "district": "Sant Ravidas Nagar (Bhadohi)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221311,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221401,
    "state": "UTTAR PRADESH",
    "district": "Sant Ravidas Nagar (Bhadohi)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221406,
    "state": "UTTAR PRADESH",
    "district": "Sant Ravidas Nagar (Bhadohi)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221503,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221505,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221602,
    "state": "UTTAR PRADESH",
    "district": "Ballia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221603,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221706,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221712,
    "state": "UTTAR PRADESH",
    "district": "Ballia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222001,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222002,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222003,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222105,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222109,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222125,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222131,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222132,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222133,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222137,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222138,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222139,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222143,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222180,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224001,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224101,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224120,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224121,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224122,
    "state": "UTTAR PRADESH",
    "district": "Ambedkar Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224123,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224135,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224190,
    "state": "UTTAR PRADESH",
    "district": "Ambedkar Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224201,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225001,
    "state": "UTTAR PRADESH",
    "district": "BaraBanki",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225003,
    "state": "UTTAR PRADESH",
    "district": "BaraBanki",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225124,
    "state": "UTTAR PRADESH",
    "district": "BaraBanki",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225302,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225305,
    "state": "UTTAR PRADESH",
    "district": "BaraBanki",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226001,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226002,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226003,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226004,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226005,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226006,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226007,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226008,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226009,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226010,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226011,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226012,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226013,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226014,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226016,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226017,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226018,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226019,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226020,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226021,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226022,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226023,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226024,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226025,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226026,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226029,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226031,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226201,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226202,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226401,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226501,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227101,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227105,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227409,
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227412,
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227809,
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228001,
    "state": "UTTAR PRADESH",
    "district": "Sultanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229001,
    "state": "UTTAR PRADESH",
    "district": "RAIBARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229002,
    "state": "UTTAR PRADESH",
    "district": "Rae Bareli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229003,
    "state": "UTTAR PRADESH",
    "district": "Rae Bareli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229010,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229206,
    "state": "UTTAR PRADESH",
    "district": "RAIBARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229301,
    "state": "UTTAR PRADESH",
    "district": "RAIBARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229316,
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229402,
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229406,
    "state": "UTTAR PRADESH",
    "district": "Rae Bareli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 230001,
    "state": "UTTAR PRADESH",
    "district": "Pratapgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 230135,
    "state": "UTTAR PRADESH",
    "district": "Pratapgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 230204,
    "state": "UTTAR PRADESH",
    "district": "Pratapgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231001,
    "state": "UTTAR PRADESH",
    "district": "Mirzapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231205,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231208,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231216,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231217,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231218,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231219,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231220,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231222,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231223,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231305,
    "state": "UTTAR PRADESH",
    "district": "Mirzapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231312,
    "state": "UTTAR PRADESH",
    "district": "Mirzapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232101,
    "state": "UTTAR PRADESH",
    "district": "Chandauli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232109,
    "state": "UTTAR PRADESH",
    "district": "CHANDOULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232329,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232333,
    "state": "UTTAR PRADESH",
    "district": "GAZIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233227,
    "state": "UTTAR PRADESH",
    "district": "Ghazipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233304,
    "state": "UTTAR PRADESH",
    "district": "Ghazipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241001,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241121,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241125,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241126,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241204,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241302,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242001,
    "state": "UTTAR PRADESH",
    "district": "Shahjahanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242401,
    "state": "UTTAR PRADESH",
    "district": "Shahjahanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243001,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 243002,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243003,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243004,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243005,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 243006,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243122,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 243123,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243201,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243202,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243501,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243502,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243503,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243601,
    "state": "UTTAR PRADESH",
    "district": "BADAUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243639,
    "state": "UTTAR PRADESH",
    "district": "Budaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243722,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243727,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243751,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244001,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244002,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244003,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244221,
    "state": "UTTAR PRADESH",
    "district": "Jyotiba Phule Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244235,
    "state": "UTTAR PRADESH",
    "district": "Jyotiba Phule Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244301,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244711,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244712,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244713,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244714,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244715,
    "state": "UTTARAKHAND",
    "district": "Nainital",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244901,
    "state": "UTTAR PRADESH",
    "district": "Rampur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245101,
    "state": "UTTAR PRADESH",
    "district": "Hapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245205,
    "state": "UTTAR PRADESH",
    "district": "Hapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245304,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246125,
    "state": "UTTAR PRADESH",
    "district": "Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246147,
    "state": "UTTAR PRADESH",
    "district": "Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246149,
    "state": "UTTAR PRADESH",
    "district": "Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246174,
    "state": "UTTARAKHAND",
    "district": "SRINAGAR - UT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246444,
    "state": "UTTARAKHAND",
    "district": "RISHIKESH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246700,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246701,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246725,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246761,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246763,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246767,
    "state": "UTTARAKHAND",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247001,
    "state": "UTTAR PRADESH",
    "district": "Saharanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247656,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247661,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247663,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247666,
    "state": "UTTARAKHAND",
    "district": "Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247667,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247776,
    "state": "UTTAR PRADESH",
    "district": "Shamli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248001,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248002,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248003,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248004,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248005,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248006,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248007,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248008,
    "state": "UTTARAKHAND",
    "district": "Tehri Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248009,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248115,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248121,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248125,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248140,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248142,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248146,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248160,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248171,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248179,
    "state": "UTTARAKHAND",
    "district": "Tehri Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248195,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248197,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248198,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249001,
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249155,
    "state": "UTTARAKHAND",
    "district": "RISHIKESH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249161,
    "state": "UTTAR PRADESH",
    "district": "Tehri Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249192,
    "state": "UTTARAKHAND",
    "district": "Tehri Garhwal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249193,
    "state": "UTTARAKHAND",
    "district": "UTTARKASHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249201,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249202,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249401,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249402,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249403,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249404,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249405,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249406,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249407,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249408,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249410,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249411,
    "state": "UTTARAKHAND",
    "district": "Dehradun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250001,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250002,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250003,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250004,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250005,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250101,
    "state": "UTTAR PRADESH",
    "district": "Baghpat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250103,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250502,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251001,
    "state": "UTTAR PRADESH",
    "district": "Muzaffarnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251002,
    "state": "UTTAR PRADESH",
    "district": "Muzaffarnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251203,
    "state": "UTTAR PRADESH",
    "district": "Muzaffarnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251305,
    "state": "UTTAR PRADESH",
    "district": "Shamli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261001,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261125,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261136,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261207,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261404,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261405,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261501,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261506,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262308,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262405,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262501,
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262701,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262721,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262722,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262725,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262803,
    "state": "UTTAR PRADESH",
    "district": "LAKHIMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262805,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262901,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262902,
    "state": "UTTAR PRADESH",
    "district": "LAKHIMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262903,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263001,
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263002,
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263139,
    "state": "UTTARAKHAND",
    "district": "Nainital",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263140,
    "state": "UTTARAKHAND",
    "district": "HALDWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263141,
    "state": "UTTARAKHAND",
    "district": "Nainital",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263145,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263148,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263149,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263152,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263153,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263160,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263601,
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263620,
    "state": "UTTARAKHAND",
    "district": "Almora",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 266005,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 269869,
    "state": "UTTAR PRADESH",
    "district": "Kanpur Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271203,
    "state": "UTTAR PRADESH",
    "district": "Balrampur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271206,
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271208,
    "state": "UTTAR PRADESH",
    "district": "Balrampur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271209,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271308,
    "state": "UTTAR PRADESH",
    "district": "Gonda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271801,
    "state": "UTTAR PRADESH",
    "district": "Bahraich",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272001,
    "state": "UTTAR PRADESH",
    "district": "Basti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272002,
    "state": "UTTAR PRADESH",
    "district": "Basti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272125,
    "state": "UTTAR PRADESH",
    "district": "Sant Kabir Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272126,
    "state": "UTTAR PRADESH",
    "district": "Sant Kabir Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272148,
    "state": "UTTAR PRADESH",
    "district": "Sant Kabir Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272152,
    "state": "UTTAR PRADESH",
    "district": "Siddharthnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272170,
    "state": "UTTAR PRADESH",
    "district": "Basti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272203,
    "state": "UTTAR PRADESH",
    "district": "Siddharthnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272206,
    "state": "UTTAR PRADESH",
    "district": "Siddharthnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272207,
    "state": "UTTAR PRADESH",
    "district": "Siddharthnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273001,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273002,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273003,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273004,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273005,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273006,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273007,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273008,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273009,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273010,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273011,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273012,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273013,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273014,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273015,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273016,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273017,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273151,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273152,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273155,
    "state": "UTTAR PRADESH",
    "district": "MAHRAJGANJ",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273157,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273162,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273164,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273200,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273201,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273207,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273209,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273302,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273303,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273310,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274001,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274002,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274003,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274182,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274202,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274203,
    "state": "UTTAR PRADESH",
    "district": "Kushinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274208,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274301,
    "state": "UTTAR PRADESH",
    "district": "Kushinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274303,
    "state": "UTTAR PRADESH",
    "district": "Kushinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274304,
    "state": "UTTAR PRADESH",
    "district": "KUSHINAGAR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 274401,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274402,
    "state": "UTTAR PRADESH",
    "district": "Kushinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274404,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274406,
    "state": "UTTAR PRADESH",
    "district": "KUSHINAGAR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 274408,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274505,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274603,
    "state": "UTTAR PRADESH",
    "district": "Deoria",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275101,
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275102,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275103,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275105,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275301,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275302,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275304,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275305,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275306,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275307,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276001,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276125,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276135,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276206,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276207,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276305,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276306,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276402,
    "state": "UTTAR PRADESH",
    "district": "Mau",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276403,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276404,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276405,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276406,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 277001,
    "state": "UTTAR PRADESH",
    "district": "Ballia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281001,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281002,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281003,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281004,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281005,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281403,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281405,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282001,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282002,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282003,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282004,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282005,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282006,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282007,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282008,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282009,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 282010,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 283203,
    "state": "UTTAR PRADESH",
    "district": "Firozabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284001,
    "state": "UTTAR PRADESH",
    "district": "Jhansi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284002,
    "state": "UTTAR PRADESH",
    "district": "Jhansi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284003,
    "state": "UTTAR PRADESH",
    "district": "Jhansi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284129,
    "state": "UTTAR PRADESH",
    "district": "Jhansi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285121,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285122,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285123,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285125,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285126,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285128,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285129,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285130,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285201,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285202,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285203,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285204,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285206,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 288005,
    "state": "UTTAR PRADESH",
    "district": "Agra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301001,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301002,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301019,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301020,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301026,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301030,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301160,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301301,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301402,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301404,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301405,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301701,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301705,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301706,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301707,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302001,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302002,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302003,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302004,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302005,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302006,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302007,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302008,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302009,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302010,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302011,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302012,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302013,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302014,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302015,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302016,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302017,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302018,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302019,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302020,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302021,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302022,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302023,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302024,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302025,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302026,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302028,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302029,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302031,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302033,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302034,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302039,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302103,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303002,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303101,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303103,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303106,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303108,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303109,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303121,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303313,
    "state": "RAJASTHAN",
    "district": "Dausa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303505,
    "state": "RAJASTHAN",
    "district": "Dausa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303706,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303901,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303904,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303905,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304021,
    "state": "RAJASTHAN",
    "district": "Tonk",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304804,
    "state": "RAJASTHAN",
    "district": "Tonk",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305001,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305002,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305003,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305004,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305005,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305007,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305009,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305022,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305023,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305025,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305403,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305404,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305601,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305624,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305801,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305816,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305901,
    "state": "RAJASTHAN",
    "district": "Ajmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306302,
    "state": "RAJASTHAN",
    "district": "Pali",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306401,
    "state": "RAJASTHAN",
    "district": "Pali",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 310001,
    "state": "RAJASTHAN",
    "district": "Bhilwara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311001,
    "state": "RAJASTHAN",
    "district": "Bhilwara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311021,
    "state": "RAJASTHAN",
    "district": "Bhilwara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311404,
    "state": "RAJASTHAN",
    "district": "Bhilwara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311602,
    "state": "RAJASTHAN",
    "district": "Bhilwara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311604,
    "state": "RAJASTHAN",
    "district": "Bhilwara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312202,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313001,
    "state": "RAJASTHAN",
    "district": "Udaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313002,
    "state": "RAJASTHAN",
    "district": "Udaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313003,
    "state": "RAJASTHAN",
    "district": "Udaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313004,
    "state": "RAJASTHAN",
    "district": "Udaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313027,
    "state": "RAJASTHAN",
    "district": "Udaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313301,
    "state": "RAJASTHAN",
    "district": "Rajsamand",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314001,
    "state": "RAJASTHAN",
    "district": "Dungarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314025,
    "state": "RAJASTHAN",
    "district": "Dungarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321022,
    "state": "RAJASTHAN",
    "district": "Bharatpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322021,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322230,
    "state": "RAJASTHAN",
    "district": "Karauli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322241,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323001,
    "state": "RAJASTHAN",
    "district": "Bundi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323306,
    "state": "RAJASTHAN",
    "district": "Chittaurgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323307,
    "state": "RAJASTHAN",
    "district": "Udaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323603,
    "state": "RAJASTHAN",
    "district": "Bundi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324001,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324002,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324003,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324004,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324005,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324006,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324007,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324008,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324009,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 324010,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325205,
    "state": "RAJASTHAN",
    "district": "Baran",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325219,
    "state": "RAJASTHAN",
    "district": "Baran",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325220,
    "state": "RAJASTHAN",
    "district": "Baran",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326021,
    "state": "RAJASTHAN",
    "district": "Jhalawar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326033,
    "state": "RAJASTHAN",
    "district": "Jhalawar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326037,
    "state": "RAJASTHAN",
    "district": "Jhalawar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326502,
    "state": "RAJASTHAN",
    "district": "Jhalawar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326530,
    "state": "RAJASTHAN",
    "district": "Kota",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327001,
    "state": "RAJASTHAN",
    "district": "Banswara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328001,
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331001,
    "state": "RAJASTHAN",
    "district": "Churu",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331803,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332001,
    "state": "RAJASTHAN",
    "district": "Sikar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332031,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332404,
    "state": "RAJASTHAN",
    "district": "Sikar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334001,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334003,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334004,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334006,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334401,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335001,
    "state": "RAJASTHAN",
    "district": "Ganganagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335025,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335512,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335702,
    "state": "RAJASTHAN",
    "district": "Ganganagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335704,
    "state": "RAJASTHAN",
    "district": "Ganganagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335711,
    "state": "RAJASTHAN",
    "district": "Ganganagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335804,
    "state": "RAJASTHAN",
    "district": "Ganganagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335805,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341001,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341508,
    "state": "RAJASTHAN",
    "district": "Nagaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341510,
    "state": "RAJASTHAN",
    "district": "Nagaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342001,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342002,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342003,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342004,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342005,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342006,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342007,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342008,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342009,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342010,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342011,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342012,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342013,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342301,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342304,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342307,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342601,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342602,
    "state": "RAJASTHAN",
    "district": "Jodhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342801,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342902,
    "state": "RAJASTHAN",
    "district": "Nagaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343001,
    "state": "RAJASTHAN",
    "district": "Jalor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343041,
    "state": "RAJASTHAN",
    "district": "Jalor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344001,
    "state": "RAJASTHAN",
    "district": "Barmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344024,
    "state": "RAJASTHAN",
    "district": "Barmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345001,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345021,
    "state": "RAJASTHAN",
    "district": "Jaisalmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360001,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360002,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360003,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360004,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360005,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360006,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360007,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360021,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360024,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360034,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360311,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360320,
    "state": "GUJARAT",
    "district": "Rajkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360370,
    "state": "GUJARAT",
    "district": "JETPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360545,
    "state": "GUJARAT",
    "district": "Porbandar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360575,
    "state": "GUJARAT",
    "district": "Porbandar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360576,
    "state": "GUJARAT",
    "district": "Porbandar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360577,
    "state": "GUJARAT",
    "district": "Porbandar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360578,
    "state": "GUJARAT",
    "district": "Porbandar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361001,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361002,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361003,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361004,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361005,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361006,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361007,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361008,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361150,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361305,
    "state": "GUJARAT",
    "district": "Devbhoomi Dwarka",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362001,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362002,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362003,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362004,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362005,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362015,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362220,
    "state": "GUJARAT",
    "district": "Junagadh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363001,
    "state": "GUJARAT",
    "district": "Surendranagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363002,
    "state": "GUJARAT",
    "district": "Surendranagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363030,
    "state": "GUJARAT",
    "district": "Surendranagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363035,
    "state": "GUJARAT",
    "district": "Surendranagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363040,
    "state": "GUJARAT",
    "district": "Surendranagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363610,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363621,
    "state": "GUJARAT",
    "district": "Morbi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363641,
    "state": "GUJARAT",
    "district": "Morbi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364001,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364002,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364004,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364005,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364006,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364140,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364240,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364710,
    "state": "GUJARAT",
    "district": "Botad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365601,
    "state": "GUJARAT",
    "district": "Amreli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370001,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370015,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370020,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370110,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370201,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370203,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370205,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370210,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370230,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370485,
    "state": "GUJARAT",
    "district": "KUTCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380001,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380002,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380003,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380004,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380005,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380006,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380007,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380008,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380009,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380010,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380013,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380014,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380015,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380016,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380018,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380019,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380021,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380022,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380023,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380024,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380025,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380026,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380027,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380028,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380038,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380050,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380051,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380052,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380053,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380054,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380055,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380058,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380059,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380060,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380061,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380063,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380330,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380481,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382001,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382002,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382003,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382004,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382005,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382006,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382007,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382008,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382009,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382010,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382011,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382012,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382013,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382014,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382015,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382016,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382017,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382018,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382019,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382020,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382021,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382022,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382023,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382024,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382025,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382026,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382027,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382028,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382029,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382030,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382041,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382042,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382044,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382045,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382110,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382120,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382150,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382170,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382210,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382213,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382220,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382260,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382305,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382316,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382321,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382325,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382330,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382340,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382345,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382346,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382350,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382355,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382405,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382410,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382415,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382418,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382421,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382423,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382424,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382425,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382427,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382428,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382430,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382433,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382435,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382440,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382443,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382445,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382449,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382450,
    "state": "GUJARAT",
    "district": "Botad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382460,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382470,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382475,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382480,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382481,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382610,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382620,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382630,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382715,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382721,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382722,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382723,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382724,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382725,
    "state": "GUJARAT",
    "district": "Panch Mahals",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382729,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382735,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382830,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382845,
    "state": "GUJARAT",
    "district": "Gandhinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383001,
    "state": "GUJARAT",
    "district": "Sabar Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383006,
    "state": "GUJARAT",
    "district": "Sabar Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383315,
    "state": "GUJARAT",
    "district": "Aravalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383430,
    "state": "GUJARAT",
    "district": "Sabar Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384001,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384002,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384003,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384151,
    "state": "GUJARAT",
    "district": "Patan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384170,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384205,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384210,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384265,
    "state": "GUJARAT",
    "district": "Patan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384315,
    "state": "GUJARAT",
    "district": "Mahesana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385001,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385002,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385110,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385210,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385505,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385535,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385545,
    "state": "GUJARAT",
    "district": "Banas Kantha",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387001,
    "state": "GUJARAT",
    "district": "Kheda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387002,
    "state": "GUJARAT",
    "district": "Kheda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387355,
    "state": "GUJARAT",
    "district": "Kheda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387810,
    "state": "GUJARAT",
    "district": "Ahmadabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388001,
    "state": "GUJARAT",
    "district": "Anand",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388121,
    "state": "GUJRAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388325,
    "state": "GUJARAT",
    "district": "Anand",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388450,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388540,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388620,
    "state": "GUJARAT",
    "district": "Anand",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389151,
    "state": "GUJARAT",
    "district": "Dohad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389330,
    "state": "GUJARAT",
    "district": "Panch Mahals",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389350,
    "state": "GUJARAT",
    "district": "Panch Mahals",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390001,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390002,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390003,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390004,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390005,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390006,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390007,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390008,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390009,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390010,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390011,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390012,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390013,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390014,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390015,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390016,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390017,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390018,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390019,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390020,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390021,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390022,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390023,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390024,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390025,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391240,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391243,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391310,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391320,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391340,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391350,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391410,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391440,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391510,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391740,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391750,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391760,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391770,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391775,
    "state": "GUJARAT",
    "district": "Vadodara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392001,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392002,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392011,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392012,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392015,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392130,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393001,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393002,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393010,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393110,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394101,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394105,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394107,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394110,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394116,
    "state": "GUJARAT",
    "district": "Bharuch",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394130,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394150,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394180,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394185,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394210,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394220,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394221,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394230,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394270,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394310,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394315,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394325,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394327,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394510,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394515,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394518,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394540,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394601,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394650,
    "state": "GUJARAT",
    "district": "Tapi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395001,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395002,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395003,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395004,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395005,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395006,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395007,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395008,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395009,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395010,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395017,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395023,
    "state": "GUJARAT",
    "district": "Surat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396001,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396002,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396020,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396030,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396035,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396091,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396105,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396125,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396155,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396171,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396180,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396185,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396191,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396193,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396195,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396197,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396210,
    "state": "GUJARAT",
    "district": "Daman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396215,
    "state": "GUJARAT",
    "district": "Daman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396230,
    "state": "GUJARAT",
    "district": "Valsad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396235,
    "state": "GUJARAT",
    "district": "Dadra & Nagar Haveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396240,
    "state": "GUJARAT",
    "district": "Dadra & Nagar Haveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396321,
    "state": "GUJARAT",
    "district": "Navsari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396424,
    "state": "GUJARAT",
    "district": "Navsari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396427,
    "state": "GUJARAT",
    "district": "Navsari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396445,
    "state": "GUJARAT",
    "district": "Navsari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396521,
    "state": "GUJARAT",
    "district": "Navsari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400001,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400002,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400003,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400004,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400005,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400006,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400007,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400008,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400009,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400010,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400011,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400012,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400013,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400014,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400015,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400016,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400017,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400018,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400019,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400020,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400021,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400022,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400023,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400024,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400025,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400026,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400027,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400028,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400029,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400030,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400031,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400032,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400033,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400034,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400035,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400036,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400037,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400038,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400039,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400042,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400043,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400049,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400050,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400051,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400052,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400053,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400054,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400055,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400056,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400057,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400058,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400059,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400060,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400061,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400062,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400063,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400064,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400065,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400066,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400067,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400068,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400069,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400070,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400071,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400072,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400074,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400075,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400076,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400077,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400078,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400079,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400080,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400081,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400082,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400083,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400084,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400085,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400086,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400087,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400088,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400089,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400090,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400091,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400092,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400093,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400094,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400095,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400096,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400097,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400098,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400099,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400101,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400102,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400103,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400104,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400107,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400210,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400401,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400406,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400601,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400602,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400603,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400604,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400605,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400606,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400607,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400608,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400610,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400612,
    "state": "MAHARASHTRA",
    "district": "MUMBRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400614,
    "state": "MAHARASHTRA",
    "district": "VASHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400615,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400701,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400702,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400703,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400704,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400705,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400706,
    "state": "MAHARASHTRA",
    "district": "VASHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400707,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400708,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400709,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400710,
    "state": "MAHARASHTRA",
    "district": "VASHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401101,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401102,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401104,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401105,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401107,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401201,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401202,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401203,
    "state": "MAHARASHTRA",
    "district": "VASAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401205,
    "state": "MAHARASHTRA",
    "district": "VASAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401206,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401207,
    "state": "MAHARASHTRA",
    "district": "VASAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401208,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401209,
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401210,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401301,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401302,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401303,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401305,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401404,
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401501,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401503,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401504,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401506,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401601,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401602,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402104,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402107,
    "state": "MAHARASHTRA",
    "district": "PEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402109,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402116,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402204,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403001,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403002,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403003,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403004,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403005,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403006,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403101,
    "state": "GOA",
    "district": "CALANGUTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403110,
    "state": "GOA",
    "district": "OLD GOA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403114,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403115,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403201,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403202,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403206,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403401,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403402,
    "state": "GOA",
    "district": "OLD GOA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403404,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403407,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403408,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403409,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403501,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403504,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403505,
    "state": "GOA",
    "district": "BICHOLIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403506,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403507,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403509,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403510,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403511,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403513,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403515,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403516,
    "state": "GOA",
    "district": "CALANGUTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403517,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403519,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403520,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403521,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403524,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403525,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403529,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403530,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403601,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403602,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403603,
    "state": "GOA",
    "district": "SALCETE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403702,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403703,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403704,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403705,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403706,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403707,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403708,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403710,
    "state": "GOA",
    "district": "ZUARI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403711,
    "state": "GOA",
    "district": "ZUARI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403712,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403713,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403716,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403721,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403722,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403724,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403726,
    "state": "GOA",
    "district": "ZUARI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403729,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403731,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403801,
    "state": "GOA",
    "district": "ZUARI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403802,
    "state": "GOA",
    "district": "VASCO DA GAMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403803,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410062,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410101,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410201,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410202,
    "state": "MAHARASHTRA",
    "district": "KHOPOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410203,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410205,
    "state": "MAHARASHTRA",
    "district": "PALI (MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410206,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410207,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410208,
    "state": "MAHARASHTRA",
    "district": "TALOJA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410209,
    "state": "MAHARASHTRA",
    "district": "VASHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410210,
    "state": "MAHARASHTRA",
    "district": "KHARGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410218,
    "state": "MAHARASHTRA",
    "district": "KALAMBOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410221,
    "state": "MAHARASHTRA",
    "district": "PANVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410222,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410401,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410501,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410503,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410504,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410505,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410506,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410507,
    "state": "MAHARASHTRA",
    "district": "TALEGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410708,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411001,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411002,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411003,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411004,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411005,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411006,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411007,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411008,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411009,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411011,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411012,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411013,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411014,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411015,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411016,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411017,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411018,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411019,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411020,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411021,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411022,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411023,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411024,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411025,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411026,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411027,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411028,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411029,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411030,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411031,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411032,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411033,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411034,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411035,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411036,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411037,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411038,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411039,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411040,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411041,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411042,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411043,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411044,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411045,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411046,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411047,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411048,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411051,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411052,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411053,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411057,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411058,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411060,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411061,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411062,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412042,
    "state": "MAHARASHTRA",
    "district": "PIRANGUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412101,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412105,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412108,
    "state": "MAHARASHTRA",
    "district": "PIRANGUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412109,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412111,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412112,
    "state": "MAHARASHTRA",
    "district": "PIRANGUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412114,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412115,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412201,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412207,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412208,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412216,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412307,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412308,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412501,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412802,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413001,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413002,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413003,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413004,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413005,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413006,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413007,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413101,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413203,
    "state": "MAHARASHTRA",
    "district": "KARMALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413208,
    "state": "MAHARASHTRA",
    "district": "KURDUWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413211,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413255,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413304,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413401,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413411,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413512,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413513,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413515,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413517,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413531,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413717,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415001,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415105,
    "state": "MAHARASHTRA",
    "district": "KARAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415110,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415124,
    "state": "MAHARASHTRA",
    "district": "KARAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415307,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415409,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415410,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415539,
    "state": "MAHARASHTRA",
    "district": "KARAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415605,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415612,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416001,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416002,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416003,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416004,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416005,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416006,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416007,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416008,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416010,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416012,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416013,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416101,
    "state": "MAHARASHTRA",
    "district": "JAISINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416112,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416114,
    "state": "MAHARASHTRA",
    "district": "JAISINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416115,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416119,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416122,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416144,
    "state": "MAHARASHTRA",
    "district": "JAISINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416203,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416209,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416216,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416234,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416236,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416312,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416406,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416410,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416414,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416415,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416416,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416435,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416436,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416437,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416502,
    "state": "MAHARASHTRA",
    "district": "GADHINGLAJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416504,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421001,
    "state": "MAHARASHTRA",
    "district": "ULAHASNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421002,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421003,
    "state": "MAHARASHTRA",
    "district": "ULAHASNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421004,
    "state": "MAHARASHTRA",
    "district": "ULAHASNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421005,
    "state": "MAHARASHTRA",
    "district": "ULAHASNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421101,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421102,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421201,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421202,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421203,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421204,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421301,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421302,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421304,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421305,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421306,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421308,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421311,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421312,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421501,
    "state": "MAHARASHTRA",
    "district": "AMBERNATH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421502,
    "state": "MAHARASHTRA",
    "district": "AMBERNATH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421503,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421504,
    "state": "MAHARASHTRA",
    "district": "AMBERNATH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421505,
    "state": "MAHARASHTRA",
    "district": "AMBERNATH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421506,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421601,
    "state": "MAHARASHTRA",
    "district": "SHAHAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421605,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422001,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422002,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422003,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422004,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422005,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422006,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422007,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422008,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422009,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422010,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422011,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422012,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422013,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422101,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422102,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422103,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422112,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422113,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422207,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422401,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422403,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423109,
    "state": "MAHARASHTRA",
    "district": "SHIRDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423401,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424001,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424002,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424005,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424006,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424101,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424201,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424304,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425001,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425002,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425003,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425004,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425201,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425412,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431001,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431002,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431003,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431004,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431005,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431006,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431008,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431010,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431103,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431105,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431107,
    "state": "MAHARASHTRA",
    "district": "PAITHAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431111,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431112,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431122,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431133,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431136,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431203,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431210,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431401,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431402,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431505,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431511,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431512,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431517,
    "state": "MAHARASHTRA",
    "district": "AMBEJOGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431601,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431602,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431603,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431604,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431605,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431708,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431717,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431723,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440001,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440002,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440003,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440004,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440005,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440006,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440007,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440008,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440009,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440010,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440011,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440012,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440013,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440014,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440015,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440016,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440017,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440018,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440019,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440020,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440022,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440023,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440024,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440025,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440026,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440027,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440028,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440029,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440030,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440031,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440032,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440033,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440034,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440035,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440036,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440037,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441008,
    "state": "MAHARASHTRA",
    "district": "BUTIBORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442001,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442002,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442301,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442302,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442401,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442402,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442403,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442404,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442405,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442406,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444001,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444002,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444003,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444004,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444005,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444601,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444602,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444603,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444604,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444605,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444606,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444607,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444608,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444609,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450001,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450221,
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450331,
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450445,
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451001,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451666,
    "state": "MADHYA PRADESH",
    "district": "SENDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452001,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452002,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452003,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452004,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452005,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452006,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452007,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452008,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452009,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452010,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452011,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452012,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452013,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452014,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452015,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452016,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452017,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452018,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452020,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453001,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453112,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453331,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453441,
    "state": "MADHYA PRADESH",
    "district": "MHOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453552,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453771,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454001,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454331,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454365,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454552,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454774,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454775,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455001,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456001,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456010,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457001,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457114,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458001,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458002,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458110,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458226,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458441,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458468,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458664,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458888,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460001,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461001,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461005,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461331,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461775,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461990,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462001,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462002,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462003,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462004,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462007,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462008,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462010,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462011,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462012,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462013,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462014,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462015,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462016,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462020,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462021,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462022,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462023,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462024,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462026,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462027,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462030,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462031,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462032,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462033,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462036,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462037,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462038,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462039,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462041,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462042,
    "state": "MADHYA PRADESH",
    "district": "MANDIDEEP (RAISEN)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462043,
    "state": "MADHYA PRADESH",
    "district": "MANDIDEEP (RAISEN)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462044,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462045,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462046,
    "state": "MADHYA PRADESH",
    "district": "MANDIDEEP (RAISEN)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462047,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462048,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462066,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464001,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464002,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465333,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465667,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466116,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466331,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466445,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470001,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470002,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470004,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470442,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470661,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473331,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473551,
    "state": "MADHYA PRADESH",
    "district": "Shivpuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473990,
    "state": "MADHYA PRADESH",
    "district": "Shivpuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474001,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474002,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474003,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474004,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474005,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474006,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474007,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474008,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474009,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474010,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474011,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474015,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474020,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474021,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475110,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476337,
    "state": "MADHYA PRADESH",
    "district": "Sheopur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477117,
    "state": "MADHYA PRADESH",
    "district": "Bhind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480001,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480661,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481001,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481111,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481115,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481116,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481222,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481226,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481331,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481556,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482001,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482002,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482003,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482004,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482005,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482008,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482009,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482010,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482011,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482020,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483501,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483504,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484001,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484224,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485001,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486001,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486002,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486661,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486886,
    "state": "MADHYA PRADESH",
    "district": "VINDHYANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490001,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490002,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490006,
    "state": "CHHATTISGARH",
    "district": "DURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490009,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490011,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490020,
    "state": "CHHATTISGARH",
    "district": "DURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490021,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490023,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490024,
    "state": "CHHATTISGARH",
    "district": "DURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490026,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491001,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491002,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492001,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492003,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492004,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492006,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492007,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492008,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492009,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492010,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492012,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492013,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492099,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495001,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495003,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495004,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495006,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500001,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500002,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500003,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500004,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500005,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500006,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500007,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500008,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500009,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500010,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500011,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500012,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500013,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500014,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500015,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500016,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500017,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500018,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500019,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500020,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500021,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500022,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500023,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500024,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500025,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500026,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500027,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500028,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500029,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500030,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500031,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500032,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500033,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500034,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500035,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500036,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500037,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500038,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500039,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500040,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500041,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500042,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500043,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500044,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500045,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500046,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500047,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500048,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500049,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500050,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500051,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500052,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500053,
    "state": "TELANGANA",
    "district": "MOGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500054,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500055,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500056,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500057,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500058,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500059,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500060,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500061,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500062,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500063,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500064,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500065,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500066,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500067,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500068,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500069,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500070,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500071,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500072,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500073,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500074,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500075,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500076,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500077,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500078,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500079,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500080,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500081,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500082,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500083,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500084,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500085,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500086,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500087,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500088,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500089,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500090,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500091,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500092,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500093,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500094,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500095,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500096,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500097,
    "state": "TELANGANA",
    "district": "MEERPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500098,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500100,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500101,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500108,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500195,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500409,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500609,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500873,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501203,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501218,
    "state": "TELANGANA",
    "district": "SHAMSHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501301,
    "state": "TELANGANA",
    "district": "GHATKESAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501359,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501401,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501403,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501505,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501506,
    "state": "TELANGANA",
    "district": "IBRAHIMPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501510,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501511,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501512,
    "state": "TELANGANA",
    "district": "HAYATNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502001,
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502005,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502032,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502101,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502103,
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502205,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502220,
    "state": "TELANGANA",
    "district": "ZAHEERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502246,
    "state": "TELANGANA",
    "district": "ZAHEERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502279,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502291,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502295,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502305,
    "state": "TELANGANA",
    "district": "PATANCHERU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502307,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502319,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502324,
    "state": "TELANGANA",
    "district": "PATANCHERU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502325,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502329,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502336,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502345,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503001,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503002,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503003,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503004,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503224,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503501,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504001,
    "state": "TELANGANA",
    "district": "ADILABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504002,
    "state": "TELANGANA",
    "district": "ADILABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504208,
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504209,
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505001,
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505002,
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505185,
    "state": "TELANGANA",
    "district": "SULTHANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505188,
    "state": "TELANGANA",
    "district": "CENTENARY COLONY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505208,
    "state": "TELANGANA",
    "district": "GODAVARI KHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505209,
    "state": "TELANGANA",
    "district": "GODAVARI KHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505210,
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505212,
    "state": "TELANGANA",
    "district": "GODAVARI KHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505214,
    "state": "TELANGANA",
    "district": "GODAVARI KHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505215,
    "state": "TELANGANA",
    "district": "RAMAGUNDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505301,
    "state": "TELANGANA",
    "district": "SIRCILLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505327,
    "state": "TELANGANA",
    "district": "JAGTIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505425,
    "state": "ANDHRA PRADESH",
    "district": "DHARMAPURI - AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505455,
    "state": "TELANGANA",
    "district": "JAGTIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506001,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506002,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506003,
    "state": "TELANGANA",
    "district": "HANUMAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506004,
    "state": "TELANGANA",
    "district": "HANUMAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506008,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506009,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506011,
    "state": "TELANGANA",
    "district": "HANUMAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506101,
    "state": "ANDHRA PRADESH",
    "district": "MAHABUBABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506112,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506381,
    "state": "ANDHRA PRADESH",
    "district": "MAHABUBABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507001,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507002,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507003,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507101,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507102,
    "state": "ANDHRA PRADESH",
    "district": "KOTHAGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507111,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507115,
    "state": "ANDHRA PRADESH",
    "district": "PALONCHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507116,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507117,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507123,
    "state": "ANDHRA PRADESH",
    "district": "YELLANDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507125,
    "state": "ANDHRA PRADESH",
    "district": "KOTHAGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507128,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507154,
    "state": "ANDHRA PRADESH",
    "district": "PALONCHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507160,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507165,
    "state": "ANDHRA PRADESH",
    "district": "WYRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507203,
    "state": "ANDHRA PRADESH",
    "district": "MADHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507209,
    "state": "ANDHRA PRADESH",
    "district": "KALLURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507301,
    "state": "TELANGANA",
    "district": "ASWARAOPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507303,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508001,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508114,
    "state": "ANDHRA PRADESH",
    "district": "CHITYAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508204,
    "state": "ANDHRA PRADESH",
    "district": "HUZURNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508206,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508207,
    "state": "ANDHRA PRADESH",
    "district": "MIRYALGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508211,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508213,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508223,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508233,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508254,
    "state": "ANDHRA PRADESH",
    "district": "NARKETPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509001,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509125,
    "state": "ANDHRA PRADESH",
    "district": "GADWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509153,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509202,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509203,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509204,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509208,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509209,
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509210,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509216,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509223,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509228,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509301,
    "state": "TELANGANA",
    "district": "JEDCHERLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509324,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509338,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 510510,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 512501,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 512503,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515001,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515002,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515003,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515004,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515005,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515110,
    "state": "ANDHRA PRADESH",
    "district": "PENUKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515134,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515201,
    "state": "ANDHRA PRADESH",
    "district": "HINDUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515202,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515211,
    "state": "ANDHRA PRADESH",
    "district": "HINDUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515231,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515301,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515401,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515402,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515411,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515422,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515591,
    "state": "ANDHRA PRADESH",
    "district": "KADIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515592,
    "state": "ANDHRA PRADESH",
    "district": "KADIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515601,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515671,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515672,
    "state": "ANDHRA PRADESH",
    "district": "DHARMAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515731,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515761,
    "state": "ANDHRA PRADESH",
    "district": "KALYANDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515801,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515802,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515803,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515804,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515812,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515865,
    "state": "ANDHRA PRADESH",
    "district": "RAYADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516001,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516002,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516003,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516004,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516101,
    "state": "ANDHRA PRADESH",
    "district": "KODUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516115,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516172,
    "state": "ANDHRA PRADESH",
    "district": "MYDUKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516227,
    "state": "ANDHRA PRADESH",
    "district": "BADVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516267,
    "state": "ANDHRA PRADESH",
    "district": "GALIVEEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516269,
    "state": "ANDHRA PRADESH",
    "district": "RAYACHOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516297,
    "state": "ANDHRA PRADESH",
    "district": "GALIVEEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516309,
    "state": "ANDHRA PRADESH",
    "district": "YERRAGUNTLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516329,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516360,
    "state": "ANDHRA PRADESH",
    "district": "PRODDATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516390,
    "state": "ANDHRA PRADESH",
    "district": "PULIVENDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516434,
    "state": "ANDHRA PRADESH",
    "district": "JAMMALAMADAGU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517001,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517002,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517003,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517004,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517102,
    "state": "ANDHRA PRADESH",
    "district": "A.RANGAMPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517112,
    "state": "ANDHRA PRADESH",
    "district": "PAKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517127,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517214,
    "state": "ANDHRA PRADESH",
    "district": "PILER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517234,
    "state": "ANDHRA PRADESH",
    "district": "KALKIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517247,
    "state": "ANDHRA PRADESH",
    "district": "PUNGANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517319,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517325,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517327,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517352,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517370,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517390,
    "state": "ANDHRA PRADESH",
    "district": "MULAKALACHERUVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517408,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517416,
    "state": "ANDHRA PRADESH",
    "district": "BANGARUPALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517419,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517424,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517425,
    "state": "ANDHRA PRADESH",
    "district": "KUPPAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517501,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517502,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517503,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517505,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517506,
    "state": "ANDHRA PRADESH",
    "district": "RENIGUNTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517507,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517520,
    "state": "ANDHRA PRADESH",
    "district": "RENIGUNTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517526,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517541,
    "state": "ANDHRA PRADESH",
    "district": "SATYAVEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517583,
    "state": "ANDHRA PRADESH",
    "district": "PUTTUR -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517588,
    "state": "ANDHRA PRADESH",
    "district": "SATYAVEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517590,
    "state": "ANDHRA PRADESH",
    "district": "NAGARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517619,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517640,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517644,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517646,
    "state": "ANDHRA PRADESH",
    "district": "SATYAVEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518001,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518002,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518003,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518004,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518005,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518006,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518007,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518124,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518134,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518222,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518301,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518302,
    "state": "ANDHRA PRADESH",
    "district": "ADONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518360,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518401,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518422,
    "state": "ANDHRA PRADESH",
    "district": "ATAMAKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518464,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518501,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518502,
    "state": "ANDHRA PRADESH",
    "district": "NANDYAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518503,
    "state": "ANDHRA PRADESH",
    "district": "NANDYAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518508,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518533,
    "state": "ANDHRA PRADESH",
    "district": "VELUGODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518543,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520001,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520002,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520003,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520004,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520006,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520007,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520008,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520009,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520010,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520011,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520012,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520013,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520014,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520015,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520016,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520307,
    "state": "TELANGANA",
    "district": "ISNAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521001,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521002,
    "state": "ANDHRA PRADESH",
    "district": "MACHILIPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521101,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521102,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521103,
    "state": "ANDHRA PRADESH",
    "district": "GANNAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521104,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521105,
    "state": "ANDHRA PRADESH",
    "district": "HANUMAN JUNCTION",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521107,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521108,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521110,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521120,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521121,
    "state": "ANDHRA PRADESH",
    "district": "AVANIGADDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521126,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521134,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521137,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521139,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521151,
    "state": "ANDHRA PRADESH",
    "district": "KANKIPADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521157,
    "state": "ANDHRA PRADESH",
    "district": "PAMARRU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521165,
    "state": "ANDHRA PRADESH",
    "district": "VUYYUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521169,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521175,
    "state": "ANDHRA PRADESH",
    "district": "JAGGHAIAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521178,
    "state": "ANDHRA PRADESH",
    "district": "CHILLAKALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521180,
    "state": "ANDHRA PRADESH",
    "district": "KANCHIKACHERLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521185,
    "state": "ANDHRA PRADESH",
    "district": "NANDIGAMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521190,
    "state": "ANDHRA PRADESH",
    "district": "PENUGANCHIPROLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521201,
    "state": "ANDHRA PRADESH",
    "district": "NUZVEEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521212,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521225,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521228,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521230,
    "state": "ANDHRA PRADESH",
    "district": "MYLAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521235,
    "state": "ANDHRA PRADESH",
    "district": "TIRUVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521241,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521301,
    "state": "ANDHRA PRADESH",
    "district": "GUDIWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521324,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521325,
    "state": "ANDHRA PRADESH",
    "district": "MUDINEPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521333,
    "state": "ANDHRA PRADESH",
    "district": "KAIKALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521356,
    "state": "ANDHRA PRADESH",
    "district": "GUDLAVALLERU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521366,
    "state": "ANDHRA PRADESH",
    "district": "MACHILIPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521456,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522001,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522002,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522003,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522004,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522005,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522006,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522007,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522009,
    "state": "ANDHRA PRADESH",
    "district": "PERECHERLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522017,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522020,
    "state": "ANDHRA PRADESH",
    "district": "AMARAVATHI -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522034,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522101,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522102,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522111,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522124,
    "state": "ANDHRA PRADESH",
    "district": "PONNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522201,
    "state": "ANDHRA PRADESH",
    "district": "TENALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522202,
    "state": "ANDHRA PRADESH",
    "district": "TENALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522212,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522213,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522233,
    "state": "ANDHRA PRADESH",
    "district": "MARTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522235,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522237,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522265,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522309,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522330,
    "state": "ANDHRA PRADESH",
    "district": "DUGGIRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522403,
    "state": "ANDHRA PRADESH",
    "district": "SATTENPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522413,
    "state": "ANDHRA PRADESH",
    "district": "PIDUGURALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522414,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522415,
    "state": "ANDHRA PRADESH",
    "district": "GURAZALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522421,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522426,
    "state": "ANDHRA PRADESH",
    "district": "MACHERLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522501,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522502,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522503,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522509,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522510,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522601,
    "state": "ANDHRA PRADESH",
    "district": "NARASARAOPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522602,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522616,
    "state": "ANDHRA PRADESH",
    "district": "CHILAKALURIPETA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522647,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523001,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523002,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523101,
    "state": "ANDHRA PRADESH",
    "district": "SINGARAYAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523105,
    "state": "ANDHRA PRADESH",
    "district": "KANDUKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523108,
    "state": "ANDHRA PRADESH",
    "district": "PAMURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523155,
    "state": "ANDHRA PRADESH",
    "district": "CHIRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523156,
    "state": "ANDHRA PRADESH",
    "district": "CHIRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523157,
    "state": "ANDHRA PRADESH",
    "district": "CHIRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523165,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523166,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523167,
    "state": "ANDHRA PRADESH",
    "district": "INKOLLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523169,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523187,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523201,
    "state": "ANDHRA PRADESH",
    "district": "ADDANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523211,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523225,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523226,
    "state": "ANDHRA PRADESH",
    "district": "CHIMAKURTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523230,
    "state": "ANDHRA PRADESH",
    "district": "KANIGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523240,
    "state": "ANDHRA PRADESH",
    "district": "PODILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523247,
    "state": "ANDHRA PRADESH",
    "district": "DARSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523254,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523262,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523274,
    "state": "ANDHRA PRADESH",
    "district": "TANGUTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523301,
    "state": "ANDHRA PRADESH",
    "district": "MARTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523305,
    "state": "ANDHRA PRADESH",
    "district": "DARSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523316,
    "state": "ANDHRA PRADESH",
    "district": "MARKAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523325,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523333,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523357,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524001,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524002,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524003,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524004,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524005,
    "state": "ANDHRA PRADESH",
    "district": "KOVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524101,
    "state": "ANDHRA PRADESH",
    "district": "GUDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524102,
    "state": "ANDHRA PRADESH",
    "district": "GUDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524121,
    "state": "ANDHRA PRADESH",
    "district": "SULLURPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524126,
    "state": "ANDHRA PRADESH",
    "district": "NAIDUPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524127,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524132,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524137,
    "state": "ANDHRA PRADESH",
    "district": "KOVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524201,
    "state": "ANDHRA PRADESH",
    "district": "KAVALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524202,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524228,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524305,
    "state": "ANDHRA PRADESH",
    "district": "BUCHIREDDYPALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524314,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524319,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524320,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524322,
    "state": "ANDHRA PRADESH",
    "district": "ATAMAKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524345,
    "state": "ANDHRA PRADESH",
    "district": "PODALKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524366,
    "state": "ANDHRA PRADESH",
    "district": "ALLURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524401,
    "state": "ANDHRA PRADESH",
    "district": "TADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524405,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524411,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524421,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530001,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530002,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530003,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530004,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530007,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530008,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530009,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530011,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530012,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530013,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530014,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530015,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530016,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530017,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530018,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530020,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530021,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530022,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530023,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530024,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530026,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530027,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530029,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530031,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530032,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530035,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530040,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530041,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530043,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530044,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530045,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530046,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530047,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530048,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530049,
    "state": "ANDHRA PRADESH",
    "district": "GAJUWAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530051,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530052,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531001,
    "state": "ANDHRA PRADESH",
    "district": "ANAKAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531002,
    "state": "ANDHRA PRADESH",
    "district": "ANAKAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531011,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531019,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531020,
    "state": "ANDHRA PRADESH",
    "district": "PARAVADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531021,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531035,
    "state": "ANDHRA PRADESH",
    "district": "ANAKAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531036,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531055,
    "state": "ANDHRA PRADESH",
    "district": "YELLAMANCHILLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531081,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531116,
    "state": "ANDHRA PRADESH",
    "district": "NARSIPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532001,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532002,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532003,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532004,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532005,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532127,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532168,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532185,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532195,
    "state": "ANDHRA PRADESH",
    "district": "KOTABOMMALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532201,
    "state": "ANDHRA PRADESH",
    "district": "TEKKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532221,
    "state": "ANDHRA PRADESH",
    "district": "PALASA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532222,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532284,
    "state": "ANDHRA PRADESH",
    "district": "SOMPETA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532312,
    "state": "ANDHRA PRADESH",
    "district": "ICHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532407,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532409,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532421,
    "state": "ANDHRA PRADESH",
    "district": "NARASANNAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532440,
    "state": "ANDHRA PRADESH",
    "district": "PALAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533001,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533002,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533003,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533004,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533005,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533006,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533007,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533008,
    "state": "ANDHRA PRADESH",
    "district": "MANDAPETA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533016,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533101,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533102,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533103,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533104,
    "state": "ANDHRA PRADESH",
    "district": "DEVARAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533105,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533106,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533107,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533124,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533125,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533126,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533201,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533214,
    "state": "ANDHRA PRADESH",
    "district": "AMBAJIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533216,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533223,
    "state": "ANDHRA PRADESH",
    "district": "KOTHAPETA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533233,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533238,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533242,
    "state": "ANDHRA PRADESH",
    "district": "RAZOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533249,
    "state": "ANDHRA PRADESH",
    "district": "TATIPAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533255,
    "state": "ANDHRA PRADESH",
    "district": "RAMACHANDRAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533294,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533308,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533341,
    "state": "ANDHRA PRADESH",
    "district": "DWARAPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533342,
    "state": "ANDHRA PRADESH",
    "district": "ANAPARTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533343,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533401,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533431,
    "state": "ANDHRA PRADESH",
    "district": "KIRLAMPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533435,
    "state": "ANDHRA PRADESH",
    "district": "PEDDAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533437,
    "state": "ANDHRA PRADESH",
    "district": "PEDDAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533440,
    "state": "ANDHRA PRADESH",
    "district": "SAMALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533444,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533445,
    "state": "ANDHRA PRADESH",
    "district": "PITHAMPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533450,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533464,
    "state": "ANDHRA PRADESH",
    "district": "YANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533577,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534001,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534002,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534003,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534005,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534006,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534007,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534101,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534102,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534123,
    "state": "ANDHRA PRADESH",
    "district": "ACHANTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534134,
    "state": "ANDHRA PRADESH",
    "district": "ATTLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534198,
    "state": "ANDHRA PRADESH",
    "district": "GANAPAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534201,
    "state": "ANDHRA PRADESH",
    "district": "BHIMAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534202,
    "state": "ANDHRA PRADESH",
    "district": "BHIMAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534203,
    "state": "ANDHRA PRADESH",
    "district": "BHIMAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534204,
    "state": "ANDHRA PRADESH",
    "district": "BHIMAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534210,
    "state": "ANDHRA PRADESH",
    "district": "PALAKODERU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534211,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534212,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534213,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534214,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534215,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534235,
    "state": "ANDHRA PRADESH",
    "district": "AKIVEEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534260,
    "state": "ANDHRA PRADESH",
    "district": "PALAKOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534275,
    "state": "ANDHRA PRADESH",
    "district": "NARASAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534281,
    "state": "ANDHRA PRADESH",
    "district": "MOGALTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534301,
    "state": "ANDHRA PRADESH",
    "district": "NIDADAVOLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534312,
    "state": "ANDHRA PRADESH",
    "district": "KOYALAGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534313,
    "state": "ANDHRA PRADESH",
    "district": "DEVARAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534316,
    "state": "ANDHRA PRADESH",
    "district": "KOYALAGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534320,
    "state": "ANDHRA PRADESH",
    "district": "PENUGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534341,
    "state": "ANDHRA PRADESH",
    "district": "TALLAPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534342,
    "state": "ANDHRA PRADESH",
    "district": "CHAGALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534350,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534406,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534425,
    "state": "ANDHRA PRADESH",
    "district": "BHIMADOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534447,
    "state": "ANDHRA PRADESH",
    "district": "JANGAREDDYGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534460,
    "state": "ANDHRA PRADESH",
    "district": "CHINTALAPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535001,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535002,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535003,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535004,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535101,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535128,
    "state": "ANDHRA PRADESH",
    "district": "CHEEPURUPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535145,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535183,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535270,
    "state": "ANDHRA PRADESH",
    "district": "GAJAPATHINAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535501,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535558,
    "state": "ANDHRA PRADESH",
    "district": "BOBBILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535591,
    "state": "ANDHRA PRADESH",
    "district": "SALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 538101,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560001,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560002,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560003,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560004,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560005,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560006,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560007,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560008,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560009,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560010,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560011,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560012,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560013,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560014,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560015,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560016,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560017,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560018,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560019,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560020,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560021,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560022,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560023,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560024,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560025,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560026,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560027,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560028,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560029,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560030,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560031,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560032,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560033,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560034,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560035,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560036,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560037,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560038,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560039,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560040,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560041,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560042,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560043,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560044,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560045,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560046,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560047,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560048,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560049,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560050,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560051,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560052,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560053,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560054,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560055,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560056,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560057,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560058,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560059,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560060,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560061,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560062,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560063,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560064,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560065,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560066,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560067,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560068,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560069,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560070,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560071,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560072,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560073,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560074,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560075,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560076,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560077,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560078,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560079,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560080,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560081,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560082,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560083,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560084,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560085,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560086,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560087,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560088,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560089,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560090,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560091,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560092,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560093,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560094,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560095,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560096,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560097,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560098,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560099,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560100,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560101,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560102,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560103,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560104,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560105,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560106,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560107,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560108,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560109,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560110,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560112,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560114,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560122,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560149,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560204,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560300,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561202,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561203,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561207,
    "state": "KARNATAKA",
    "district": "BAGEPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561208,
    "state": "KARNATAKA",
    "district": "CHICKBALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561213,
    "state": "KARNATAKA",
    "district": "CHICKBALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561230,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562101,
    "state": "KARNATAKA",
    "district": "CHICKBALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562105,
    "state": "KARNATAKA",
    "district": "SIDLAGATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562106,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562107,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562109,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562110,
    "state": "KARNATAKA",
    "district": "DEVANAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562111,
    "state": "KARNATAKA",
    "district": "NELAMANGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562112,
    "state": "KARNATAKA",
    "district": "KANAKAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562114,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562117,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562119,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562123,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562125,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562129,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562130,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562131,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562132,
    "state": "KARNATAKA",
    "district": "NELAMANGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562135,
    "state": "KARNATAKA",
    "district": "BANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562145,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562149,
    "state": "KARNATAKA",
    "district": "DEVANAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562152,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562157,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562158,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562159,
    "state": "KARNATAKA",
    "district": "RAMANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562161,
    "state": "KARNATAKA",
    "district": "CHANNAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562162,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562163,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563101,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563102,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563103,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563114,
    "state": "KARNATAKA",
    "district": "BANGARPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563115,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563120,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563122,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563125,
    "state": "KARNATAKA",
    "district": "CHINTAMANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563130,
    "state": "KARNATAKA",
    "district": "MALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563131,
    "state": "KARNATAKA",
    "district": "MULBAGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563133,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563135,
    "state": "KARNATAKA",
    "district": "KOLAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563157,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570001,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570002,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570003,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570004,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570005,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570006,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570007,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570008,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570009,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570010,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570011,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570012,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570014,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570015,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570016,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570017,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570018,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570019,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570020,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570021,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570022,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570023,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570024,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570025,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570026,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570027,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570028,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570029,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570030,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571101,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571105,
    "state": "KARNATAKA",
    "district": "HUNSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571111,
    "state": "KARNATAKA",
    "district": "GUNDLUPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571114,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571124,
    "state": "KARNATAKA",
    "district": "T NARASIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571130,
    "state": "KARNATAKA",
    "district": "YELWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571232,
    "state": "KARNATAKA",
    "district": "KUSHALNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571234,
    "state": "KARNATAKA",
    "district": "KUSHALNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571236,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571301,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571302,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571311,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571313,
    "state": "KARNATAKA",
    "district": "CHAMRAJNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571401,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571402,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571403,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571404,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571426,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571428,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571429,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571430,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571432,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571434,
    "state": "KARNATAKA",
    "district": "SRIRANGAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571438,
    "state": "KARNATAKA",
    "district": "SRIRANGAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571440,
    "state": "KARNATAKA",
    "district": "KOLLEGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571441,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571455,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571511,
    "state": "KARNATAKA",
    "district": "RAMANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571602,
    "state": "KARNATAKA",
    "district": "K.R.NAGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572101,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572102,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572103,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572104,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572105,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572106,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572107,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572111,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572120,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572129,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572130,
    "state": "KARNATAKA",
    "district": "KUNIGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572132,
    "state": "KARNATAKA",
    "district": "MADHUGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572137,
    "state": "KARNATAKA",
    "district": "SIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572138,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572142,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572143,
    "state": "KARNATAKA",
    "district": "HIRIYUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572168,
    "state": "KARNATAKA",
    "district": "NELAMANGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572201,
    "state": "KARNATAKA",
    "district": "TIPTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572202,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572214,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572216,
    "state": "KARNATAKA",
    "district": "GUBBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572218,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573103,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573116,
    "state": "KARNATAKA",
    "district": "CHANNARAYAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573121,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573134,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573201,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573211,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574104,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574105,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574106,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574108,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574110,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574111,
    "state": "KARNATAKA",
    "district": "PADUBIDRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574116,
    "state": "KARNATAKA",
    "district": "SHIRVA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574117,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574118,
    "state": "KARNATAKA",
    "district": "KATAPADI (KA)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574129,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574142,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574144,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574145,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574146,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574149,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574150,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574151,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574154,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574157,
    "state": "KARNATAKA",
    "district": "SURATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574160,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574164,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574170,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574199,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574201,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574202,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574203,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574211,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574214,
    "state": "KARNATAKA",
    "district": "BELTHANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574216,
    "state": "KARNATAKA",
    "district": "BELTHANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574219,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574227,
    "state": "KARNATAKA",
    "district": "MOODABIDRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574231,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574235,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574237,
    "state": "KARNATAKA",
    "district": "SULLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574239,
    "state": "KARNATAKA",
    "district": "SULLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574240,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574243,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574327,
    "state": "KARNATAKA",
    "district": "SULLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574339,
    "state": "KARNATAKA",
    "district": "SULLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575001,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575002,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575003,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575004,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575005,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575006,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575007,
    "state": "KARNATAKA",
    "district": "CHAMRAJNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575008,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575010,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575011,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575013,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575014,
    "state": "KARNATAKA",
    "district": "SURATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575015,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575017,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575018,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575019,
    "state": "KARNATAKA",
    "district": "SURATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575020,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575022,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575023,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575025,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575026,
    "state": "KARNATAKA",
    "district": "SURATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575028,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575030,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575219,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576101,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576102,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576103,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576104,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576105,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576106,
    "state": "KARNATAKA",
    "district": "MANIPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576112,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576115,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576118,
    "state": "KARNATAKA",
    "district": "MALPE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576119,
    "state": "KARNATAKA",
    "district": "MANIPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576122,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576125,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576143,
    "state": "KARNATAKA",
    "district": "MALPE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576201,
    "state": "KARNATAKA",
    "district": "KUNDAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576210,
    "state": "KARNATAKA",
    "district": "BRAHMAVAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576213,
    "state": "KARNATAKA",
    "district": "BRAHMAVAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576214,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576221,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576222,
    "state": "KARNATAKA",
    "district": "KUNDAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576228,
    "state": "KARNATAKA",
    "district": "BHATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576232,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576244,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576257,
    "state": "KARNATAKA",
    "district": "KUNDAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577001,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577002,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577003,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577004,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577005,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577006,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577101,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577102,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577111,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577116,
    "state": "KARNATAKA",
    "district": "BIRUR KA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577126,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577132,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577134,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577135,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577139,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577201,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577202,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577203,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577204,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577205,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577213,
    "state": "KARNATAKA",
    "district": "CHANNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577217,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577222,
    "state": "KARNATAKA",
    "district": "BHADRAVATHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577223,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577228,
    "state": "KARNATAKA",
    "district": "TARIKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577230,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577301,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577302,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577303,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577401,
    "state": "KARNATAKA",
    "district": "SAGAR(KA)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577412,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577413,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577418,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577422,
    "state": "KARNATAKA",
    "district": "THIRTHAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577427,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577428,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577429,
    "state": "KARNATAKA",
    "district": "SORAB",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577430,
    "state": "KARNATAKA",
    "district": "SAGAR(KA)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577432,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577501,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577502,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577522,
    "state": "KARNATAKA",
    "district": "CHALLAKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577526,
    "state": "KARNATAKA",
    "district": "HOLALKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577527,
    "state": "KARNATAKA",
    "district": "HOSADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577528,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577530,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577535,
    "state": "KARNATAKA",
    "district": "MOLAKALMURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577540,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577547,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577548,
    "state": "KARNATAKA",
    "district": "KADUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577599,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577601,
    "state": "KARNATAKA",
    "district": "HARIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580001,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580002,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580003,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580004,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580005,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580006,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580007,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580008,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580009,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580011,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580020,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580021,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580022,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580023,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580024,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580025,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580026,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580028,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580029,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580030,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580031,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580032,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580112,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580114,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580118,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581104,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581106,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581107,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581110,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581111,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581113,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581115,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581118,
    "state": "KARNATAKA",
    "district": "SIDDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581145,
    "state": "KARNATAKA",
    "district": "RANEBENNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581196,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581202,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581204,
    "state": "KARNATAKA",
    "district": "KALAGHATAGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581205,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581206,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581301,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581302,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581303,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581304,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581305,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581306,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581307,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581314,
    "state": "KARNATAKA",
    "district": "ANKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581316,
    "state": "KARNATAKA",
    "district": "ANKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581317,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581320,
    "state": "KARNATAKA",
    "district": "BHATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581321,
    "state": "KARNATAKA",
    "district": "ANKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581324,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581325,
    "state": "KARNATAKA",
    "district": "DANDELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581326,
    "state": "KARNATAKA",
    "district": "GOKARN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581329,
    "state": "KARNATAKA",
    "district": "HALIYAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581331,
    "state": "KARNATAKA",
    "district": "SIDDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581334,
    "state": "KARNATAKA",
    "district": "HONNAVARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581343,
    "state": "KARNATAKA",
    "district": "KUMTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581347,
    "state": "KARNATAKA",
    "district": "YELLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581349,
    "state": "KARNATAKA",
    "district": "MUNDGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581350,
    "state": "KARNATAKA",
    "district": "MURUDESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581352,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581355,
    "state": "KARNATAKA",
    "district": "SIDDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581357,
    "state": "KARNATAKA",
    "district": "ANKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581359,
    "state": "KARNATAKA",
    "district": "YELLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581362,
    "state": "KARNATAKA",
    "district": "KUMTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581400,
    "state": "KARNATAKA",
    "district": "MALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581401,
    "state": "KARNATAKA",
    "district": "SIRSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581402,
    "state": "KARNATAKA",
    "district": "SIRSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581440,
    "state": "KARNATAKA",
    "district": "SIRSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582101,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582102,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582103,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582116,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582118,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582201,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582208,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582209,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583101,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583102,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583103,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583104,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583112,
    "state": "KARNATAKA",
    "district": "DONIMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583115,
    "state": "KARNATAKA",
    "district": "KUDITHINI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583116,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583118,
    "state": "KARNATAKA",
    "district": "DONIMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583119,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583121,
    "state": "KARNATAKA",
    "district": "SIRUGUPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583123,
    "state": "KARNATAKA",
    "district": "THORANAGALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583124,
    "state": "KARNATAKA",
    "district": "DONIMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583125,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583131,
    "state": "KARNATAKA",
    "district": "HARAPANAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583132,
    "state": "KARNATAKA",
    "district": "KAMPLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583134,
    "state": "KARNATAKA",
    "district": "KOTTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583135,
    "state": "KARNATAKA",
    "district": "KUDLIGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583201,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583203,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583212,
    "state": "KARNATAKA",
    "district": "HAGARI BOMMANAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583219,
    "state": "KARNATAKA",
    "district": "HUVINAHADAGALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583222,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583227,
    "state": "KARNATAKA",
    "district": "GANGAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583228,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583229,
    "state": "KARNATAKA",
    "district": "KARATAGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583231,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583233,
    "state": "KARNATAKA",
    "district": "MUNIRABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583234,
    "state": "KARNATAKA",
    "district": "MUNIRABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583236,
    "state": "KARNATAKA",
    "district": "YELBURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583275,
    "state": "KARNATAKA",
    "district": "THORANAGALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583277,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583279,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584101,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584102,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584103,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584111,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584115,
    "state": "KARNATAKA",
    "district": "LINGASUGUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584121,
    "state": "KARNATAKA",
    "district": "KUSHTAGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584122,
    "state": "KARNATAKA",
    "district": "LINGASUGUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584123,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584124,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584128,
    "state": "KARNATAKA",
    "district": "SINDHANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584129,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584131,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584166,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584170,
    "state": "KARNATAKA",
    "district": "SHAKTINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585101,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585102,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585103,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585104,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585105,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585106,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585201,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585202,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585211,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585212,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585222,
    "state": "KARNATAKA",
    "district": "SEDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585223,
    "state": "KARNATAKA",
    "district": "SHAHAPUR -KA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585225,
    "state": "KARNATAKA",
    "district": "WADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585227,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585228,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585229,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585292,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585301,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585302,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585310,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585312,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585327,
    "state": "KARNATAKA",
    "district": "BASAVAKALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585330,
    "state": "KARNATAKA",
    "district": "HUMNABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585401,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585402,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585403,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586101,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586102,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586103,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586104,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586109,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586121,
    "state": "KARNATAKA",
    "district": "BASAVAN BAGEWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586124,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586206,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586207,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586211,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586212,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586213,
    "state": "KARNATAKA",
    "district": "BASAVAN BAGEWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586214,
    "state": "KARNATAKA",
    "district": "TALIKOTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587101,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587102,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587103,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587111,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587116,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587118,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587122,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587124,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587125,
    "state": "KARNATAKA",
    "district": "ILKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587201,
    "state": "KARNATAKA",
    "district": "BADAMI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587203,
    "state": "KARNATAKA",
    "district": "GULEGUDD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587205,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587301,
    "state": "KARNATAKA",
    "district": "JAMKHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587304,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587305,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587310,
    "state": "KARNATAKA",
    "district": "BANHATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587311,
    "state": "KARNATAKA",
    "district": "BANHATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587313,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587314,
    "state": "KARNATAKA",
    "district": "BANHATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587330,
    "state": "KARNATAKA",
    "district": "JAMKHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 589301,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590001,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590002,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590003,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590004,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590005,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590006,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590007,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590008,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590009,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590010,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590011,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590014,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590016,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590018,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590019,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591001,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591002,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591003,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591004,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591102,
    "state": "KARNATAKA",
    "district": "BAILAHONGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591113,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591115,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591123,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591136,
    "state": "KARNATAKA",
    "district": "GOKAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591201,
    "state": "KARNATAKA",
    "district": "CHIKKODI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591213,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591220,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591237,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591302,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591304,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591306,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591307,
    "state": "KARNATAKA",
    "district": "GOKAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591309,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591312,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591313,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591317,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600001,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600002,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600003,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600004,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600005,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600006,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600007,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600008,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600009,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600010,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600011,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600012,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600013,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600014,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600015,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600016,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600017,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600018,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600019,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600020,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600021,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600022,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600023,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600024,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600025,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600026,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600027,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600028,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600029,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600030,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600031,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600032,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600033,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600034,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600035,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600036,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600037,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600038,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600039,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600040,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600041,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600042,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600043,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600044,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600045,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600046,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600047,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600048,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600049,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600050,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600051,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600052,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600053,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600054,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600055,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600056,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600057,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600058,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600059,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600060,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600061,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600062,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600063,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600064,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600065,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600066,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600067,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600068,
    "state": "TAMIL NADU",
    "district": "MANALI -TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600069,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600070,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600071,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600072,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600073,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600074,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600075,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600076,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600077,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600078,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600079,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600080,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600081,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600082,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600083,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600084,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600085,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600086,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600087,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600088,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600089,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600090,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600091,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600092,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600093,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600094,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600095,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600096,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600097,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600098,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600099,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600100,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600101,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600102,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600103,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600104,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600105,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600106,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600107,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600108,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600109,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600110,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600111,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600112,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600113,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600114,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600115,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600116,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600117,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600118,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600119,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600120,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600122,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600123,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600124,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600125,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600126,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600127,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600128,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600129,
    "state": "ANDHRA PRADESH",
    "district": "PACHIKAPALLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600130,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601201,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601203,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601204,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601205,
    "state": "TAMIL NADU",
    "district": "SRIPERUMPUDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601206,
    "state": "TAMIL NADU",
    "district": "GUMMIDIPONDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601301,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601302,
    "state": "TAMIL NADU",
    "district": "MEDAVAKKAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602001,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602002,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602003,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602004,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602024,
    "state": "TAMIL NADU",
    "district": "AVADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602025,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602026,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602101,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602103,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602105,
    "state": "TAMIL NADU",
    "district": "SRIPERUMPUDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602106,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602107,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602117,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603001,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603002,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603102,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603103,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603109,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603110,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603111,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603112,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603201,
    "state": "TAMIL NADU",
    "district": "GUDUVANCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603202,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603203,
    "state": "TAMIL NADU",
    "district": "KELAMBAKKAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603204,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603209,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603210,
    "state": "TAMIL NADU",
    "district": "GUDUVANCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603211,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603308,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603603,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604001,
    "state": "TAMIL NADU",
    "district": "TINDIVANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604002,
    "state": "TAMIL NADU",
    "district": "TINDIVANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604202,
    "state": "TAMIL NADU",
    "district": "GINGEE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604302,
    "state": "TAMIL NADU",
    "district": "TINDIVANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604303,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604407,
    "state": "TAMIL NADU",
    "district": "CHEYYAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604408,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605001,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605002,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605003,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605004,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605005,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605006,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605007,
    "state": "TAMIL NADU",
    "district": "PALLIADY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605008,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605009,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605010,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605011,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605012,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605013,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605014,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605101,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605102,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605104,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605106,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605107,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605110,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605111,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605401,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605502,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605601,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605602,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605606,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605652,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605757,
    "state": "TAMIL NADU",
    "district": "TIRUKOILUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606001,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606106,
    "state": "TAMIL NADU",
    "district": "TITTAGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606107,
    "state": "TAMIL NADU",
    "district": "ULUNDURPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606202,
    "state": "TAMIL NADU",
    "district": "KALLAKURUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606401,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606402,
    "state": "TAMIL NADU",
    "district": "KALLAKURUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606601,
    "state": "TAMIL NADU",
    "district": "THIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606602,
    "state": "TAMIL NADU",
    "district": "THIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606603,
    "state": "TAMIL NADU",
    "district": "THIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606604,
    "state": "TAMIL NADU",
    "district": "THIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606751,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606803,
    "state": "TAMIL NADU",
    "district": "POLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606905,
    "state": "TAMIL NADU",
    "district": "POLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606906,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607001,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607002,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607003,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607005,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607105,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607106,
    "state": "TAMIL NADU",
    "district": "PANRUTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607303,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607308,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607402,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607801,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607802,
    "state": "TAMIL NADU",
    "district": "NEYVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607803,
    "state": "TAMIL NADU",
    "district": "NEYVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607807,
    "state": "TAMIL NADU",
    "district": "NEYVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608001,
    "state": "TAMIL NADU",
    "district": "CHIDAMBARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608002,
    "state": "TAMIL NADU",
    "district": "CHIDAMBARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608301,
    "state": "TAMIL NADU",
    "district": "KATTUMANNARKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608502,
    "state": "TAMIL NADU",
    "district": "PARANGIPETTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609001,
    "state": "TAMIL NADU",
    "district": "Nagapattinam",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609110,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609118,
    "state": "TAMIL NADU",
    "district": "Nagapattinam",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609305,
    "state": "TAMIL NADU",
    "district": "Nagapattinam",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609602,
    "state": "TAMIL NADU",
    "district": "Karaikal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609607,
    "state": "TAMIL NADU",
    "district": "Karaikal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609801,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610001,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610003,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610004,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610101,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611002,
    "state": "TAMIL NADU",
    "district": "Nagapattinam",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611116,
    "state": "TAMIL NADU",
    "district": "Nagapattinam",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612001,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612002,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612101,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613001,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613002,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613003,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613004,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613005,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613006,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613007,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613008,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613009,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613010,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613204,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613401,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613402,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613403,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614001,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614201,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614211,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614616,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614704,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614713,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614804,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620001,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620002,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620003,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620004,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620005,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620006,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620007,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620008,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620010,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620011,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620012,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620013,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620014,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620015,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620017,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620018,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620019,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620020,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620021,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620022,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620023,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620024,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620026,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620102,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621005,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621010,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621211,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621216,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621220,
    "state": "TAMIL NADU",
    "district": "Perambalur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621306,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621316,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621706,
    "state": "TAMIL NADU",
    "district": "Tiruchirappalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621802,
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622001,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622002,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622003,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622004,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622005,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622101,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622102,
    "state": "TAMIL NADU",
    "district": "Pudukkottai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623525,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623534,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624001,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624002,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624003,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624004,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624005,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624101,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624102,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624202,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624301,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624302,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624601,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624602,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624613,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624615,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624619,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624710,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625001,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625002,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625003,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625004,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625005,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625006,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625007,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625008,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625009,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625010,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625011,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625012,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625014,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625015,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625016,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625017,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625018,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625019,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625020,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625021,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625022,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625023,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625101,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625102,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625107,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625122,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625402,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625513,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625515,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625531,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625532,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626102,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626106,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626111,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626117,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626121,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626123,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626124,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626125,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626126,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626130,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626132,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626189,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626203,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627001,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627002,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627003,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627004,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627005,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627006,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627007,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627008,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627009,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627010,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627011,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627012,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627104,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627106,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627111,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627124,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627352,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627353,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627357,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627358,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627401,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627425,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627757,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627808,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627811,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628001,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628002,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628003,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628004,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628005,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628006,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628008,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628101,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628151,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628203,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628204,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628229,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628501,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628502,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628503,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628902,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629001,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629002,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629003,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629153,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629155,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629157,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629165,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629175,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629177,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629401,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629702,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629703,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629704,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629802,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629803,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630001,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630002,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630003,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630004,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630005,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630211,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630302,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630303,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630561,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630606,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630611,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631001,
    "state": "TAMIL NADU",
    "district": "ARAKKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631002,
    "state": "TAMIL NADU",
    "district": "ARAKKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631102,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631151,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631201,
    "state": "TAMIL NADU",
    "district": "TIRUTTANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631209,
    "state": "TAMIL NADU",
    "district": "TIRUTTANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631211,
    "state": "TAMIL NADU",
    "district": "THANDALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631402,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631501,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631502,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631503,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631551,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631552,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631561,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631604,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631701,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632001,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632002,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632003,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632004,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632006,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632007,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632009,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632012,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632013,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632014,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632106,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632301,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632316,
    "state": "TAMIL NADU",
    "district": "POLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632401,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632402,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632403,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632404,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632405,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632406,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632503,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632504,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632509,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632513,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632602,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635001,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635002,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635103,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635104,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635107,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635109,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635110,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635111,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635112,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635114,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635116,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635117,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635121,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635125,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635126,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635203,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635206,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635207,
    "state": "TAMIL NADU",
    "district": "Krishnagiri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635751,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635802,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635810,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635811,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635812,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635814,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635851,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635901,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636001,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636002,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636003,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636004,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636005,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636006,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636007,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636008,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636009,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636010,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636011,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636012,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636013,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636014,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636015,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636016,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636030,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636102,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636103,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636105,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636106,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636108,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636112,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636113,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636115,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636140,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636141,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636201,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636302,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636307,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636308,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636401,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636402,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636403,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636404,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636451,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636453,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636455,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636457,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636501,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636502,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636601,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636701,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636702,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636703,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636705,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636808,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636810,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636811,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636813,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636903,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636905,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636908,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637001,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637002,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637017,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637101,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637205,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637207,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637209,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637210,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637211,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637214,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637215,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637301,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637302,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637304,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637408,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637501,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637502,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638001,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638002,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638003,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638004,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638005,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638006,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638007,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638008,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638009,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638011,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638012,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638052,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638053,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638056,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638102,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638103,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638106,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638107,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638111,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638112,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638116,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638151,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638182,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638183,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638301,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638315,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638316,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638401,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638402,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638451,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638452,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638453,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638455,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638458,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638459,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638476,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638501,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638656,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638657,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638701,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638751,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638812,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639001,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639002,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639003,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639004,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639005,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639006,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639007,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639008,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639104,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639114,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639117,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639136,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639205,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639207,
    "state": "TAMIL NADU",
    "district": "Karur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 640613,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641001,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641002,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641003,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641004,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641005,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641006,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641007,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641008,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641009,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641010,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641011,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641012,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641013,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641014,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641015,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641016,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641017,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641018,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641019,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641020,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641021,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641022,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641023,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641024,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641025,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641026,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641027,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641028,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641029,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641030,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641031,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641032,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641033,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641034,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641035,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641036,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641037,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641038,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641039,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641041,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641042,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641043,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641044,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641045,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641046,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641047,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641048,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641049,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641050,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641062,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641101,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641103,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641104,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641105,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641107,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641108,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641109,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641110,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641111,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641112,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641113,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641114,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641201,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641301,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641302,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641305,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641401,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641402,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641406,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641407,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641601,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641602,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641603,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641604,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641605,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641606,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641607,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641653,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641654,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641655,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641659,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641666,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641668,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642001,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642002,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642003,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642004,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642102,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642103,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642104,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642109,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642110,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642112,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642114,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642122,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642126,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642128,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642154,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642201,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642202,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642205,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643001,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643002,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643003,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643004,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643005,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643006,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643007,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643101,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643102,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643103,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643104,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643105,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643201,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643202,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643213,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643214,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643215,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643217,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643231,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643232,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643237,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643243,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670001,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670002,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670003,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670004,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670005,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670006,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670007,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670008,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670009,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670010,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670011,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670012,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670013,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670014,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670017,
    "state": "KERALA",
    "district": "TELLICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670018,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670101,
    "state": "KERALA",
    "district": "TELLICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670141,
    "state": "KERALA",
    "district": "TALIPARAMBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670142,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670301,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670303,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670304,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670306,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670307,
    "state": "KERALA",
    "district": "PAYYANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670308,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670309,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670310,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670327,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670331,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670353,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670358,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670501,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670502,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670503,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670504,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670511,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670521,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670561,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670562,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670563,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670571,
    "state": "KERALA",
    "district": "ALAKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670581,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670582,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670591,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670592,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670593,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670594,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670595,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670601,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670602,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670604,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670611,
    "state": "KERALA",
    "district": "MATTANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670612,
    "state": "KERALA",
    "district": "MATTANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670613,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670621,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670622,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670631,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670632,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670633,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670643,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670644,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670645,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670646,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670674,
    "state": "KERALA",
    "district": "KELAKAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670702,
    "state": "KERALA",
    "district": "MATTANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670703,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670721,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670731,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671121,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671122,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671123,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671124,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671310,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671311,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671312,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671313,
    "state": "KERALA",
    "district": "CHERUVATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671314,
    "state": "KERALA",
    "district": "NILESWARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671315,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671316,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671317,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671318,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671319,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671321,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671322,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671323,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671324,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671351,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671531,
    "state": "KERALA",
    "district": "KANHANGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671532,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671533,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671541,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671542,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671551,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673000,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673001,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673002,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673003,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673004,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673005,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673006,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673007,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673008,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673009,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673010,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673011,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673012,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673013,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673014,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673015,
    "state": "KERALA",
    "district": "CHALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673016,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673017,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673018,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673019,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673020,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673021,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673022,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673023,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673024,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673025,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673026,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673027,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673028,
    "state": "KERALA",
    "district": "CHALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673029,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673031,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673032,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673035,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673037,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673051,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673101,
    "state": "KERALA",
    "district": "VATAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673102,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673103,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673104,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673105,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673106,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673121,
    "state": "KERALA",
    "district": "KALPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673122,
    "state": "KERALA",
    "district": "KALPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673123,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673300,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673301,
    "state": "KERALA",
    "district": "NADAKKAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673302,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673303,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673305,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673306,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673307,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673308,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673314,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673315,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673317,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673318,
    "state": "KERALA",
    "district": "MAHE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673319,
    "state": "KERALA",
    "district": "MAHE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673321,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673322,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673323,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673324,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673325,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673326,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673327,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673328,
    "state": "KERALA",
    "district": "NADAKKAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673330,
    "state": "KERALA",
    "district": "NADAKKAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673501,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673502,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673504,
    "state": "KERALA",
    "district": "NADAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673505,
    "state": "KERALA",
    "district": "NADAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673506,
    "state": "KERALA",
    "district": "NADAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673507,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673508,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673509,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673515,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673517,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673519,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673521,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673522,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673523,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673525,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673527,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673529,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673531,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673532,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673533,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673534,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673535,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673541,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673542,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673570,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673571,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673572,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673573,
    "state": "KERALA",
    "district": "THAMARASSERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673574,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673575,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673576,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673577,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673579,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673580,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673581,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673582,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673583,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673584,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673585,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673586,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673587,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673588,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673589,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673591,
    "state": "KERALA",
    "district": "KALPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673592,
    "state": "KERALA",
    "district": "KALPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673593,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673595,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673596,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673600,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673601,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673602,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673603,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673604,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673607,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673611,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673612,
    "state": "KERALA",
    "district": "BALUSSERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673613,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673614,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673616,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673617,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673618,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673619,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673620,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673621,
    "state": "KERALA",
    "district": "KOZHIKODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673622,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673623,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673624,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673631,
    "state": "KERALA",
    "district": "FEROKE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673632,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673633,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673634,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673635,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673636,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673637,
    "state": "KERALA",
    "district": "KONDOTTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673638,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673639,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673640,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673641,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673642,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673643,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673645,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673647,
    "state": "KERALA",
    "district": "KONDOTTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673654,
    "state": "KERALA",
    "district": "FEROKE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673655,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673661,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676101,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676102,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676103,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676104,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676105,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676106,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676107,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676108,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676109,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676121,
    "state": "KERALA",
    "district": "MANJERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676123,
    "state": "KERALA",
    "district": "MANJERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676161,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676301,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676302,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676303,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676304,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676305,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676306,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676307,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676309,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676311,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676312,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676317,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676319,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676320,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676501,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676502,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676503,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676504,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676505,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676506,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676507,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676508,
    "state": "KERALA",
    "district": "TIRURANGADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676509,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676510,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676514,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676517,
    "state": "KERALA",
    "district": "MANJERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676519,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676521,
    "state": "KERALA",
    "district": "PANDIKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676528,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676541,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676551,
    "state": "KERALA",
    "district": "TIRUR - MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676552,
    "state": "KERALA",
    "district": "VALANCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676553,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676561,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678001,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678002,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678003,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678004,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678005,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678006,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678007,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678008,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678009,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678010,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678011,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678012,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678013,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678014,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678015,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678101,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678102,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678103,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678104,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678501,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678502,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678503,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678504,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678506,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678507,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678508,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678531,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678534,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678541,
    "state": "KERALA",
    "district": "ALATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678542,
    "state": "KERALA",
    "district": "ALATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678551,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678552,
    "state": "KERALA",
    "district": "CHITTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678553,
    "state": "KERALA",
    "district": "CHITTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678554,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678556,
    "state": "KERALA",
    "district": "CHITTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678557,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678570,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678571,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678572,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678582,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678583,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678592,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678594,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678596,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678601,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678611,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678612,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678613,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678621,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678622,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678623,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678624,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678631,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678633,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678641,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678642,
    "state": "KERALA",
    "district": "OTTAPALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678651,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678671,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678682,
    "state": "KERALA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678683,
    "state": "KERALA",
    "district": "VADAKKENCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678684,
    "state": "KERALA",
    "district": "ALATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678701,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678702,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678705,
    "state": "KERALA",
    "district": "VADAKKENCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678707,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678731,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678732,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678762,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679101,
    "state": "KERALA",
    "district": "OTTAPALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679102,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679103,
    "state": "KERALA",
    "district": "OTTAPALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679104,
    "state": "KERALA",
    "district": "OTTAPALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679121,
    "state": "KERALA",
    "district": "SHORANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679122,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679123,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679301,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679302,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679303,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679304,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679306,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679307,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679308,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679309,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679313,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679321,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679322,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679323,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679324,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679325,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679326,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679328,
    "state": "KERALA",
    "district": "PANDIKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679329,
    "state": "KERALA",
    "district": "NILAMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679331,
    "state": "KERALA",
    "district": "EDAKKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679332,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679334,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679335,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679336,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679337,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679338,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679342,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679351,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679501,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679502,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679503,
    "state": "KERALA",
    "district": "OTTAPALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679506,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679511,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679513,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679514,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679521,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679522,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679523,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679531,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679532,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679533,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679534,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679535,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679536,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679537,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679538,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679552,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679561,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679562,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679563,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679571,
    "state": "KERALA",
    "district": "VALANCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679573,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679575,
    "state": "KERALA",
    "district": "CHANGARAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679576,
    "state": "KERALA",
    "district": "EDAPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679577,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679579,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679582,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679585,
    "state": "KERALA",
    "district": "CHANGARAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679586,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679590,
    "state": "KERALA",
    "district": "KUTTIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679592,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679594,
    "state": "KERALA",
    "district": "CHANGARAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680001,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680002,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680003,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680004,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680005,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680006,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680007,
    "state": "KERALA",
    "district": "KOORKANCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680008,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680009,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680010,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680011,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680012,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680013,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680014,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680018,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680020,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680021,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680022,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680026,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680027,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680028,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680101,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680102,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680103,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680104,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680106,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680109,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680111,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680121,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680122,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680123,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680125,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680221,
    "state": "KERALA",
    "district": "CHALAKUDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680301,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680302,
    "state": "KERALA",
    "district": "AMBALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680303,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680304,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680305,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680306,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680307,
    "state": "KERALA",
    "district": "CHALAKUDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680308,
    "state": "KERALA",
    "district": "KORATTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680309,
    "state": "KERALA",
    "district": "KORATTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680310,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680311,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680312,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680313,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680314,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680315,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680317,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680322,
    "state": "KERALA",
    "district": "OLLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680323,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680501,
    "state": "KERALA",
    "district": "KECHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680503,
    "state": "KERALA",
    "district": "KECHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680504,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680505,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680506,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680507,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680508,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680509,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680510,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680511,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680512,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680513,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680514,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680515,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680516,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680517,
    "state": "KERALA",
    "district": "KUNNAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680518,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680519,
    "state": "KERALA",
    "district": "KUNNAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680522,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680523,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680541,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680542,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680543,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680545,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680546,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680547,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680549,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680551,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680552,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680553,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680555,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680561,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680562,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680563,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680564,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680565,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680566,
    "state": "KERALA",
    "district": "TRIPRAYAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680567,
    "state": "KERALA",
    "district": "TRIPRAYAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680569,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680571,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680581,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680582,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680583,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680585,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680586,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680587,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680588,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680589,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680590,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680592,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680594,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680596,
    "state": "KERALA",
    "district": "WADAKANCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680597,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680600,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680601,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680602,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680604,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680608,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680609,
    "state": "KERALA",
    "district": "KORATTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680611,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680612,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680613,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680614,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680615,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680616,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680617,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680618,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680619,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680620,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680623,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680631,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680641,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680642,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680651,
    "state": "KERALA",
    "district": "MANNUTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680652,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680653,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680654,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680655,
    "state": "KERALA",
    "district": "MANNUTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680656,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680661,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680662,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680663,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680664,
    "state": "KERALA",
    "district": "KODUNGALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680665,
    "state": "KERALA",
    "district": "KODUNGALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680666,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680667,
    "state": "KERALA",
    "district": "KODUNGALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680668,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680671,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680673,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680681,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680682,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680683,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680684,
    "state": "KERALA",
    "district": "KODAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680685,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680686,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680687,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680688,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680689,
    "state": "KERALA",
    "district": "KODAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680697,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680699,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680701,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680702,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680703,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680711,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680712,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680721,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680724,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680731,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680732,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680733,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680734,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680736,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680741,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680751,
    "state": "KERALA",
    "district": "MANNUTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682000,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682001,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682002,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682003,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682004,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682005,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682006,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682007,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682008,
    "state": "KERALA",
    "district": "KANNAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682009,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682010,
    "state": "KERALA",
    "district": "KANNAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682011,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682012,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682013,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682014,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682015,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682016,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682017,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682018,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682019,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682020,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682021,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682022,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682023,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682024,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682025,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682026,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682027,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682028,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682029,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682030,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682031,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682032,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682033,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682034,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682035,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682036,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682037,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682038,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682039,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682040,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682041,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682042,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682301,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682302,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682303,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682304,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682305,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682306,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682307,
    "state": "KERALA",
    "district": "VENNIKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682308,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682309,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682310,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682311,
    "state": "KERALA",
    "district": "KOLENCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682312,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682313,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682314,
    "state": "KERALA",
    "district": "MULANTHURUTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682315,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682316,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682317,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682319,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682320,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682501,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682502,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682503,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682504,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682505,
    "state": "KERALA",
    "district": "NARAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682506,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682507,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682508,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682509,
    "state": "KERALA",
    "district": "NARAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682511,
    "state": "KERALA",
    "district": "NARAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683001,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683101,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683102,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683103,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683104,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683105,
    "state": "KERALA",
    "district": "VAZHAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683106,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683107,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683108,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683109,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683110,
    "state": "KERALA",
    "district": "EDAYAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683111,
    "state": "KERALA",
    "district": "ATHANI -COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683112,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683302,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683303,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683501,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683502,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683503,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683504,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683511,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683512,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683513,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683514,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683515,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683516,
    "state": "KERALA",
    "district": "KODUNGALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683517,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683518,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683519,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683520,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683522,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683541,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683542,
    "state": "KERALA",
    "district": "PERUMBAVOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683543,
    "state": "KERALA",
    "district": "VAZHAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683544,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683545,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683547,
    "state": "KERALA",
    "district": "VAZHAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683548,
    "state": "KERALA",
    "district": "PERUMBAVOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683549,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683550,
    "state": "KERALA",
    "district": "ANGAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683556,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683561,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683562,
    "state": "KERALA",
    "district": "KOLENCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683563,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683564,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683565,
    "state": "KERALA",
    "district": "KOLENCHERY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683571,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683572,
    "state": "KERALA",
    "district": "ANGAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683573,
    "state": "KERALA",
    "district": "ANGAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683574,
    "state": "KERALA",
    "district": "ANGAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683575,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683576,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683577,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683578,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683579,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683580,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683581,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683585,
    "state": "KERALA",
    "district": "ATHANI -COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683587,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683589,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683591,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683592,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683594,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685501,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685503,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685505,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685507,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685508,
    "state": "KERALA",
    "district": "KATTAPPANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685509,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685511,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685512,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685514,
    "state": "KERALA",
    "district": "ERATTAYAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685515,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685518,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685531,
    "state": "KERALA",
    "district": "KUTTIKANAM - IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685532,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685533,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685551,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685552,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685553,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685554,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685561,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685562,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685563,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685564,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685565,
    "state": "KERALA",
    "district": "MUNNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685566,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685581,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685582,
    "state": "KERALA",
    "district": "THODUPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685584,
    "state": "KERALA",
    "district": "THODUPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685585,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685586,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685587,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685588,
    "state": "KERALA",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685589,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685590,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685595,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685602,
    "state": "KERALA",
    "district": "KARIMBAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685603,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685604,
    "state": "KERALA",
    "district": "MURIKASSERY - IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685605,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685606,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685607,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685608,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685609,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685611,
    "state": "KERALA",
    "district": "MUNNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685612,
    "state": "KERALA",
    "district": "MUNNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685613,
    "state": "KERALA",
    "district": "MUNNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685618,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686001,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686002,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686003,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686004,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686005,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686006,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686007,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686008,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686009,
    "state": "KERALA",
    "district": "PUTHUPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686010,
    "state": "KERALA",
    "district": "PUTHUPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686011,
    "state": "KERALA",
    "district": "PUTHUPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686012,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686013,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686014,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686015,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686016,
    "state": "KERALA",
    "district": "ETTUMANOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686017,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686018,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686019,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686020,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686021,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686022,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686023,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686024,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686025,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686026,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686027,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686028,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686029,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686030,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686031,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686032,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686033,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686034,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686035,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686036,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686037,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686038,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686039,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686040,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686041,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686101,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686102,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686103,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686104,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686105,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686106,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686121,
    "state": "KERALA",
    "district": "ERATTPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686122,
    "state": "KERALA",
    "district": "ERATTPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686141,
    "state": "KERALA",
    "district": "VAIKOM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686143,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686144,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686146,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686307,
    "state": "KERALA",
    "district": "VAIKOM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686501,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686502,
    "state": "KERALA",
    "district": "PAMPADY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686503,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686504,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686506,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686507,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686509,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686510,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686511,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686512,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686513,
    "state": "KERALA",
    "district": "MUNDAKAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686514,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686516,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686518,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686521,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686531,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686532,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686533,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686534,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686535,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686536,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686538,
    "state": "KERALA",
    "district": "THENGANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686539,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686540,
    "state": "KERALA",
    "district": "KARUKACHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686541,
    "state": "KERALA",
    "district": "KARUKACHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686542,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686546,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686547,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686548,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686552,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686553,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686555,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686560,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686561,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686562,
    "state": "KERALA",
    "district": "ETTUMANOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686563,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686564,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686566,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686568,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686572,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686573,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686574,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686575,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686576,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686577,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686578,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686582,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686583,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686601,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686602,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686603,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686604,
    "state": "KERALA",
    "district": "KADUTHURUTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686605,
    "state": "KERALA",
    "district": "THALAYOLAPARAMBU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686606,
    "state": "KERALA",
    "district": "VAIKOM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686607,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686608,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686609,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686610,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686611,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686612,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686613,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686615,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686617,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686630,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686631,
    "state": "KERALA",
    "district": "KOTTIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686632,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686633,
    "state": "KERALA",
    "district": "KURAVILANGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686634,
    "state": "KERALA",
    "district": "UZHAVOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686635,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686636,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686637,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686651,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686652,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686661,
    "state": "KERALA",
    "district": "MUVATTUPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686662,
    "state": "KERALA",
    "district": "KOOTHATTUKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686663,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686664,
    "state": "KERALA",
    "district": "PIRAVAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686665,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686666,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686667,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686668,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686669,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686670,
    "state": "KERALA",
    "district": "VAZHAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686671,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686672,
    "state": "KERALA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686673,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686674,
    "state": "KERALA",
    "district": "VAZHAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686681,
    "state": "KERALA",
    "district": "ERNAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686691,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686692,
    "state": "KERALA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686693,
    "state": "KERALA",
    "district": "NERIAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686702,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686721,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686722,
    "state": "KERALA",
    "district": "MUVATTUPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688001,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688002,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688003,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688004,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688005,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688006,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688007,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688009,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688010,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688011,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688012,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688013,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688014,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688016,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688017,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688020,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688022,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688028,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688029,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688042,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688101,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688503,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688507,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688508,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688509,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688511,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688521,
    "state": "KERALA",
    "district": "KOMALAPURAM - ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688522,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688523,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688524,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688525,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688526,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688527,
    "state": "KERALA",
    "district": "ERAMALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688528,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688529,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688530,
    "state": "KERALA",
    "district": "ARTHUNKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688531,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688532,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688533,
    "state": "KERALA",
    "district": "ERAMALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688534,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688535,
    "state": "KERALA",
    "district": "ERAMALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688536,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688537,
    "state": "KERALA",
    "district": "ERAMALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688538,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688539,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688540,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688541,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688542,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688543,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688544,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688545,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688546,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688547,
    "state": "KERALA",
    "district": "ERAMALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688549,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688550,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688552,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688554,
    "state": "KERALA",
    "district": "ARTHUNKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688555,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688556,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688557,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688559,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688560,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688561,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688562,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688563,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688564,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688565,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688566,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688567,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688581,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688582,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688583,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688585,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688586,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688587,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688625,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688656,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689101,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689102,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689103,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689104,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689105,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689107,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689108,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689109,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689110,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689111,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689112,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689113,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689114,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689115,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689121,
    "state": "KERALA",
    "district": "CHENGANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689122,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689123,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689124,
    "state": "KERALA",
    "district": "CHENGANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689125,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689126,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689501,
    "state": "KERALA",
    "district": "CHENGANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689502,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689503,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689504,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689505,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689506,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689507,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689510,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689511,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689513,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689514,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689515,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689517,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689519,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689520,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689521,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689529,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689531,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689532,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689533,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689541,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689542,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689543,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689544,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689545,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689546,
    "state": "KERALA",
    "district": "KUMBANADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689547,
    "state": "KERALA",
    "district": "KUMBANADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689548,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689550,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689552,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689571,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689573,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689574,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689575,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689576,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689578,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689579,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689580,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689581,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689582,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689583,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689584,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689585,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689586,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689587,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689588,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689589,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689591,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689593,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689595,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689596,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689597,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689598,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689600,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689602,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689603,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689611,
    "state": "KERALA",
    "district": "RANNY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689612,
    "state": "KERALA",
    "district": "RANNY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689613,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689614,
    "state": "KERALA",
    "district": "RANNY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689615,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689620,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689621,
    "state": "KERALA",
    "district": "MANNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689622,
    "state": "KERALA",
    "district": "MANNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689623,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689624,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689625,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689626,
    "state": "KERALA",
    "district": "MANNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689627,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689628,
    "state": "KERALA",
    "district": "MANNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689641,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689642,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689643,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689644,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689645,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689646,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689647,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689648,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689649,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689653,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689654,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689656,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689657,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689659,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689662,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689663,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689666,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689668,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689671,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689672,
    "state": "KERALA",
    "district": "RANNY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689673,
    "state": "KERALA",
    "district": "RANNY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689676,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689678,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689680,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689681,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689682,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689691,
    "state": "KERALA",
    "district": "KONNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689692,
    "state": "KERALA",
    "district": "KONNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689693,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689695,
    "state": "KERALA",
    "district": "PATHANAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689696,
    "state": "KERALA",
    "district": "PATHANAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689698,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689703,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689705,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689712,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689713,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689721,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689722,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689723,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689842,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690001,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690010,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690101,
    "state": "KERALA",
    "district": "MAVELIKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690103,
    "state": "KERALA",
    "district": "MAVELIKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690104,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690105,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690106,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690107,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690110,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690501,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690502,
    "state": "KERALA",
    "district": "KAYAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690503,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690504,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690505,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690506,
    "state": "KERALA",
    "district": "HARIPAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690507,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690508,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690509,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690511,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690512,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690513,
    "state": "KERALA",
    "district": "HARIPAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690514,
    "state": "KERALA",
    "district": "HARIPAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690515,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690516,
    "state": "KERALA",
    "district": "HARIPAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690517,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690518,
    "state": "KERALA",
    "district": "KARUNAGAPILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690519,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690520,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690521,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690522,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690523,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690524,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690525,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690526,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690527,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690528,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690529,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690530,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690531,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690533,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690534,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690535,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690536,
    "state": "KERALA",
    "district": "KAYAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690537,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690539,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690542,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690544,
    "state": "KERALA",
    "district": "KARUNAGAPILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690546,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690547,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690550,
    "state": "KERALA",
    "district": "HARIPAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690551,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690558,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690559,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690561,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690565,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690572,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690573,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690574,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691001,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691002,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691003,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691004,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691005,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691006,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691008,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691009,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691010,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691011,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691012,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691013,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691014,
    "state": "KERALA",
    "district": "ANCHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691015,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691017,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691020,
    "state": "KERALA",
    "district": "THATTAMALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691021,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691301,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691302,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691303,
    "state": "KERALA",
    "district": "KOTTIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691305,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691306,
    "state": "KERALA",
    "district": "ANCHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691307,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691310,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691312,
    "state": "KERALA",
    "district": "PATHANAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691314,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691322,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691333,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691334,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691501,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691502,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691503,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691505,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691506,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691507,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691508,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691509,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691510,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691511,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691512,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691516,
    "state": "KERALA",
    "district": "PATHANAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691520,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691521,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691522,
    "state": "KERALA",
    "district": "PATHANAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691523,
    "state": "KERALA",
    "district": "ADOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691524,
    "state": "KERALA",
    "district": "ADOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691525,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691526,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691528,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691531,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691532,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691533,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691534,
    "state": "KERALA",
    "district": "ANCHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691535,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691536,
    "state": "KERALA",
    "district": "KADAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691537,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691538,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691540,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691541,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691544,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691550,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691551,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691552,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691553,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691554,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691555,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691556,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691557,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691559,
    "state": "KERALA",
    "district": "KADAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691560,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691566,
    "state": "KERALA",
    "district": "PARIPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691571,
    "state": "KERALA",
    "district": "KOTTIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691572,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691573,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691574,
    "state": "KERALA",
    "district": "PARIPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691576,
    "state": "KERALA",
    "district": "KOTTIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691577,
    "state": "KERALA",
    "district": "KOTTIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691578,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691579,
    "state": "KERALA",
    "district": "CHATTANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691582,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691583,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691585,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691589,
    "state": "KERALA",
    "district": "KOTTIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691601,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691602,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695001,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695002,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695003,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695004,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695005,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695006,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695007,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695008,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695009,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695010,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695011,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695012,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695013,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695014,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695015,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695016,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695017,
    "state": "KERALA",
    "district": "SREEKARIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695018,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695019,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695020,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695021,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695022,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695023,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695024,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695025,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695026,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695027,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695028,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695029,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695030,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695031,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695032,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695033,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695034,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695035,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695036,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695037,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695038,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695039,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695040,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695041,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695042,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695043,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695044,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695099,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695101,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695102,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695103,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695104,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695121,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695123,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695125,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695141,
    "state": "KERALA",
    "district": "VARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695143,
    "state": "KERALA",
    "district": "VARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695145,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695146,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695301,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695303,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695304,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695305,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695310,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695311,
    "state": "KERALA",
    "district": "VARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695316,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695317,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695501,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695502,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695521,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695522,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695524,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695526,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695527,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695528,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695541,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695542,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695543,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695547,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695551,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695561,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695562,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695564,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695571,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695572,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695573,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695575,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695581,
    "state": "KERALA",
    "district": "SREEKARIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695582,
    "state": "KERALA",
    "district": "KAZHAKKUTTAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695583,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695584,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695585,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695586,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695587,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695588,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695601,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695602,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695603,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695604,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695605,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695606,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695607,
    "state": "KERALA",
    "district": "VENJARAMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695608,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695614,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695615,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700001,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700002,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700003,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700004,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700005,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700006,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700007,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700008,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700009,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700010,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700011,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700012,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700013,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700014,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700015,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700016,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700017,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700018,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700019,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700020,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700021,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700022,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700023,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700024,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700025,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700026,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700027,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700028,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700029,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700030,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700031,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700032,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700033,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700034,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700035,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700036,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700037,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700038,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700039,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700040,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700041,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700042,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700043,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700044,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700045,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700046,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700047,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700048,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700049,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700050,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700051,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700052,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700053,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700054,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700055,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700056,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700057,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700058,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700059,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700060,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700061,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700062,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700063,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700064,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700065,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700066,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700067,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700068,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700069,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700070,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700071,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700072,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700073,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700074,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700075,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700076,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700077,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700078,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700079,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700080,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700081,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700082,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700083,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700084,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700085,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700086,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700087,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700088,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700089,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700090,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700091,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700092,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700093,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700094,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700095,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700096,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700097,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700098,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700099,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700100,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700101,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700102,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700103,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700104,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700105,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700106,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700107,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700108,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700109,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700110,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700111,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700112,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700113,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700114,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700115,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700116,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700117,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700118,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700119,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700120,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700121,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700122,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700123,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700124,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700125,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700126,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700127,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700128,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700129,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700130,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700131,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700132,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700133,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700134,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700135,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700136,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700141,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700142,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700143,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700144,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700145,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700146,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700147,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700148,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700149,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700150,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700151,
    "state": "WEST BENGAL",
    "district": "SOUTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700152,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700153,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700154,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700155,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700156,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700157,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700158,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700159,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700160,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700161,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700162,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711101,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711102,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711103,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711104,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711105,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711106,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711107,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711108,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711109,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711110,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711111,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711112,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711113,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711114,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711127,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711201,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711202,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711203,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711204,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711227,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711302,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711303,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711304,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711310,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711313,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711315,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711316,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711321,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711322,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711328,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711401,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711402,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711403,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711405,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711408,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711409,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711411,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712101,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712102,
    "state": "WEST BENGAL",
    "district": "CHINSURAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712105,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712123,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712124,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712125,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712136,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712138,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712148,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712149,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712201,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712202,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712203,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712204,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712205,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712221,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712222,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712223,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712232,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712233,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712234,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712235,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712245,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712246,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712247,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712248,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712249,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712250,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712258,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712302,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712303,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712304,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712306,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712309,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712310,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712401,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712402,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712403,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712404,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712405,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712407,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712409,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712410,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712501,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712502,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712503,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712512,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712514,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712515,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712601,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712611,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712614,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712701,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712708,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713101,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713102,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713103,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713104,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713125,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713128,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713130,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713140,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713144,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713146,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713148,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713150,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713201,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713202,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713203,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713204,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713205,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713206,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713207,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713208,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713209,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713210,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713211,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713212,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713213,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713214,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713215,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713216,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713218,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713219,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713301,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713302,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713303,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713304,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713305,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713315,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713321,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713324,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713325,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713326,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713331,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713333,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713334,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713335,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713336,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713339,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713340,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713341,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713343,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713346,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713347,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713357,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713358,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713359,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713360,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713363,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713364,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713365,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713378,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713381,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713385,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713386,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713403,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713404,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713405,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713406,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713409,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713424,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713426,
    "state": "WEST BENGAL",
    "district": "Barddhaman",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721101,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721102,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721121,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721124,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721126,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721132,
    "state": "WEST BENGAL",
    "district": "SALBONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721134,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721137,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721145,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721147,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721150,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721152,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721154,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721157,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721160,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721166,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721171,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721172,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721201,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721211,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721212,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721232,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721242,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721301,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721302,
    "state": "WEST BENGAL",
    "district": "PASCHIM MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721303,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721304,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721305,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721306,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721401,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721424,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721425,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721426,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721428,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721429,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721430,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721431,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721437,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721443,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721444,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721446,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721448,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721451,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721453,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721463,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721507,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721514,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721601,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721602,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721603,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721604,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721605,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721606,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721607,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721625,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721626,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721627,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721628,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721631,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721632,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721634,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721635,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721636,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721641,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721645,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721646,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721648,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721649,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721655,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721657,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721659,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722101,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722102,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722122,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722132,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722133,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722134,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722137,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722140,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722141,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722142,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722144,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722147,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722151,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722152,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722158,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722161,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722162,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722166,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722168,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722183,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722202,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722203,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722204,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722205,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723101,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723102,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723103,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723121,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723131,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723133,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723146,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723149,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723202,
    "state": "WEST BENGAL",
    "district": "Puruliya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731101,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731102,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731103,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731104,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731123,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731201,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731204,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731214,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731216,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731219,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731224,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731233,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731234,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731235,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731236,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731237,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731243,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731244,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731302,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731303,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732101,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732102,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732103,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732123,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732124,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732125,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732138,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732141,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732142,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732146,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732201,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733006,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733101,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733102,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733103,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733121,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733123,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733124,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733130,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733134,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733201,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733215,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734001,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734003,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734004,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734005,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734006,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734007,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734008,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734009,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734010,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734011,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734012,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734013,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734014,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734015,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734018,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734025,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734401,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734403,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734404,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734405,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734406,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734418,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734421,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734422,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734429,
    "state": "WEST BENGAL",
    "district": "Darjiling",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735102,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735134,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735135,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735202,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735203,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735210,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735211,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735213,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735215,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735216,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735220,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735221,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735304,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736101,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736102,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736118,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736121,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736122,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736123,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736131,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736146,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736156,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736159,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736165,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736170,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736179,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736202,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736207,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 737102,
    "state": "SIKKIM",
    "district": "DEORALI -GANGTOK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 737132,
    "state": "SIKKIM",
    "district": "DEORALI -GANGTOK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 737135,
    "state": "SIKKIM",
    "district": "RANIPUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 738001,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741001,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741101,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741102,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741103,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741121,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741126,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741139,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741155,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741159,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741160,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741201,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741202,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741203,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741221,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741222,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741232,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741234,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741235,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741245,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741246,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741249,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741250,
    "state": "WEST BENGAL",
    "district": "KATAGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741251,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741252,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741255,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741302,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741313,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741402,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741404,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741501,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741502,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741504,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741505,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742101,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742102,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742103,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742137,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742165,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742187,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742201,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742202,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742212,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742213,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742225,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742236,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742238,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743122,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743123,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743124,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743125,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743126,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743127,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743128,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743129,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743133,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743134,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743135,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743136,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743143,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743144,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743145,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743165,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743166,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743175,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743178,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743179,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743180,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743186,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743187,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743193,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743195,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743201,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743202,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743203,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743204,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743221,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743222,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743223,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743235,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743245,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743247,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743248,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743249,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743252,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743263,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743272,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743273,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743275,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743276,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743286,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743287,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743289,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743290,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743293,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743298,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743312,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743329,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743330,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743332,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743337,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743368,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743411,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743412,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743413,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743422,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743424,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743425,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743426,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743428,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743438,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743445,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743502,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743510,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743513,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743610,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743703,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743704,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743707,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743711,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 744127,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 748706,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 750014,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 750026,
    "state": "ORISSA",
    "district": "DUBURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 750122,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751000,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751001,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751002,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751003,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751004,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751005,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751006,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751007,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751009,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751010,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751011,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751012,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751013,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751014,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751015,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751016,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751017,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751018,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751019,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751020,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751021,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751022,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751023,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751024,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751025,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751030,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751031,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751054,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752001,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752002,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752003,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752011,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752012,
    "state": "ORISSA",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752013,
    "state": "ORISSA",
    "district": "BASUDEVPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752014,
    "state": "ORISSA",
    "district": "SAKHIGOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752019,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752021,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752027,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752030,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752034,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752035,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752037,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752055,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752056,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752057,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752068,
    "state": "ORISSA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752069,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752070,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752077,
    "state": "ORISSA",
    "district": "JAGATSINGHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752078,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752082,
    "state": "ORISSA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752083,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752094,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752100,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752101,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752104,
    "state": "ORISSA",
    "district": "PIPILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752106,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752108,
    "state": "ORISSA",
    "district": "KAKATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753001,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753002,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753003,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753004,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753005,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753007,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753008,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753009,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753010,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753011,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753012,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753013,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753014,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753015,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753021,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753141,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754006,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754008,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754021,
    "state": "ORISSA",
    "district": "JAGATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754024,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754025,
    "state": "ORISSA",
    "district": "JAGATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754071,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754102,
    "state": "ORISSA",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754103,
    "state": "ORISSA",
    "district": "JAGATSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754120,
    "state": "ORISSA",
    "district": "PARADEEP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754134,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754136,
    "state": "ORISSA",
    "district": "JAGATSINGHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754141,
    "state": "ORISSA",
    "district": "PARADEEP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754142,
    "state": "ORISSA",
    "district": "PARADEEP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754143,
    "state": "ORISSA",
    "district": "PARADEEP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754144,
    "state": "ORISSA",
    "district": "PARADEEP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754145,
    "state": "ORISSA",
    "district": "PARADEEP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754202,
    "state": "ORISSA",
    "district": "SALEPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754211,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754212,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755011,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755018,
    "state": "ORISSA",
    "district": "SUKINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755019,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755020,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755026,
    "state": "ORISSA",
    "district": "DUBURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755028,
    "state": "ORISSA",
    "district": "SUKINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755043,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755047,
    "state": "ORISSA",
    "district": "SUKINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756001,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756002,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756003,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756019,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756045,
    "state": "ORISSA",
    "district": "SORO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756080,
    "state": "ORISSA",
    "district": "BALESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756100,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756101,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756114,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756171,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757001,
    "state": "ORISSA",
    "district": "BARIPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757028,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757037,
    "state": "ORISSA",
    "district": "KARANJIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758001,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758002,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758034,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758035,
    "state": "ORISSA",
    "district": "BARBIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759013,
    "state": "ORISSA",
    "district": "DHENKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759037,
    "state": "ORISSA",
    "district": "TALCHER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759100,
    "state": "ORISSA",
    "district": "TALCHER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759101,
    "state": "ORISSA",
    "district": "TALCHER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759103,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759104,
    "state": "ORISSA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759106,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759107,
    "state": "ORISSA",
    "district": "BALHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759116,
    "state": "ORISSA",
    "district": "TALCHER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759121,
    "state": "ORISSA",
    "district": "MERAMUNDULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759122,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759123,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759128,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759141,
    "state": "ORISSA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759143,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759145,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759147,
    "state": "ORISSA",
    "district": "KANIHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759148,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760001,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760002,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760003,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760004,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760005,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760006,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760008,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760009,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760010,
    "state": "WEST BENGAL",
    "district": "BRAHMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761029,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761041,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761043,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761101,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761103,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761110,
    "state": "ORISSA",
    "district": "ASKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761116,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761117,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761144,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761146,
    "state": "ORISSA",
    "district": "NABARANGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761211,
    "state": "ORISSA",
    "district": "PARLAKHEMUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 762001,
    "state": "ORISSA",
    "district": "PHULBANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 763001,
    "state": "ORISSA",
    "district": "DAMANJODI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 763002,
    "state": "ORISSA",
    "district": "DAMANJODI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 763003,
    "state": "ORISSA",
    "district": "DAMANJODI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 763008,
    "state": "ORISSA",
    "district": "DAMANJODI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764001,
    "state": "ORISSA",
    "district": "JEYPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764036,
    "state": "ORISSA",
    "district": "SIMILIGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764037,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764048,
    "state": "ORISSA",
    "district": "MALKANGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764049,
    "state": "ORISSA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764070,
    "state": "ORISSA",
    "district": "NABARANGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764078,
    "state": "ORISSA",
    "district": "NABARANGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765001,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765002,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765015,
    "state": "ORISSA",
    "district": "TIKIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765017,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765020,
    "state": "ORISSA",
    "district": "MINIGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765022,
    "state": "ORISSA",
    "district": "GUNUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766001,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766012,
    "state": "ORISSA",
    "district": "KESINGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766027,
    "state": "ORISSA",
    "district": "BHAWANIPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766107,
    "state": "ORISSA",
    "district": "NUAPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767001,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767002,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768001,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768002,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768003,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768004,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768005,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768016,
    "state": "ORISSA",
    "district": "HIRAKUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768017,
    "state": "ORISSA",
    "district": "BURLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768018,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768019,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768020,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768027,
    "state": "ORISSA",
    "district": "ATTABIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768028,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768029,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768033,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768036,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768108,
    "state": "ORISSA",
    "district": "DEOGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768150,
    "state": "ORISSA",
    "district": "BARAIPALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768201,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768202,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768203,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768211,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768212,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768216,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768234,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769001,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769002,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769003,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769004,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769005,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769006,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769007,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769008,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769009,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769010,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769011,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769012,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769013,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769014,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769015,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769016,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769017,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769031,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769034,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769037,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769041,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769042,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769043,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770001,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770002,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770017,
    "state": "ORISSA",
    "district": "RAJGANGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770032,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770034,
    "state": "ORISSA",
    "district": "KANSBAHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770038,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 773235,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781001,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781003,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781004,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781005,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781006,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781007,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781008,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781009,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781010,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781011,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781012,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781013,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781014,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781015,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781016,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781017,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781018,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781019,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781020,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781021,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781022,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781024,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781025,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781026,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781027,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781028,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781029,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781030,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781031,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781032,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781033,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781034,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781035,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781036,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781037,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781038,
    "state": "ASSAM",
    "district": "Kamrup Metropolitan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781039,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781040,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781068,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781071,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781101,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781122,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781125,
    "state": "ASSAM",
    "district": "KAMRUP METROPOLITAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781132,
    "state": "ASSAM",
    "district": "BAKSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781301,
    "state": "ASSAM",
    "district": "Barpeta",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781315,
    "state": "ASSAM",
    "district": "Baksa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781325,
    "state": "ASSAM",
    "district": "Barpeta",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781335,
    "state": "ASSAM",
    "district": "Nalbari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781346,
    "state": "ASSAM",
    "district": "Baksa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781354,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781355,
    "state": "ASSAM",
    "district": "Baksa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781365,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781370,
    "state": "ASSAM",
    "district": "Nalbari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781371,
    "state": "ASSAM",
    "district": "Baksa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781372,
    "state": "ASSAM",
    "district": "BAKSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781374,
    "state": "ASSAM",
    "district": "Baksa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781378,
    "state": "ASSAM",
    "district": "Baksa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781380,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781381,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782001,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782002,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782003,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782103,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782136,
    "state": "ASSAM",
    "district": "JAKHALABANDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782137,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782138,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782139,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782402,
    "state": "ASSAM",
    "district": "SONAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782403,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782435,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782445,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782446,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782447,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783101,
    "state": "ASSAM",
    "district": "Goalpara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783126,
    "state": "ASSAM",
    "district": "Goalpara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783301,
    "state": "ASSAM",
    "district": "Dhubri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783302,
    "state": "ASSAM",
    "district": "Dhubri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783303,
    "state": "ASSAM",
    "district": "Dhubri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783323,
    "state": "ASSAM",
    "district": "Dhubri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783348,
    "state": "ASSAM",
    "district": "Dhubri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783369,
    "state": "ASSAM",
    "district": "Kokrajhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783370,
    "state": "ASSAM",
    "district": "Kokrajhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783380,
    "state": "ASSAM",
    "district": "Bongaigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783381,
    "state": "ASSAM",
    "district": "Bongaigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783382,
    "state": "ASSAM",
    "district": "Bongaigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783384,
    "state": "ASSAM",
    "district": "Bongaigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783385,
    "state": "ASSAM",
    "district": "Bongaigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783390,
    "state": "ASSAM",
    "district": "Chirang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784001,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784027,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784028,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784101,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784105,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784110,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784114,
    "state": "ASSAM",
    "district": "Udalguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784115,
    "state": "ASSAM",
    "district": "Darrang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784125,
    "state": "ASSAM",
    "district": "Darrang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784145,
    "state": "ASSAM",
    "district": "Darrang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784154,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784160,
    "state": "ASSAM",
    "district": "Lakhimpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784161,
    "state": "ASSAM",
    "district": "Lakhimpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784164,
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784168,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784176,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784507,
    "state": "ASSAM",
    "district": "Darrang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784509,
    "state": "ASSAM",
    "district": "Udalguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784514,
    "state": "ASSAM",
    "district": "Darrang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784521,
    "state": "ASSAM",
    "district": "Darrang",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785001,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785002,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785003,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785004,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785005,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785006,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785007,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785008,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785612,
    "state": "ASSAM",
    "district": "Golaghat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785621,
    "state": "ASSAM",
    "district": "Golaghat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785640,
    "state": "ASSAM",
    "district": "Sivasagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785662,
    "state": "ASSAM",
    "district": "Sivasagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785670,
    "state": "ASSAM",
    "district": "Sivasagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786001,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786002,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786003,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786004,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786005,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786006,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786008,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786009,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786010,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786125,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786126,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786145,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786146,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786153,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786156,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786157,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786171,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786184,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786601,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786602,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786622,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786623,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786678,
    "state": "ASSAM",
    "district": "Lakhimpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787001,
    "state": "ASSAM",
    "district": "Lakhimpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787034,
    "state": "ASSAM",
    "district": "Lakhimpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787055,
    "state": "ASSAM",
    "district": "Lakhimpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787057,
    "state": "ASSAM",
    "district": "Dhemaji",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787059,
    "state": "ASSAM",
    "district": "Dhemaji",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787060,
    "state": "ASSAM",
    "district": "Dhemaji",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788001,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788002,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788003,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788004,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788005,
    "state": "ASSAM",
    "district": "CACHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788006,
    "state": "ASSAM",
    "district": "CACHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788007,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788008,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788009,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788010,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788011,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788012,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788014,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788015,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788030,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788101,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788150,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788151,
    "state": "ASSAM",
    "district": "Hailakandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788152,
    "state": "ASSAM",
    "district": "Hailakandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788155,
    "state": "ASSAM",
    "district": "Hailakandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788163,
    "state": "ASSAM",
    "district": "Hailakandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788166,
    "state": "ASSAM",
    "district": "Karimganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788710,
    "state": "ASSAM",
    "district": "Karimganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788806,
    "state": "ASSAM",
    "district": "Karimganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788815,
    "state": "ASSAM",
    "district": "Cachar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791102,
    "state": "ARUNACHAL PRADESH",
    "district": "PASIGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791103,
    "state": "ARUNACHAL PRADESH",
    "district": "PASIGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791109,
    "state": "ASSAM",
    "district": "PAPUM PARE",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 791110,
    "state": "ASSAM",
    "district": "PAPUM PARE",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 791111,
    "state": "ASSAM",
    "district": "PAPUM PARE",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 791113,
    "state": "ASSAM",
    "district": "PAPUM PARE",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 791123,
    "state": "ASSAM",
    "district": "PAPUM PARE",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 793001,
    "state": "MEGHALAYA",
    "district": "East Khasi Hills",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793002,
    "state": "MEGHALAYA",
    "district": "East Khasi Hills",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793003,
    "state": "MEGHALAYA",
    "district": "East Khasi Hills",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793004,
    "state": "MEGHALAYA",
    "district": "East Khasi Hills",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793006,
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 793014,
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793021,
    "state": "MEGHALAYA",
    "district": "East Khasi Hills",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 795004,
    "state": "MANIPUR",
    "district": "IMPHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 796001,
    "state": "MIZORAM",
    "district": "AIZWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 796007,
    "state": "MIZORAM",
    "district": "AIZWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799001,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799002,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799003,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799004,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799005,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799006,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799007,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799008,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799009,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799010,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799014,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799022,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799035,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799045,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799046,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799055,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799102,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799116,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799120,
    "state": "TRIPURA",
    "district": "AGARTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799130,
    "state": "TRIPURA",
    "district": "Sipahijala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799141,
    "state": "TRIPURA",
    "district": "South Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799144,
    "state": "TRIPURA",
    "district": "South Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799155,
    "state": "TRIPURA",
    "district": "South Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799181,
    "state": "TRIPURA",
    "district": "South Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799201,
    "state": "TRIPURA",
    "district": "Khowai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799202,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799203,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799206,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799207,
    "state": "TRIPURA",
    "district": "West Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799211,
    "state": "TRIPURA",
    "district": "AGARTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799250,
    "state": "TRIPURA",
    "district": "North Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799260,
    "state": "TRIPURA",
    "district": "North Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799264,
    "state": "TRIPURA",
    "district": "Unakoti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799270,
    "state": "TRIPURA",
    "district": "North Tripura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799275,
    "state": "TRIPURA",
    "district": "Dhalai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799277,
    "state": "TRIPURA",
    "district": "Unakoti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799279,
    "state": "TRIPURA",
    "district": "Unakoti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799285,
    "state": "TRIPURA",
    "district": "Dhalai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799286,
    "state": "TRIPURA",
    "district": "Dhalai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799287,
    "state": "TRIPURA",
    "district": "Dhalai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799289,
    "state": "TRIPURA",
    "district": "Dhalai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800001,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800002,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800003,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800004,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800005,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800006,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800007,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800008,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800009,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800010,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800011,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800012,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800013,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800014,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800015,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800016,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800017,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800018,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800019,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800020,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800021,
    "state": "BIHAR",
    "district": "PUNAICHAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800022,
    "state": "BIHAR",
    "district": "PUNAICHAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800023,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800024,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800025,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800026,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800027,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800029,
    "state": "BIHAR",
    "district": "PHULWARI KHAGAUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801103,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801108,
    "state": "BIHAR",
    "district": "BIHTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801118,
    "state": "BIHAR",
    "district": "BIHTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801501,
    "state": "BIHAR",
    "district": "BETTIAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801503,
    "state": "BIHAR",
    "district": "DANAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801505,
    "state": "BIHAR",
    "district": "PHULWARI KHAGAUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803101,
    "state": "BIHAR",
    "district": "BIHAR SHARIFF",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803116,
    "state": "BIHAR",
    "district": "RAJGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803201,
    "state": "BIHAR",
    "district": "FATWAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803212,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803214,
    "state": "BIHAR",
    "district": "BARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811201,
    "state": "BIHAR",
    "district": "MUNGER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811202,
    "state": "BIHAR",
    "district": "MUNGER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811203,
    "state": "BIHAR",
    "district": "MUNGER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811214,
    "state": "BIHAR",
    "district": "MUNGER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811311,
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812001,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812002,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812003,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812004,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812005,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 813102,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814112,
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 815301,
    "state": "BIHAR",
    "district": "GIRIDIH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 815316,
    "state": "BIHAR",
    "district": "GIRIDIH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 815351,
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 815353,
    "state": "BIHAR",
    "district": "MADHUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 816101,
    "state": "JHARKHAND",
    "district": "BARHARWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 816107,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821101,
    "state": "BIHAR",
    "district": "BHABHUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821103,
    "state": "BIHAR",
    "district": "BHABHUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821108,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821109,
    "state": "BIHAR",
    "district": "MOHANIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 823001,
    "state": "BIHAR",
    "district": "GAYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 823002,
    "state": "BIHAR",
    "district": "GAYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824101,
    "state": "BIHAR",
    "district": "AURANGABAD -BH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824211,
    "state": "BIHAR",
    "district": "GAYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824231,
    "state": "BIHAR",
    "district": "BUDHGAYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824236,
    "state": "BIHAR",
    "district": "GAYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825301,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825336,
    "state": "BIHAR",
    "district": "CHARHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825405,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826001,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826002,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826003,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826004,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826005,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826006,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827001,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827002,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827003,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827004,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827005,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827006,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827007,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827008,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827009,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827010,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827011,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827012,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827013,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 827014,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828104,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828106,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828108,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828109,
    "state": "JHARKHAND",
    "district": "GOBINDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828110,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828111,
    "state": "JHARKHAND",
    "district": "JHARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828113,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828119,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828122,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828123,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828124,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828127,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828202,
    "state": "WEST BENGAL",
    "district": "ASANSOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828203,
    "state": "WEST BENGAL",
    "district": "BARAKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828205,
    "state": "JHARKHAND",
    "district": "NIRSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828207,
    "state": "JHARKHAND",
    "district": "MAITHON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828301,
    "state": "JHARKHAND",
    "district": "JHARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828309,
    "state": "JHARKHAND",
    "district": "BAGHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828403,
    "state": "JHARKHAND",
    "district": "CHANDRAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829107,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829112,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829113,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829117,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829144,
    "state": "JHARKHAND",
    "district": "PHUSRO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829301,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831001,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831002,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831003,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831004,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831005,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831006,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831007,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831008,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831009,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831010,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831011,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831012,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831013,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831015,
    "state": "JHARKHAND",
    "district": "CHHOTA GOVINDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831017,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831018,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831019,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831107,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831109,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 831110,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832101,
    "state": "JHARKHAND",
    "district": "BAHARAGORA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832102,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832107,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832108,
    "state": "JHARKHAND",
    "district": "GAMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832109,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832110,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832303,
    "state": "JHARKHAND",
    "district": "GHATSILA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832401,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 833201,
    "state": "JHARKHAND",
    "district": "CHAIBASA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 833215,
    "state": "JHARKHAND",
    "district": "CHAIBASA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 833217,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 833218,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834001,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834002,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834003,
    "state": "JHARKHAND",
    "district": "HATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834004,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834005,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834006,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834007,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834008,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834009,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834010,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 834012,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835103,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835215,
    "state": "BIHAR",
    "district": "MESRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835217,
    "state": "BIHAR",
    "district": "MESRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835219,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835222,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841426,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841428,
    "state": "BIHAR",
    "district": "GOPALGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841505,
    "state": "BIHAR",
    "district": "GOPALGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 842001,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 842002,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 842003,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 842004,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843108,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843109,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843113,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843119,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843301,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843302,
    "state": "BIHAR",
    "district": "SITAMARHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844101,
    "state": "BIHAR",
    "district": "HAZIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844118,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845101,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845303,
    "state": "BIHAR",
    "district": "GHORASAHAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845305,
    "state": "BIHAR",
    "district": "RAXAUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845401,
    "state": "BIHAR",
    "district": "MOTIHARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845412,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845438,
    "state": "BIHAR",
    "district": "BETTIAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845455,
    "state": "BIHAR",
    "district": "NARKATIAGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 846001,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 846004,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 846005,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 847211,
    "state": "BIHAR",
    "district": "MADHUBANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 847213,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848101,
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848102,
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848103,
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848114,
    "state": "BIHAR",
    "district": "DALSINGSARAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848125,
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848130,
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852111,
    "state": "BIHAR",
    "district": "RAGHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852113,
    "state": "BIHAR",
    "district": "MADHEPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852131,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852138,
    "state": "BIHAR",
    "district": "SAHARSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852201,
    "state": "BIHAR",
    "district": "SAHARSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854103,
    "state": "BIHAR",
    "district": "KATIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854105,
    "state": "BIHAR",
    "district": "KATIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854106,
    "state": "BIHAR",
    "district": "KATIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854301,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854302,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854303,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854305,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854311,
    "state": "BIHAR",
    "district": "ARARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854326,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854337,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 855107,
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124021,
    "state": "HARYANA",
    "district": "Rohtak",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124103,
    "state": "HARYANA",
    "district": "Jhajjar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124113,
    "state": "HARYANA",
    "district": "Rohtak",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125033,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125051,
    "state": "HARYANA",
    "district": "Fatehabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125052,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125102,
    "state": "HARYANA",
    "district": "SIRSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125120,
    "state": "HARYANA",
    "district": "Fatehabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125121,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126102,
    "state": "HARYANA",
    "district": "Jind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126112,
    "state": "HARYANA",
    "district": "Jind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126116,
    "state": "HARYANA",
    "district": "Jind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127306,
    "state": "HARYANA",
    "district": "Bhiwani",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131039,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131101,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131103,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131402,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132013,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132021,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132024,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132039,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132106,
    "state": "HARYANA",
    "district": "Panipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132114,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132116,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132117,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132140,
    "state": "HARYANA",
    "district": "Panipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133102,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133104,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133201,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133202,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133203,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133302,
    "state": "HIMACHAL PRADESH",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134105,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134126,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134203,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136119,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136128,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136129,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136131,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136132,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136135,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140201,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140306,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140308,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140406,
    "state": "PUNJAB",
    "district": "Fatehgarh Sahib",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140507,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140603,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140604,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142026,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142027,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143112,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143201,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143519,
    "state": "PUNJAB",
    "district": "Gurdaspur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144211,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144401,
    "state": "PUNJAB",
    "district": "Kapurthala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144402,
    "state": "PUNJAB",
    "district": "Kapurthala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144601,
    "state": "PUNJAB",
    "district": "Kapurthala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147005,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147201,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147301,
    "state": "PUNJAB",
    "district": "Fatehgarh Sahib",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148023,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148024,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148027,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148035,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148101,
    "state": "PUNJAB",
    "district": "Barnala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151204,
    "state": "PUNJAB",
    "district": "Faridkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151505,
    "state": "PUNJAB",
    "district": "Mansa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152002,
    "state": "PUNJAB",
    "district": "Firozpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152123,
    "state": "PUNJAB",
    "district": "FIROZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160058,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160061,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160065,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160070,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160074,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160079,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171009,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173025,
    "state": "HARYANA",
    "district": "Sirmaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173201,
    "state": "HARYANA",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173205,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173212,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174303,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174401,
    "state": "HIMACHAL PRADESH",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175008,
    "state": "HIMACHAL PRADESH",
    "district": "Mandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177005,
    "state": "HARYANA",
    "district": "Hamirpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383341,
    "state": "GUJARAT",
    "district": "Aravalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383354,
    "state": "GUJARAT",
    "district": "Aravalli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445001,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410220,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410405,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412119,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412205,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412219,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413102,
    "state": "MAHARASHTRA",
    "district": "BARAMATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413111,
    "state": "MAHARASHTRA",
    "district": "BARAMATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413130,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413133,
    "state": "MAHARASHTRA",
    "district": "BARAMATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413601,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414003,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414005,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415523,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416109,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416116,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441104,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606201,
    "state": "TAMIL NADU",
    "district": "Viluppuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606207,
    "state": "TAMIL NADU",
    "district": "Viluppuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636704,
    "state": "TAMIL NADU",
    "district": "Dharmapuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641608,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642127,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561209,
    "state": "KARNATAKA",
    "district": "BAGEPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571104,
    "state": "KARNATAKA",
    "district": "BYALAKUPPE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576218,
    "state": "KARNATAKA",
    "district": "BRAHMAVAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576225,
    "state": "KARNATAKA",
    "district": "BRAHMAVAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576226,
    "state": "KARNATAKA",
    "district": "BRAHMAVAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577512,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585367,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585412,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586203,
    "state": "KARNATAKA",
    "district": "BASAVAN BAGEWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591117,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700139,
    "state": "WEST BENGAL",
    "district": "Kolkata",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700140,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721441,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735101,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736135,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752050,
    "state": "ORISSA",
    "district": "JATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754005,
    "state": "ORISSA",
    "district": "TRISULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755008,
    "state": "ORISSA",
    "district": "JARAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761002,
    "state": "ORISSA",
    "district": "GOPALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 762014,
    "state": "ORISSA",
    "district": "BOUDH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767017,
    "state": "ORISSA",
    "district": "SONEPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781171,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782105,
    "state": "ASSAM",
    "district": "Morigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782410,
    "state": "ASSAM",
    "district": "JAGIROAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782413,
    "state": "ASSAM",
    "district": "Morigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782440,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785010,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785013,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785014,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785602,
    "state": "ASSAM",
    "district": "Golaghat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785630,
    "state": "ASSAM",
    "district": "Jorhat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785664,
    "state": "ASSAM",
    "district": "Sivasagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785680,
    "state": "ASSAM",
    "district": "Sivasagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785699,
    "state": "ASSAM",
    "district": "Golaghat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785702,
    "state": "ASSAM",
    "district": "Golaghat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 805103,
    "state": "BIHAR",
    "district": "NAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 813116,
    "state": "BIHAR",
    "district": "RAJGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 822101,
    "state": "JHARKHAND",
    "district": "DALTONGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825321,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828114,
    "state": "JHARKHAND",
    "district": "KHATRAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828121,
    "state": "JHARKHAND",
    "district": "KHATRAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828304,
    "state": "JHARKHAND",
    "district": "KHATRAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829118,
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829119,
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829120,
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829122,
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829203,
    "state": "JHARKHAND",
    "district": "DALTONGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829206,
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835204,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835210,
    "state": "JHARKHAND",
    "district": "KHUNTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851112,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851129,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851218,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854321,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854330,
    "state": "BIHAR",
    "district": "PURNIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494001,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493445,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493773,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497335,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493332,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497229,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493114,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494334,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 496001,
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495677,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497001,
    "state": "CHHATTISGARH",
    "district": "AMBIKAPUR(CG)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491441,
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125039,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125075,
    "state": "HARYANA",
    "district": "Sirsa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125104,
    "state": "PUNJAB",
    "district": "Sirsa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125133,
    "state": "HARYANA",
    "district": "Fatehabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131023,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131029,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131301,
    "state": "HARYANA",
    "district": "Sonipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132101,
    "state": "HARYANA",
    "district": "Panipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132107,
    "state": "HARYANA",
    "district": "Panipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132113,
    "state": "HARYANA",
    "district": "Panipat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133204,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134118,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136020,
    "state": "HARYANA",
    "district": "Kurukshetra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140101,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140103,
    "state": "PUNJAB",
    "district": "KURALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140111,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140112,
    "state": "HARYANA",
    "district": "PINJORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140118,
    "state": "HARYANA",
    "district": "Rupnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140301,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140412,
    "state": "PUNJAB",
    "district": "Fatehgarh Sahib",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140501,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141025,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141109,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141801,
    "state": "PUNJAB",
    "district": "Fatehgarh Sahib",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142033,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142038,
    "state": "PUNJAB",
    "district": "Moga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142047,
    "state": "PUNJAB",
    "district": "Firozpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142050,
    "state": "PUNJAB",
    "district": "Firozpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142055,
    "state": "PUNJAB",
    "district": "Moga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144039,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144216,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144411,
    "state": "PUNJAB",
    "district": "Kapurthala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144505,
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144514,
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144521,
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144527,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144702,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146102,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147101,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147103,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147105,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147202,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148022,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148026,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148028,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151101,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151103,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151301,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151504,
    "state": "PUNJAB",
    "district": "Mansa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152024,
    "state": "PUNJAB",
    "district": "Fazilka",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 172001,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173030,
    "state": "HARYANA",
    "district": "Sirmaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173101,
    "state": "HIMACHAL PRADESH",
    "district": "Sirmaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173207,
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173229,
    "state": "HIMACHAL PRADESH",
    "district": "Sirmaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174305,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174306,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176023,
    "state": "PUNJAB",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176047,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176052,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177033,
    "state": "HARYANA",
    "district": "Hamirpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177101,
    "state": "HARYANA",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244303,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312001,
    "state": "RAJASTHAN",
    "district": "Chittaurgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321001,
    "state": "RAJASTHAN",
    "district": "Bharatpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326001,
    "state": "RAJASTHAN",
    "district": "Jhalawar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344022,
    "state": "RAJASTHAN",
    "district": "Barmer",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476001,
    "state": "MADHYA PRADESH",
    "district": "Morena",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501101,
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501141,
    "state": "TELANGANA",
    "district": "TANDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501501,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501503,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502108,
    "state": "ANDHRA PRADESH",
    "district": "DUBBAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502110,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502230,
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502270,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502278,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502285,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502286,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502301,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502313,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502321,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502334,
    "state": "TELANGANA",
    "district": "MEDAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503111,
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503185,
    "state": "TELANGANA",
    "district": "BODHAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503187,
    "state": "TELANGANA",
    "district": "BANSWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503201,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503218,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503307,
    "state": "TELANGANA",
    "district": "BHEEMGHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504101,
    "state": "TELANGANA",
    "district": "BASAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504103,
    "state": "TELANGANA",
    "district": "BHAINSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504106,
    "state": "TELANGANA",
    "district": "NIRMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504201,
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504203,
    "state": "TELANGANA",
    "district": "NIRMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504205,
    "state": "TELANGANA",
    "district": "LUXETTIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504215,
    "state": "TELANGANA",
    "district": "LUXETTIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504216,
    "state": "TELANGANA",
    "district": "I-JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504251,
    "state": "TELANGANA",
    "district": "BELLAMPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504293,
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504296,
    "state": "TELANGANA",
    "district": "ASIFABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504301,
    "state": "TELANGANA",
    "district": "RAMAKRISHNAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504307,
    "state": "TELANGANA",
    "district": "ICHODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505122,
    "state": "TELANGANA",
    "district": "JAMMIKUNTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505162,
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505172,
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505184,
    "state": "TELANGANA",
    "district": "MANTHANY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505211,
    "state": "TELANGANA",
    "district": "EIGHT INC. COLONY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505302,
    "state": "TELANGANA",
    "district": "VEMULAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505325,
    "state": "TELANGANA",
    "district": "METPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505326,
    "state": "TELANGANA",
    "district": "KORATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505468,
    "state": "TELANGANA",
    "district": "HUZURABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506013,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506015,
    "state": "TELANGANA",
    "district": "HASANPARTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506132,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506163,
    "state": "TELANGANA",
    "district": "THORRUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506164,
    "state": "TELANGANA",
    "district": "PARAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506167,
    "state": "TELANGANA",
    "district": "JANGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506168,
    "state": "TELANGANA",
    "district": "CHELPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506169,
    "state": "TELANGANA",
    "district": "BHOOPALPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506223,
    "state": "TELANGANA",
    "district": "CHERIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506371,
    "state": "TELANGANA",
    "district": "HASANPARTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507166,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507302,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508101,
    "state": "ANDHRA PRADESH",
    "district": "ALAIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508113,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508116,
    "state": "TELANGANA",
    "district": "BHONGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508126,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508218,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508234,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508248,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508252,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508255,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508277,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508284,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508355,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508377,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509002,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509102,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509104,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509131,
    "state": "ANDHRA PRADESH",
    "district": "ATAMAKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509207,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509217,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509321,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509375,
    "state": "TELANGANA",
    "district": "ACHAMPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509410,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515133,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515425,
    "state": "ANDHRA PRADESH",
    "district": "NARPALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515701,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516106,
    "state": "ANDHRA PRADESH",
    "district": "KODUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516130,
    "state": "ANDHRA PRADESH",
    "district": "T.SUNDUPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516162,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516203,
    "state": "ANDHRA PRADESH",
    "district": "MYDUKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516257,
    "state": "ANDHRA PRADESH",
    "district": "LAKKIREDDYPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516433,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516439,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517124,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517125,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517129,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517235,
    "state": "ANDHRA PRADESH",
    "district": "KALKIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517299,
    "state": "ANDHRA PRADESH",
    "district": "VAYALPADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517432,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517551,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517582,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517585,
    "state": "ANDHRA PRADESH",
    "district": "PUTTUR -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518123,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518347,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518380,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518553,
    "state": "ANDHRA PRADESH",
    "district": "CHAGALAMARRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521109,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521215,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521229,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521403,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522018,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522019,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522236,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522314,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522411,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522419,
    "state": "ANDHRA PRADESH",
    "district": "DORNAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522505,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522508,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522529,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522612,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522614,
    "state": "ANDHRA PRADESH",
    "district": "KAREMPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523322,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523331,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524315,
    "state": "ANDHRA PRADESH",
    "district": "ALLURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524408,
    "state": "ANDHRA PRADESH",
    "district": "PODALKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524412,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530005,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530028,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530053,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531031,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531053,
    "state": "ANDHRA PRADESH",
    "district": "YELLAMANCHILLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531162,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531211,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531212,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531213,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531214,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531215,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532202,
    "state": "ANDHRA PRADESH",
    "district": "TEKKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532242,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532401,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532484,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533221,
    "state": "ANDHRA PRADESH",
    "district": "AMBAJIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533234,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533247,
    "state": "ANDHRA PRADESH",
    "district": "TATIPAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533248,
    "state": "ANDHRA PRADESH",
    "district": "TATIPAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533253,
    "state": "ANDHRA PRADESH",
    "district": "TATIPAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533286,
    "state": "ANDHRA PRADESH",
    "district": "GOKAVARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533287,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533288,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533406,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533408,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533428,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533429,
    "state": "ANDHRA PRADESH",
    "district": "KIRLAMPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533432,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533446,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533449,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534112,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534199,
    "state": "ANDHRA PRADESH",
    "district": "UNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534245,
    "state": "ANDHRA PRADESH",
    "district": "VEERAVASARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534269,
    "state": "ANDHRA PRADESH",
    "district": "ACHANTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534272,
    "state": "ANDHRA PRADESH",
    "district": "ACHANTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534315,
    "state": "ANDHRA PRADESH",
    "district": "TALLAPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534328,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534343,
    "state": "ANDHRA PRADESH",
    "district": "TALLAPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534426,
    "state": "ANDHRA PRADESH",
    "district": "DWARAKATIRUMALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534449,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535216,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535524,
    "state": "ANDHRA PRADESH",
    "district": "PARVATHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571201,
    "state": "KARNATAKA",
    "district": "MADIKERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572126,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573130,
    "state": "KARNATAKA",
    "district": "ARAKALAGUDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585214,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603107,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605501,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607103,
    "state": "TAMIL NADU",
    "district": "PANRUTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609111,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631003,
    "state": "TAMIL NADU",
    "district": "ARAKKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631004,
    "state": "TAMIL NADU",
    "district": "ARAKKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631601,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632008,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632059,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632201,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632204,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632515,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635601,
    "state": "TAMIL NADU",
    "district": "Vellore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635602,
    "state": "TAMIL NADU",
    "district": "Vellore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635752,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752054,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754001,
    "state": "ORISSA",
    "district": "PHULNAKHARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754009,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754029,
    "state": "ORISSA",
    "district": "ATHGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754032,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754132,
    "state": "ORISSA",
    "district": "RAGHUNATHPUR- CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755034,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756026,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756029,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756032,
    "state": "ORISSA",
    "district": "JALESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756036,
    "state": "ORISSA",
    "district": "DEHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756085,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756115,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756125,
    "state": "ORISSA",
    "district": "BASUDEVPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756133,
    "state": "ORISSA",
    "district": "CHANDBALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757002,
    "state": "ORISSA",
    "district": "BARIPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757003,
    "state": "ORISSA",
    "district": "BARIPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757041,
    "state": "ORISSA",
    "district": "UDALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757100,
    "state": "ORISSA",
    "district": "BETNOTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758015,
    "state": "ORISSA",
    "district": "ANANDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758021,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758023,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758028,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758078,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759117,
    "state": "ORISSA",
    "district": "KANIHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759125,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761012,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761020,
    "state": "ORISSA",
    "district": "CHATRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761102,
    "state": "ORISSA",
    "district": "HINJILICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761105,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761118,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761126,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764059,
    "state": "ORISSA",
    "district": "NABARANGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764071,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764073,
    "state": "ORISSA",
    "district": "UMERKOTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766014,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767019,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767025,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767033,
    "state": "ORISSA",
    "district": "TITILAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767039,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768106,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768217,
    "state": "ORISSA",
    "district": "BELPAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768231,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768232,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770031,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770039,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781123,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781124,
    "state": "ASSAM",
    "district": "Kamrup",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781316,
    "state": "ASSAM",
    "district": "Barpeta",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782460,
    "state": "ASSAM",
    "district": "Karbi Anglong",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783120,
    "state": "ASSAM",
    "district": "Goalpara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783123,
    "state": "ASSAM",
    "district": "Goalpara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783124,
    "state": "ASSAM",
    "district": "Goalpara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783129,
    "state": "ASSAM",
    "district": "Goalpara",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783360,
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783371,
    "state": "ASSAM",
    "district": "Dhubri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783372,
    "state": "ASSAM",
    "district": "Kokrajhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784505,
    "state": "ASSAM",
    "district": "Sonitpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786170,
    "state": "ASSAM",
    "district": "Tinsukia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788724,
    "state": "ASSAM",
    "district": "Karimganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 794001,
    "state": "MEGHALAYA",
    "district": "TURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801303,
    "state": "BIHAR",
    "district": "NALANDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801504,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803102,
    "state": "BIHAR",
    "district": "BIHAR SHARIFF",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803111,
    "state": "BIHAR",
    "district": "BIHAR SHARIFF",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 804401,
    "state": "BIHAR",
    "district": "ARWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811307,
    "state": "BIHAR",
    "district": "JAMUI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812006,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814113,
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814133,
    "state": "JHARKHAND",
    "district": "GODDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814142,
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814154,
    "state": "JHARKHAND",
    "district": "GODDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 816109,
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 822114,
    "state": "JHARKHAND",
    "district": "GARHWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 822116,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824113,
    "state": "BIHAR",
    "district": "DAUDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824401,
    "state": "BIHAR",
    "district": "ARWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824402,
    "state": "BIHAR",
    "district": "ARWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825314,
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825322,
    "state": "JHARKHAND",
    "district": "BAGODAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825328,
    "state": "JHARKHAND",
    "district": "BAGODAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825401,
    "state": "JHARKHAND",
    "district": "CHATRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825418,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828828,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829111,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829116,
    "state": "JHARKHAND",
    "district": "BOKARO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829132,
    "state": "JHARKHAND",
    "district": "CHANDRAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829209,
    "state": "WEST BENGAL",
    "district": "DAKRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829210,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 833219,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835214,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835223,
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835302,
    "state": "JHARKHAND",
    "district": "LOHARDAGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841226,
    "state": "BIHAR",
    "district": "SIWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841238,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841424,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841438,
    "state": "BIHAR",
    "district": "NAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841501,
    "state": "BIHAR",
    "district": "GOPALGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843031,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844102,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844114,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844122,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844502,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844506,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845302,
    "state": "BIHAR",
    "district": "MOTIHARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845450,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 847239,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851213,
    "state": "BIHAR",
    "district": "KHAGARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854108,
    "state": "BIHAR",
    "district": "KATIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180003,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180006,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180002,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180012,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180013,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180018,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181121,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181152,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181205,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 182101,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190004,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190005,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190009,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441108,
    "state": "MAHARASHTRA",
    "district": "BUTIBORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441122,
    "state": "MAHARASHTRA",
    "district": "BUTIBORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517101,
    "state": "ANDHRA PRADESH",
    "district": "CHANDRAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517194,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517330,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517351,
    "state": "ANDHRA PRADESH",
    "district": "MULAKALACHERUVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517401,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517418,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522311,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522324,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522438,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522619,
    "state": "ANDHRA PRADESH",
    "district": "MARTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523334,
    "state": "ANDHRA PRADESH",
    "district": "CUMBUM -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524226,
    "state": "ANDHRA PRADESH",
    "district": "UDAYAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531126,
    "state": "ANDHRA PRADESH",
    "district": "TUNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534122,
    "state": "ANDHRA PRADESH",
    "district": "MARTERU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534166,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535579,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612103,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614601,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614602,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614604,
    "state": "TAMIL NADU",
    "district": "Thanjavur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623503,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623504,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623526,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623527,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623701,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623704,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623707,
    "state": "TAMIL NADU",
    "district": "Ramanathapuram",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624201,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624304,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624401,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624622,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624709,
    "state": "TAMIL NADU",
    "district": "Dindigul",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625106,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625201,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625218,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625501,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625512,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625516,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625530,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625579,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625601,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625602,
    "state": "TAMIL NADU",
    "district": "Theni",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625703,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625706,
    "state": "TAMIL NADU",
    "district": "Madurai",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626001,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626101,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626115,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626122,
    "state": "TAMIL NADU",
    "district": "Virudhunagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627108,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627117,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627354,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627416,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627751,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627756,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627759,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627809,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627818,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627851,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627855,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627859,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628215,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628216,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628601,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628616,
    "state": "TAMIL NADU",
    "district": "Thoothukkudi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629004,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629156,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629159,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629161,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629162,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629163,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629171,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629173,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629180,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629201,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629252,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629301,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629701,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629804,
    "state": "TAMIL NADU",
    "district": "Kanniyakumari",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630502,
    "state": "TAMIL NADU",
    "district": "Sivaganga",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637015,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637018,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637102,
    "state": "TAMIL NADU",
    "district": "Salem",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637409,
    "state": "TAMIL NADU",
    "district": "Namakkal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638051,
    "state": "TAMIL NADU",
    "district": "Erode",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641652,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641658,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641662,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641663,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641664,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641687,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642118,
    "state": "TAMIL NADU",
    "district": "Tiruppur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642120,
    "state": "TAMIL NADU",
    "district": "Coimbatore",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643211,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643212,
    "state": "TAMIL NADU",
    "district": "The Nilgiris",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 672105,
    "state": "TAMIL NADU",
    "district": "Tirunelveli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722143,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722207,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123001,
    "state": "HARYANA",
    "district": "Mahendragarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123029,
    "state": "HARYANA",
    "district": "Mahendragarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124201,
    "state": "HARYANA",
    "district": "Jhajjar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125011,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125047,
    "state": "HARYANA",
    "district": "Fatehabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125053,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126104,
    "state": "HARYANA",
    "district": "Jind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127028,
    "state": "HARYANA",
    "district": "Bhiwani",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127040,
    "state": "HARYANA",
    "district": "Bhiwani",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127046,
    "state": "HARYANA",
    "district": "Bhiwani",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127308,
    "state": "HARYANA",
    "district": "Bhiwani",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132004,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132022,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132023,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132036,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132041,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132054,
    "state": "HARYANA",
    "district": "Karnal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134011,
    "state": "HARYANA",
    "district": "Ambala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134204,
    "state": "HARYANA",
    "district": "Panchkula",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 135102,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 135133,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140113,
    "state": "PUNJAB",
    "district": "ROPAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140601,
    "state": "PUNJAB",
    "district": "Patiala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140801,
    "state": "HARYANA",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141101,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141106,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141418,
    "state": "PUNJAB",
    "district": "Ludhiana",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143115,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143301,
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143303,
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143416,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143505,
    "state": "PUNJAB",
    "district": "Gurdaspur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143512,
    "state": "PUNJAB",
    "district": "Gurdaspur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143531,
    "state": "PUNJAB",
    "district": "Gurdaspur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144011,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144040,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144102,
    "state": "PUNJAB",
    "district": "ADAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144103,
    "state": "PUNJAB",
    "district": "ADAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144201,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144203,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144204,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144205,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144207,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144208,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144306,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144409,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144621,
    "state": "PUNJAB",
    "district": "Kapurthala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144626,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145023,
    "state": "PUNJAB",
    "district": "Pathankot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146021,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146022,
    "state": "PUNJAB",
    "district": "Hoshiarpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147203,
    "state": "PUNJAB",
    "district": "Fatehgarh Sahib",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148021,
    "state": "PUNJAB",
    "district": "Sangrur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151201,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151202,
    "state": "PUNJAB",
    "district": "Faridkot",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151206,
    "state": "PUNJAB",
    "district": "Bathinda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151501,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152022,
    "state": "PUNJAB",
    "district": "Fazilka",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160056,
    "state": "PUNJAB",
    "district": "Sahibzada Ajit Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171005,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171010,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171207,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171219,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173021,
    "state": "HARYANA",
    "district": "Sirmaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173204,
    "state": "HARYANA",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173209,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173230,
    "state": "HIMACHAL PRADESH",
    "district": "Sirmaur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174013,
    "state": "HIMACHAL PRADESH",
    "district": "Mandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174315,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174507,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175024,
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175124,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR  ( H.P.)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176057,
    "state": "HIMACHAL PRADESH",
    "district": "DHARAMSALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176206,
    "state": "HARYANA",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176216,
    "state": "PUNJAB",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176310,
    "state": "PUNJAB",
    "district": "Chamba",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177204,
    "state": "HARYANA",
    "district": "Una",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180007,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180004,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180010,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180001,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180015,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180016,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180020,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181123,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181133,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181201,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190001,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190003,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190008,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190010,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201201,
    "state": "UTTAR PRADESH",
    "district": "Ghaziabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203209,
    "state": "UTTAR PRADESH",
    "district": "Gautam Buddha Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206247,
    "state": "UTTAR PRADESH",
    "district": "Auraiya",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212201,
    "state": "UTTAR PRADESH",
    "district": "Kaushambi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221206,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221405,
    "state": "UTTAR PRADESH",
    "district": "Varanasi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221711,
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224149,
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225203,
    "state": "UTTAR PRADESH",
    "district": "BaraBanki",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225415,
    "state": "UTTAR PRADESH",
    "district": "BaraBanki",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227817,
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228120,
    "state": "UTTAR PRADESH",
    "district": "Sultanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231304,
    "state": "UTTAR PRADESH",
    "district": "Mirzapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233230,
    "state": "UTTAR PRADESH",
    "district": "Ghazipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241124,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241303,
    "state": "UTTAR PRADESH",
    "district": "Hardoi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242221,
    "state": "UTTAR PRADESH",
    "district": "Shahjahanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243504,
    "state": "UTTAR PRADESH",
    "district": "Rampur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243701,
    "state": "UTTAR PRADESH",
    "district": "Budaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244302,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244304,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244410,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244412,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244501,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244504,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246722,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247664,
    "state": "UTTARAKHAND",
    "district": "Hardwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250401,
    "state": "UTTAR PRADESH",
    "district": "Meerut",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261203,
    "state": "UTTAR PRADESH",
    "district": "Sitapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262001,
    "state": "UTTAR PRADESH",
    "district": "Pilibhit",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262802,
    "state": "UTTAR PRADESH",
    "district": "LAKHIMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262804,
    "state": "UTTAR PRADESH",
    "district": "Kheri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263126,
    "state": "UTTARAKHAND",
    "district": "Nainital",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271302,
    "state": "UTTAR PRADESH",
    "district": "Gonda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272131,
    "state": "UTTAR PRADESH",
    "district": "Basti",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273165,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273301,
    "state": "UTTAR PRADESH",
    "district": "Mahrajganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274204,
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274207,
    "state": "UTTAR PRADESH",
    "district": "Kushinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274407,
    "state": "UTTAR PRADESH",
    "district": "Kushinagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276137,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276304,
    "state": "UTTAR PRADESH",
    "district": "Azamgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 277201,
    "state": "UTTAR PRADESH",
    "district": "Ballia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281123,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284128,
    "state": "UTTAR PRADESH",
    "district": "Jhansi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301408,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301411,
    "state": "RAJASTHAN",
    "district": "Alwar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303012,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303301,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303303,
    "state": "RAJASTHAN",
    "district": "Dausa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303328,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303503,
    "state": "RAJASTHAN",
    "district": "Dausa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303702,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303704,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304001,
    "state": "RAJASTHAN",
    "district": "Tonk",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306001,
    "state": "RAJASTHAN",
    "district": "Pali",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306104,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307026,
    "state": "RAJASTHAN",
    "district": "ABU ROAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312021,
    "state": "RAJASTHAN",
    "district": "Chittaurgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312601,
    "state": "RAJASTHAN",
    "district": "Chittaurgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312605,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313324,
    "state": "RAJASTHAN",
    "district": "Rajsamand",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321401,
    "state": "RAJASTHAN",
    "district": "Bharatpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322201,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331022,
    "state": "RAJASTHAN",
    "district": "Churu",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331403,
    "state": "RAJASTHAN",
    "district": "Churu",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331507,
    "state": "RAJASTHAN",
    "district": "Churu",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332301,
    "state": "RAJASTHAN",
    "district": "Sikar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332311,
    "state": "RAJASTHAN",
    "district": "Sikar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332713,
    "state": "RAJASTHAN",
    "district": "Sikar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332715,
    "state": "RAJASTHAN",
    "district": "Sikar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333001,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333026,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333031,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333042,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333307,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333705,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334803,
    "state": "RAJASTHAN",
    "district": "Bikaner",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335063,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335501,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335513,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335523,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335524,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335701,
    "state": "RAJASTHAN",
    "district": "Ganganagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335803,
    "state": "RAJASTHAN",
    "district": "Hanumangarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343029,
    "state": "RAJASTHAN",
    "district": "Jalor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361140,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361142,
    "state": "GUJARAT",
    "district": "Jamnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361335,
    "state": "GUJARAT",
    "district": "Devbhoomi Dwarka",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362265,
    "state": "GUJARAT",
    "district": "Gir Somnath",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362266,
    "state": "GUJARAT",
    "district": "Gir Somnath",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362268,
    "state": "GUJARAT",
    "district": "Gir Somnath",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363005,
    "state": "TAMIL NADU",
    "district": "Surendranagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363630,
    "state": "GUJARAT",
    "district": "Morbi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364003,
    "state": "GUJARAT",
    "district": "Bhavnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370410,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370415,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370421,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370465,
    "state": "GUJARAT",
    "district": "Kachchh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403109,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403502,
    "state": "GOA",
    "district": "MAPUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403715,
    "state": "GOA",
    "district": "SALCETE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403717,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403727,
    "state": "GOA",
    "district": "MARGAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403804,
    "state": "GOA",
    "district": "VASCO DA GAMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403806,
    "state": "GOA",
    "district": "ZUARI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412801,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413705,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413709,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414001,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414002,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414006,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414111,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416103,
    "state": "MAHARASHTRA",
    "district": "JAISINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416412,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441106,
    "state": "MAHARASHTRA",
    "district": "RAMTEK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441203,
    "state": "MAHARASHTRA",
    "district": "UMRER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441302,
    "state": "MAHARASHTRA",
    "district": "KATOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441501,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441601,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441614,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441904,
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441911,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441912,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442701,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442708,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442901,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442902,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442905,
    "state": "MAHARASHTRA",
    "district": "RAJURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442907,
    "state": "MAHARASHTRA",
    "district": "WARORA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442908,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444105,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444107,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444303,
    "state": "MAHARASHTRA",
    "district": "KHAMGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444505,
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445202,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445203,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445204,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445206,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445304,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450112,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450119,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451111,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451113,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451115,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451224,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451331,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451447,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451551,
    "state": "MADHYA PRADESH",
    "district": "BADWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451659,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451660,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451770,
    "state": "MADHYA PRADESH",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453111,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453115,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453551,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453777,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454111,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454116,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454221,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454276,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454333,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454446,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454449,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454660,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454665,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454773,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455111,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455115,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455116,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455118,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455223,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455332,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455336,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456224,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456331,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456335,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456443,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456771,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457226,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457661,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457772,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457773,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457775,
    "state": "MADHYA PRADESH",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457779,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457887,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457990,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457993,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461111,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461223,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461228,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461251,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465001,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465331,
    "state": "MADHYA PRADESH",
    "district": "Shajapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465441,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465445,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465449,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465661,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465674,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465680,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465683,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465691,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466001,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470113,
    "state": "MADHYA PRADESH",
    "district": "BINA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470124,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473001,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473101,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473112,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473226,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473287,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473770,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480002,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484334,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485005,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487001,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487118,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487221,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487551,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488001,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491003,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491335,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493558,
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493661,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493881,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494226,
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494553,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495117,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495450,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495454,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495689,
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 496225,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 496661,
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497223,
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497442,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497451,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515132,
    "state": "ANDHRA PRADESH",
    "district": "PUTTAPARTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515561,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515809,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515872,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516193,
    "state": "ANDHRA PRADESH",
    "district": "PORUMAMILLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516312,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516326,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516330,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517130,
    "state": "ANDHRA PRADESH",
    "district": "IRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517131,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517139,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517391,
    "state": "ANDHRA PRADESH",
    "district": "MULAKALACHERUVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517504,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518010,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518345,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518599,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521035,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521123,
    "state": "ANDHRA PRADESH",
    "district": "AVANIGADDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521135,
    "state": "ANDHRA PRADESH",
    "district": "KUCHIPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521136,
    "state": "ANDHRA PRADESH",
    "district": "KUCHIPUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521202,
    "state": "ANDHRA PRADESH",
    "district": "NUZVEEDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521211,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521227,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521345,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522123,
    "state": "ANDHRA PRADESH",
    "district": "PONNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522267,
    "state": "ANDHRA PRADESH",
    "district": "BHATTIPROLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522302,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522304,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522318,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522402,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522410,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522549,
    "state": "ANDHRA PRADESH",
    "district": "NARASARAOPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522611,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522615,
    "state": "ANDHRA PRADESH",
    "district": "NAKARIKALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523302,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523327,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523502,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524449,
    "state": "ANDHRA PRADESH",
    "district": "VENKATAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530331,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531026,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531208,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532220,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532290,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532313,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532405,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532460,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533211,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533240,
    "state": "ANDHRA PRADESH",
    "district": "AMBAJIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533251,
    "state": "ANDHRA PRADESH",
    "district": "MALKIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533252,
    "state": "ANDHRA PRADESH",
    "district": "MALKIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533261,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533262,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533289,
    "state": "ANDHRA PRADESH",
    "district": "KORUKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533344,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533346,
    "state": "ANDHRA PRADESH",
    "district": "BIKAVOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533433,
    "state": "ANDHRA PRADESH",
    "district": "PEDDAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533457,
    "state": "ANDHRA PRADESH",
    "district": "SAMALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533462,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533463,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534004,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535204,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535217,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535273,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535350,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560203,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561201,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561204,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561205,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561224,
    "state": "KARNATAKA",
    "district": "CHICKBALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562120,
    "state": "KARNATAKA",
    "district": "RAMANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562121,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562122,
    "state": "KARNATAKA",
    "district": "GOWRIBIDANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562126,
    "state": "KARNATAKA",
    "district": "RAMANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562127,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562138,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562160,
    "state": "KARNATAKA",
    "district": "CHANNAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562203,
    "state": "KARNATAKA",
    "district": "DODDABALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563113,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563117,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563118,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563119,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563121,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563132,
    "state": "KARNATAKA",
    "district": "MULBAGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563146,
    "state": "KARNATAKA",
    "district": "CHINTAMANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563155,
    "state": "KARNATAKA",
    "district": "KOLAR GOLD FIELDS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563162,
    "state": "KARNATAKA",
    "district": "BANGARPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571102,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571107,
    "state": "KARNATAKA",
    "district": "PERYAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571108,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571110,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571118,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571121,
    "state": "KARNATAKA",
    "district": "H D KOTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571122,
    "state": "KARNATAKA",
    "district": "T NARASIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571125,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571134,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571183,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571186,
    "state": "KARNATAKA",
    "district": "MALAVALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571187,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571189,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571213,
    "state": "KARNATAKA",
    "district": "GONIKOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571218,
    "state": "KARNATAKA",
    "district": "VIRAJPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571235,
    "state": "KARNATAKA",
    "district": "KODAGU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571237,
    "state": "KARNATAKA",
    "district": "KODAGU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571253,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571312,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571419,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571421,
    "state": "KARNATAKA",
    "district": "MALAVALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571422,
    "state": "KARNATAKA",
    "district": "MALAVALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571425,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571431,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571435,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571439,
    "state": "KARNATAKA",
    "district": "KOLLEGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571448,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571495,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571501,
    "state": "KARNATAKA",
    "district": "CHANNAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571502,
    "state": "KARNATAKA",
    "district": "CHANNAPATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571603,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571604,
    "state": "KARNATAKA",
    "district": "K.R.NAGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571608,
    "state": "KARNATAKA",
    "district": "K.R.NAGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571610,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571617,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572108,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572110,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572123,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572125,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572128,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572144,
    "state": "KARNATAKA",
    "district": "HIRIYUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572221,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572227,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573102,
    "state": "KARNATAKA",
    "district": "ARAKALAGUDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573115,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573133,
    "state": "KARNATAKA",
    "district": "ARAKALAGUDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573202,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574107,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574109,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574197,
    "state": "KARNATAKA",
    "district": "MOODABIDRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574241,
    "state": "KARNATAKA",
    "district": "PUTTUR -KA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574299,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576108,
    "state": "KARNATAKA",
    "district": "MALPE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576117,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577112,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577124,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577125,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577127,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577142,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577181,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577215,
    "state": "KARNATAKA",
    "district": "CHANNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577218,
    "state": "KARNATAKA",
    "district": "CHANNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577257,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577588,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577598,
    "state": "KARNATAKA",
    "district": "HIRIYUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580010,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580102,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581117,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581123,
    "state": "KARNATAKA",
    "district": "HARIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581208,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581209,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581322,
    "state": "KARNATAKA",
    "district": "SIDDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581403,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581411,
    "state": "KARNATAKA",
    "district": "MUNDGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582109,
    "state": "KARNATAKA",
    "district": "HIREKERUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582114,
    "state": "KARNATAKA",
    "district": "GAJENDREEGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582614,
    "state": "KARNATAKA",
    "district": "TALIKOTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583202,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583221,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583225,
    "state": "KARNATAKA",
    "district": "BHADRAVATHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583268,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583280,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584114,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585221,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585224,
    "state": "KARNATAKA",
    "district": "SHORAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585309,
    "state": "KARNATAKA",
    "district": "SHAHAPUR -KA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585311,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585317,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585324,
    "state": "KARNATAKA",
    "district": "SULEPETH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585328,
    "state": "KARNATAKA",
    "district": "BHALKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586115,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586142,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586157,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586166,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586168,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586209,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587112,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587207,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587302,
    "state": "KARNATAKA",
    "district": "JAMKHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587303,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 589112,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591112,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591120,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591124,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591126,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591316,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602087,
    "state": "TAMIL NADU",
    "district": "VEPPAMPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602088,
    "state": "TAMIL NADU",
    "district": "VEPPAMPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602089,
    "state": "TAMIL NADU",
    "district": "VEPPAMPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602108,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603306,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603406,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604201,
    "state": "TAMIL NADU",
    "district": "GINGEE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604203,
    "state": "TAMIL NADU",
    "district": "GINGEE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604205,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604301,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604304,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605109,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606002,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606105,
    "state": "TAMIL NADU",
    "district": "PENNADAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606206,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606306,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606701,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606702,
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606705,
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606710,
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606754,
    "state": "TAMIL NADU",
    "district": "THIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606801,
    "state": "#N/A",
    "district": "#N/A",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607301,
    "state": "TAMIL NADU",
    "district": "KURINJIPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607302,
    "state": "TAMIL NADU",
    "district": "KURINJIPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607804,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608703,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608704,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621116,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621209,
    "state": "TAMIL NADU",
    "district": "TIRUTTANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623406,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631203,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631505,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632005,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632010,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632011,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632102,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632501,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632505,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632601,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632603,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632604,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635635,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635753,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635754,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700137,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700138,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711205,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712103,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712104,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712137,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712139,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712311,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712331,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712612,
    "state": "WEST BENGAL",
    "district": "Hugli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722150,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722160,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722206,
    "state": "WEST BENGAL",
    "district": "Bankura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731125,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731127,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731220,
    "state": "WEST BENGAL",
    "district": "Birbhum",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732128,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732139,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732202,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732203,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732206,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732207,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732215,
    "state": "WEST BENGAL",
    "district": "Maldah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733127,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733128,
    "state": "WEST BENGAL",
    "district": "ITAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733129,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733131,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733132,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733202,
    "state": "WEST BENGAL",
    "district": "ISLAMPUR (WB)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733211,
    "state": "WEST BENGAL",
    "district": "Uttar Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734103,
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734203,
    "state": "WEST BENGAL",
    "district": "KURSEONG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735122,
    "state": "WEST BENGAL",
    "district": "HALDIBARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735133,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735204,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735224,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735305,
    "state": "WEST BENGAL",
    "district": "Jalpaiguri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736133,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736174,
    "state": "WEST BENGAL",
    "district": "Koch Bihar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736182,
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 737101,
    "state": "SIKKIM",
    "district": "GANGTOK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 737134,
    "state": "SIKKIM",
    "district": "SINGTHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 737136,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741123,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741156,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741167,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741301,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741315,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742121,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742122,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742123,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742133,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742134,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742135,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742136,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742166,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742189,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742227,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742229,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742303,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742304,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742406,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743331,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743347,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743372,
    "state": "WEST BENGAL",
    "district": "JOYNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743377,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743398,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743414,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743429,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743504,
    "state": "WEST BENGAL",
    "district": "Howrah",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752022,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752023,
    "state": "ORISSA",
    "district": "CHANDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752024,
    "state": "ORISSA",
    "district": "CHANDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752031,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752038,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752081,
    "state": "ORISSA",
    "district": "ODAGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752109,
    "state": "ORISSA",
    "district": "KAKATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752110,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754004,
    "state": "ORISSA",
    "district": "MUNDULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754030,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754215,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755001,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755044,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756038,
    "state": "ORISSA",
    "district": "BALHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756056,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757043,
    "state": "ORISSA",
    "district": "RAIRANGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758038,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758083,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759001,
    "state": "ORISSA",
    "district": "DHENKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759018,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761008,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761045,
    "state": "ORISSA",
    "district": "CHATRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761100,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761200,
    "state": "ORISSA",
    "district": "PARLAKHEMUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764020,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764058,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764069,
    "state": "ORISSA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768038,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768218,
    "state": "ORISSA",
    "district": "BELPAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768222,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770072,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 802301,
    "state": "BIHAR",
    "district": "BHOJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 804408,
    "state": "BIHAR",
    "district": "JEHANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811105,
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 813203,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 813213,
    "state": "BIHAR",
    "district": "SULTANGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821115,
    "state": "BIHAR",
    "district": "SASRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821307,
    "state": "BIHAR",
    "district": "DEHRI+ON+SONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832104,
    "state": "JHARKHAND",
    "district": "EASTSINGHBHUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841301,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848210,
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851101,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851116,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851117,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852171,
    "state": "BIHAR",
    "district": "RAGHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124112,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125201,
    "state": "HARYANA",
    "district": "Sirsa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126008,
    "state": "HARYANA",
    "district": "Hisar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132104,
    "state": "HARYANA",
    "district": "KARNAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133103,
    "state": "HARYANA",
    "district": "Yamunanagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136117,
    "state": "HARYANA",
    "district": "Kaithal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140125,
    "state": "HIMACHAL PRADESH",
    "district": "Rupnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140901,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142044,
    "state": "PUNJAB",
    "district": "Firozpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143105,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143107,
    "state": "PUNJAB",
    "district": "Amritsar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143804,
    "state": "PUNJAB",
    "district": "Jalandhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144504,
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144533,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144801,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148107,
    "state": "PUNJAB",
    "district": "Barnala",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152021,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171011,
    "state": "HIMACHAL PRADESH",
    "district": "Shimla",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171102,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173202,
    "state": "HARYANA",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173206,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173211,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173213,
    "state": "HIMACHAL PRADESH",
    "district": "Solan",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174021,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176110,
    "state": "HARYANA",
    "district": "HAMIRPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176201,
    "state": "PUNJAB",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176202,
    "state": "PUNJAB",
    "district": "Kangra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176219,
    "state": "HARYANA",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177006,
    "state": "HARYANA",
    "district": "UNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181124,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184102,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184120,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184121,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190014,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190015,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 191101,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 191201,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192101,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192121,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202411,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202412,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203150,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203408,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203412,
    "state": "UTTAR PRADESH",
    "district": "Bulandshahr",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204101,
    "state": "UTTAR PRADESH",
    "district": "Mahamaya Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204215,
    "state": "UTTAR PRADESH",
    "district": "Aligarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205001,
    "state": "UTTAR PRADESH",
    "district": "Mainpuri",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206122,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 207123,
    "state": "UTTAR PRADESH",
    "district": "Kanshiram Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209721,
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210201,
    "state": "UTTAR PRADESH",
    "district": "Banda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212108,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212301,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221504,
    "state": "UTTAR PRADESH",
    "district": "Allahabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222202,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 223101,
    "state": "UTTAR PRADESH",
    "district": "Jaunpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224141,
    "state": "UTTAR PRADESH",
    "district": "Faizabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227125,
    "state": "UTTAR PRADESH",
    "district": "Lucknow",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229127,
    "state": "UTTAR PRADESH",
    "district": "RAIBARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 230132,
    "state": "UTTAR PRADESH",
    "district": "Pratapgarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 230304,
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231210,
    "state": "UTTAR PRADESH",
    "district": "Sonbhadra",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231501,
    "state": "UTTAR PRADESH",
    "district": "Mirzapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233001,
    "state": "UTTAR PRADESH",
    "district": "Ghazipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243301,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243406,
    "state": "UTTAR PRADESH",
    "district": "Bareilly",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244102,
    "state": "UTTAR PRADESH",
    "district": "Sambhal",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244231,
    "state": "UTTAR PRADESH",
    "district": "Jyotiba Phule Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244402,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244601,
    "state": "UTTAR PRADESH",
    "district": "Moradabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244717,
    "state": "UTTARAKHAND",
    "district": "Udham Singh Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244921,
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245207,
    "state": "UTTAR PRADESH",
    "district": "Hapur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246171,
    "state": "UTTARAKHAND",
    "district": "RISHIKESH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246731,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246747,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246762,
    "state": "UTTAR PRADESH",
    "district": "Bijnor",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247445,
    "state": "UTTAR PRADESH",
    "district": "Saharanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247554,
    "state": "UTTAR PRADESH",
    "district": "Saharanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247662,
    "state": "UTTAR PRADESH",
    "district": "Saharanpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247774,
    "state": "UTTAR PRADESH",
    "district": "Shamli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247777,
    "state": "UTTAR PRADESH",
    "district": "Shamli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249145,
    "state": "UTTARAKHAND",
    "district": "GOPESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250601,
    "state": "UTTAR PRADESH",
    "district": "Baghpat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250609,
    "state": "UTTAR PRADESH",
    "district": "Baghpat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250611,
    "state": "UTTAR PRADESH",
    "district": "Baghpat",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251309,
    "state": "UTTAR PRADESH",
    "district": "Muzaffarnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251318,
    "state": "UTTAR PRADESH",
    "district": "Muzaffarnagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262201,
    "state": "UTTAR PRADESH",
    "district": "Pilibhit",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262401,
    "state": "UTTARAKHAND",
    "district": "Nainital",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271001,
    "state": "UTTAR PRADESH",
    "district": "Gonda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271002,
    "state": "UTTAR PRADESH",
    "district": "Gonda",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271201,
    "state": "UTTAR PRADESH",
    "district": "Balrampur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272175,
    "state": "UTTAR PRADESH",
    "district": "Sant Kabir Nagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273413,
    "state": "UTTAR PRADESH",
    "district": "Gorakhpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274702,
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281121,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281122,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281204,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281406,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281502,
    "state": "UTTAR PRADESH",
    "district": "Mathura",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 283204,
    "state": "UTTAR PRADESH",
    "district": "Firozabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285001,
    "state": "UTTAR PRADESH",
    "district": "Jalaun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303007,
    "state": "RAJASTHAN",
    "district": "Jaipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307027,
    "state": "RAJASTHAN",
    "district": "Sirohi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333704,
    "state": "RAJASTHAN",
    "district": "Jhunjhunun",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416201,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 432001,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440104,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441001,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441002,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441110,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441111,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441224,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441804,
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442507,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443101,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443201,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443301,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444203,
    "state": "MAHARASHTRA",
    "district": "BULDANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444901,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473446,
    "state": "MADHYA PRADESH",
    "district": "Ashoknagar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473793,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475005,
    "state": "MADHYA PRADESH",
    "district": "Gwalior",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475661,
    "state": "UTTAR PRADESH",
    "district": "Datia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476111,
    "state": "MADHYA PRADESH",
    "district": "Morena",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477001,
    "state": "MADHYA PRADESH",
    "district": "Bhind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477116,
    "state": "MADHYA PRADESH",
    "district": "Bhind",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480106,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486885,
    "state": "UTTAR PRADESH",
    "district": "Rewa",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486890,
    "state": "UTTAR PRADESH",
    "district": "Singrauli",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490042,
    "state": "CHHATTISGARH",
    "district": "DURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493221,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495223,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505187,
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614101,
    "state": "TAMIL NADU",
    "district": "Thiruvarur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721133,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721139,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721146,
    "state": "WEST BENGAL",
    "district": "Paschim Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721629,
    "state": "WEST BENGAL",
    "district": "Purba Medinipur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733158,
    "state": "WEST BENGAL",
    "district": "Dakshin Dinajpur",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734201,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734204,
    "state": "WEST BENGAL",
    "district": "KURSEONG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741152,
    "state": "WEST BENGAL",
    "district": "Nadia",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742188,
    "state": "WEST BENGAL",
    "district": "Murshidabad",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743146,
    "state": "WEST BENGAL",
    "district": "North Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743319,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743336,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743343,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743349,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743357,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743371,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743373,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743503,
    "state": "WEST BENGAL",
    "district": "South Twenty Four Parganas",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 744101,
    "state": "ANDAMAN & NICOBAR",
    "district": "PORT BLAIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 744102,
    "state": "ANDAMAN & NICOBAR",
    "district": "PORT BLAIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 744103,
    "state": "ANDAMAN & NICOBAR",
    "district": "PORT BLAIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781319,
    "state": "ASSAM",
    "district": "Barpeta",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781366,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782123,
    "state": "ASSAM",
    "district": "DHING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782126,
    "state": "ASSAM",
    "district": "Morigaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782426,
    "state": "ASSAM",
    "district": "Nagaon",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782480,
    "state": "ASSAM",
    "district": "BOKAJAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782482,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783131,
    "state": "ASSAM",
    "district": "MANKACHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783331,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783334,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783335,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783339,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783345,
    "state": "ASSAM",
    "district": "Kokrajhar",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785601,
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785690,
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785704,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786007,
    "state": "ASSAM",
    "district": "Dibrugarh",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786150,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786151,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786181,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786610,
    "state": "ASSAM",
    "district": "TENGAKHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786611,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788734,
    "state": "ASSAM",
    "district": "Karimganj",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788736,
    "state": "ASSAM",
    "district": "Hailakandi",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791001,
    "state": "ARUNACHAL PRADESH",
    "district": "ALONG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 792103,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 792130,
    "state": "ASSAM",
    "district": "TIRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793150,
    "state": "MEGHALAYA",
    "district": "JOWAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 794111,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 798601,
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799103,
    "state": "TRIPURA",
    "district": "AGARTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799284,
    "state": "TRIPURA",
    "district": "GANDACHARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803108,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803118,
    "state": "BIHAR",
    "district": "BIHAR SHARIFF",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803213,
    "state": "BIHAR",
    "district": "BARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 805110,
    "state": "BIHAR",
    "district": "NAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 813210,
    "state": "BIHAR",
    "district": "SABOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814101,
    "state": "JHARKHAND",
    "district": "DUMKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 821306,
    "state": "BIHAR",
    "district": "DEHRI+ON+SONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841406,
    "state": "BIHAR",
    "district": "SIWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851114,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851204,
    "state": "BIHAR",
    "district": "KHAGARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851210,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 853204,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136034,
    "state": "HARYANA",
    "district": "KAITHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176209,
    "state": "HARYANA",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232104,
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306902,
    "state": "RAJASTHAN",
    "district": "PALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388430,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402201,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403405,
    "state": "GOA",
    "district": "PONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411010,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412210,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416510,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416520,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416602,
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442603,
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611001,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641697,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678555,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721130,
    "state": "WEST BENGAL",
    "district": "PURBA MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722138,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734101,
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742164,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743233,
    "state": "WEST BENGAL",
    "district": "NORTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743268,
    "state": "WEST BENGAL",
    "district": "NORTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743269,
    "state": "WEST BENGAL",
    "district": "NORTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743271,
    "state": "WEST BENGAL",
    "district": "NORTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743292,
    "state": "WEST BENGAL",
    "district": "NORTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768204,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 802119,
    "state": "BIHAR",
    "district": "BUXAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 815354,
    "state": "WEST BENGAL",
    "district": "MIHIJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832402,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854340,
    "state": "BIHAR",
    "district": "BIRPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733125,
    "state": "WEST BENGAL",
    "district": "DAKSHIN DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733141,
    "state": "WEST BENGAL",
    "district": "DAKSHIN DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741507,
    "state": "WEST BENGAL",
    "district": "NADIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125111,
    "state": "HARYANA",
    "district": "FATEHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733126,
    "state": "WEST BENGAL",
    "district": "DAKSHIN DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722136,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344021,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757025,
    "state": "ORISSA",
    "district": "BETNOTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388630,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685583,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442201,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 813221,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365560,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683546,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741165,
    "state": "WEST BENGAL",
    "district": "NADIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686537,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641670,
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721452,
    "state": "WEST BENGAL",
    "district": "PURBA MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344033,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127030,
    "state": "HARYANA",
    "district": "BHIWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125112,
    "state": "HARYANA",
    "district": "HISAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176051,
    "state": "PUNJAB",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344031,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731202,
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344704,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344032,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387130,
    "state": "GUJARAT",
    "district": "KHEDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171213,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173208,
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151211,
    "state": "PUNJAB",
    "district": "MUKTSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174307,
    "state": "HARYANA",
    "district": "UNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 172030,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761010,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731121,
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174011,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364290,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365220,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173233,
    "state": "HARYANA",
    "district": "SOLAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721653,
    "state": "WEST BENGAL",
    "district": "PURBA MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190002,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152124,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176053,
    "state": "PUNJAB",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562104,
    "state": "KARNATAKA",
    "district": "CHICKBALLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756023,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143412,
    "state": "PUNJAB",
    "district": "TARN TARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177201,
    "state": "HARYANA",
    "district": "UNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 172029,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733140,
    "state": "WEST BENGAL",
    "district": "DAKSHIN DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603004,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247344,
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431154,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272155,
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441909,
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334002,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334005,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201311,
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141412,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175121,
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473995,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307022,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174301,
    "state": "HARYANA",
    "district": "UNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142053,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176031,
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473774,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786154,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249205,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246429,
    "state": "UTTARAKHAND",
    "district": "RISHIKESH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145024,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142037,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781313,
    "state": "ASSAM",
    "district": "BAKSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471311,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700163,
    "state": "WEST BENGAL",
    "district": "NORTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160064,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202122,
    "state": "UTTAR PRADESH",
    "district": "KOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 283110,
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321203,
    "state": "RAJASHTHAN",
    "district": "DEEG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388120,
    "state": "GUJRAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389001,
    "state": "GUJRAT",
    "district": "SHEHERA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413305,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444805,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476444,
    "state": "UTTAR PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642005,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642006,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642113,
    "state": "TAMIL NADU",
    "district": "MADATHUKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642123,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642203,
    "state": "TAMIL NADU",
    "district": "MADATHUKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642204,
    "state": "TAMIL NADU",
    "district": "MADATHUKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321608,
    "state": "RAJASHTHAN",
    "district": "MAHWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476229,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243638,
    "state": "UTTAR PRADESH",
    "district": "SAHASWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458883,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341503,
    "state": "RAJASHTHAN",
    "district": "DEGANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331027,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332402,
    "state": "RAJASHTHAN",
    "district": "DANTA RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313205,
    "state": "RAJASHTHAN",
    "district": "MAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387411,
    "state": "GUJRAT",
    "district": "KHEDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341506,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341306,
    "state": "RAJASHTHAN",
    "district": "LADNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473660,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331304,
    "state": "RAJASHTHAN",
    "district": "TARANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313332,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305204,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314026,
    "state": "RAJASHTHAN",
    "district": "SAGWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341509,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635303,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333504,
    "state": "RAJASHTHAN",
    "district": "KHETRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642007,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642101,
    "state": "TAMIL NADU",
    "district": "VALPARAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642106,
    "state": "TAMIL NADU",
    "district": "VALPARAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642129,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642132,
    "state": "TAMIL NADU",
    "district": "UDUMALAIPETTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642206,
    "state": "TAMIL NADU",
    "district": "MADATHUKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641106,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332702,
    "state": "RAJASHTHAN",
    "district": "DANTA RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333029,
    "state": "RAJASHTHAN",
    "district": "CHIRAWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321201,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306101,
    "state": "RAJASHTHAN",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515122,
    "state": "ANDHRA PRADESH",
    "district": "KANDUKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 200742,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244500,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244801,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322001,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333022,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412803,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413106,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413109,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413213,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413216,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413307,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413501,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413606,
    "state": "MAHARASHTRA",
    "district": "OMERGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413801,
    "state": "MAHARASHTRA",
    "district": "BARAMATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415002,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415003,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415004,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415521,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422206,
    "state": "MAHARASHTRA",
    "district": "NIPHAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422303,
    "state": "MAHARASHTRA",
    "district": "NIPHAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422306,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423104,
    "state": "MAHARASHTRA",
    "district": "LONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424206,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425107,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425401,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425409,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506315,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507167,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507306,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507159,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413402,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413507,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424204,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485771,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442101,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412411,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425508,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341505,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761030,
    "state": "ORISSA",
    "district": "KHALLIKOTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413502,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243633,
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507204,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402108,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486226,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412805,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327024,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413116,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483225,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507305,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444403,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507120,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180005,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180011,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483770,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425105,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311020,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485446,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423603,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481880,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303903,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766105,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 822102,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232102,
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232105,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142060,
    "state": "PUNJAB",
    "district": "FIROZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562012,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475686,
    "state": "UTTAR PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423103,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423605,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424105,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425501,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424311,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431509,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402301,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480004,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577123,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577519,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583136,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622407,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626003,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638105,
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742306,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742308,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621310,
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581318,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577536,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325202,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176041,
    "state": "HARYANA",
    "district": "HAMIRPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301702,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228132,
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 562102,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784501,
    "state": "ASSAM",
    "district": "SONITPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127032,
    "state": "HARYANA",
    "district": "BHIWANI",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 190011,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190018,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190023,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192303,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224147,
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 262122,
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 273402,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 284401,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 326038,
    "state": "#N/A",
    "district": "JHALAWAR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 361342,
    "state": "#N/A",
    "district": "DEVBHOOMI DWARKA",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 385565,
    "state": "#N/A",
    "district": "BANAS KANTHA",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 391220,
    "state": "GUJARAT",
    "district": "VADODARA",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 441107,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484774,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508246,
    "state": "ANDHRA PRADESH",
    "district": "HUZURNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521344,
    "state": "ANDHRA PRADESH",
    "district": "KALIDINDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522412,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523183,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534197,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612702,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "NORMAL PICK UP SERVICE AVAILABLE",
    "deliveryStatus": "ALL GOODS"
  },
  {
    "pincode": 460551,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332701,
    "state": "RAJASHTHAN",
    "district": "DANTA RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140413,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303104,
    "state": "RAJASHTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142043,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160054,
    "state": "PUNJAB",
    "district": "SAHIBZADA AJIT SINGH NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171201,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638314,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679330,
    "state": "KERALA",
    "district": "NILAMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721127,
    "state": "WEST BENGAL",
    "district": "PASCHIM MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755007,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508115,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444709,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783135,
    "state": "ASSAM",
    "district": "MANKACHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284405,
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423301,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382705,
    "state": "GUJARAT",
    "district": "MAHESANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341303,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485775,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465447,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175011,
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685619,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676122,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305623,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577556,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686584,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721129,
    "state": "WEST BENGAL",
    "district": "PASCHIM MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311801,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756112,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226028,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143149,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451332,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306708,
    "state": "RAJASTHAN",
    "district": "PALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523253,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263656,
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361345,
    "state": "GUJARAT",
    "district": "DEVBHOOMI DWARKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412202,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412214,
    "state": "MAHARASHTRA",
    "district": "DAUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412301,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413521,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413736,
    "state": "MAHARASHTRA",
    "district": "LONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415311,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415604,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415722,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416404,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423105,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423203,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431123,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431515,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480334,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 496440,
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586128,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721253,
    "state": "WEST BENGAL",
    "district": "PASCHIM MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415301,
    "state": "MAHARASHTRA",
    "district": "KARAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412203,
    "state": "MAHARASHTRA",
    "district": "DAUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385340,
    "state": "GUJARAT",
    "district": "PATAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412303,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403527,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416405,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416301,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415304,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 496107,
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413520,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416211,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140117,
    "state": "HARYANA",
    "district": "RUPNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431503,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458880,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416220,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416509,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403112,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403531,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412302,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416505,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431506,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721151,
    "state": "WEST BENGAL",
    "district": "PURBA MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470235,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584134,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508244,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124106,
    "state": "HARYANA",
    "district": "JHAJJAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146113,
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 206025,
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228151,
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243720,
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248145,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332602,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342037,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382750,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388320,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442505,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444701,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523117,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524301,
    "state": "ANDHRA PRADESH",
    "district": "PODALKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535557,
    "state": "ANDHRA PRADESH",
    "district": "BOBBILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573125,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581116,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582112,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583232,
    "state": "KARNATAKA",
    "district": "KUKNOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583283,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585421,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612503,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614205,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621108,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621212,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621652,
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621704,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627657,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627758,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628202,
    "state": "TAMIL NADU",
    "district": "THOOTHUKKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628801,
    "state": "TAMIL NADU",
    "district": "THOOTHUKKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629158,
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629167,
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629251,
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629801,
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630702,
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636303,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639108,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639202,
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713519,
    "state": "WEST BENGAL",
    "district": "BARDDHAMAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 802101,
    "state": "BIHAR",
    "district": "BUXAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274509,
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394305,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414401,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515408,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516310,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581109,
    "state": "KARNATAKA",
    "district": "HIREKERUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586202,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627414,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670105,
    "state": "KERALA",
    "district": "TELLICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413701,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414202,
    "state": "MAHARASHTRA",
    "district": "BEED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414301,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756126,
    "state": "ORISSA",
    "district": "MARKONA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244413,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680584,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413201,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363421,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614903,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414502,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414603,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614701,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370615,
    "state": "GUJARAT",
    "district": "KACHCHH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464884,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276121,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741127,
    "state": "WEST BENGAL",
    "district": "NADIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533217,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522112,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533235,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743384,
    "state": "WEST BENGAL",
    "district": "SOUTH TWENTY FOUR PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679512,
    "state": "KERALA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227301,
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221112,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470335,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284204,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284301,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284305,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326023,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422202,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423601,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515661,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431131,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284403,
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284126,
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754207,
    "state": "ORISSA",
    "district": "NISCHINTA KOZLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284202,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472336,
    "state": "UTTAR PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472442,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461661,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391210,
    "state": "GUJARAT",
    "district": "VADODARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301022,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523112,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249204,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577423,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464665,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263159,
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584113,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134103,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125113,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363642,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441802,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471606,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585215,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723143,
    "state": "WEST BENGAL",
    "district": "PURULIYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713422,
    "state": "WEST BENGAL",
    "district": "BARDDHAMAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509127,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754140,
    "state": "ORISSA",
    "district": "RAHAMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577426,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722148,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442104,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484661,
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722139,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723130,
    "state": "WEST BENGAL",
    "district": "PURULIYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396150,
    "state": "GUJARAT",
    "district": "VALSAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517422,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460220,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722156,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577514,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249185,
    "state": "UTTARAKHAND",
    "district": "UTTARKASHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147021,
    "state": "PUNJAB",
    "district": "PATIALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470441,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134115,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141005,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141009,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160005,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160028,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160042,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160043,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160045,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160046,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160048,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160052,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160057,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160060,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160066,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160067,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160068,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160069,
    "state": "PUNJAB",
    "district": "SAHIBZADA AJIT SINGH NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160073,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160078,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190012,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247341,
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 277303,
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325221,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326519,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360035,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360375,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360579,
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362225,
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362269,
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363622,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364515,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380056,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394516,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394602,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396170,
    "state": "GUJARAT",
    "district": "VALSAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403108,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403203,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403204,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410005,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411049,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411050,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411208,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412209,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412220,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415639,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415709,
    "state": "MAHARASHTRA",
    "district": "KHED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416310,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421604,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422209,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423107,
    "state": "MAHARASHTRA",
    "district": "SHIRDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424004,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425109,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431514,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431709,
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440021,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442605,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443001,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444905,
    "state": "MAHARASHTRA",
    "district": "MORSHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445205,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460447,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460449,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464668,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484002,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495684,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502255,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503217,
    "state": "ANDHRA PRADESH",
    "district": "MUPKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504231,
    "state": "TELANGANA",
    "district": "MANDAMARRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509103,
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509339,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509351,
    "state": "ANDHRA PRADESH",
    "district": "MARIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509381,
    "state": "TELANGANA",
    "district": "KOTHA KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515511,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517126,
    "state": "ANDHRA PRADESH",
    "district": "IRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610002,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614810,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621203,
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623302,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623501,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623502,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624208,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628617,
    "state": "TAMIL NADU",
    "district": "THOOTHUKKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637004,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637005,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637208,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637503,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637504,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637505,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638115,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639113,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712150,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712504,
    "state": "WEST BENGAL",
    "district": "HUGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732121,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741233,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742237,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743512,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754022,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754035,
    "state": "ORISSA",
    "district": "NUAPATANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754250,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759105,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770033,
    "state": "ORISSA",
    "district": "BIRAMITRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844121,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392005,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743262,
    "state": "WEST BENGAL",
    "district": "GOPALNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125076,
    "state": "HARYANA",
    "district": "SIRSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741256,
    "state": "WEST BENGAL",
    "district": "RANAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712106,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421602,
    "state": "MAHARASHTRA",
    "district": "SHAHAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421603,
    "state": "MAHARASHTRA",
    "district": "SHAHAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414402,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431204,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442903,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444906,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412213,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445103,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464221,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493554,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505460,
    "state": "ANDHRA PRADESH",
    "district": "RAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493225,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444803,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495445,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504302,
    "state": "TELANGANA",
    "district": "SRIRAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756044,
    "state": "ORISSA",
    "district": "GOPALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501504,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403111,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641669,
    "state": "KERALA",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415613,
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145002,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482021,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458990,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415206,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464551,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733143,
    "state": "WEST BENGAL",
    "district": "UTTAR DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732126,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614206,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614625,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441222,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723132,
    "state": "WEST BENGAL",
    "district": "PURULIYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458775,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470117,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621315,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754200,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756048,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723151,
    "state": "WEST BENGAL",
    "district": "PURULIYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442703,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415801,
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761004,
    "state": "WEST BENGAL",
    "district": "BERHAMPORE -WB",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425502,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415305,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733142,
    "state": "WEST BENGAL",
    "district": "DAKSHIN DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506343,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621112,
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767030,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402209,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465679,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465693,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732209,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506143,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383009,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383220,
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414110,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400206,
    "state": "MAHARASHTRA",
    "district": "PANVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641671,
    "state": "KERALA",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605108,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732143,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732144,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764047,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754201,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761106,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793108,
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394320,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394326,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394517,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394520,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412412,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711224,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712712,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450332,
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395101,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759132,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759020,
    "state": "ORISSA",
    "district": "DHENKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764056,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768221,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504107,
    "state": "TELANGANA",
    "district": "BASAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416508,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431109,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713149,
    "state": "WEST BENGAL",
    "district": "BARDDHAMAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184101,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 182121,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193101,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190017,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759119,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402309,
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470226,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503245,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759129,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759126,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759127,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422501,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612204,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244925,
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272153,
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTHNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473002,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482006,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482007,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482016,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482050,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485004,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678018,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621127,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160016,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421103,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413703,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414307,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482056,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503101,
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573165,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606806,
    "state": "TAMIL NADU",
    "district": "THIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712151,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712158,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712411,
    "state": "WEST BENGAL",
    "district": "HUGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712420,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712421,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712422,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712428,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712429,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384318,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627604,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759111,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754295,
    "state": "ORISSA",
    "district": "ATHGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754033,
    "state": "ORISSA",
    "district": "ATHGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754034,
    "state": "ORISSA",
    "district": "ATHGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754036,
    "state": "ORISSA",
    "district": "ATHGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535546,
    "state": "ANDHRA PRADESH",
    "district": "PARVATHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627423,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627428,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628702,
    "state": "TAMIL NADU",
    "district": "THOOTHUKKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638311,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711326,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711323,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711327,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712423,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741312,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483775,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382225,
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711311,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711324,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711325,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274501,
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229404,
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577596,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177104,
    "state": "HARYANA",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629203,
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636203,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620009,
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261403,
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148108,
    "state": "PUNJAB",
    "district": "SANGRUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402106,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517297,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523270,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743211,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759017,
    "state": "ORISSA",
    "district": "DHENKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785614,
    "state": "ASSAM",
    "district": "DERGOAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785634,
    "state": "ASSAM",
    "district": "MARIANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785685,
    "state": "ASSAM",
    "district": "SIBSAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799145,
    "state": "TRIPURA",
    "district": "SUBROOM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743401,
    "state": "WEST BENGAL",
    "district": "BADURIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741248,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743427,
    "state": "WEST BENGAL",
    "district": "BADURIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212303,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577538,
    "state": "KARNATAKA",
    "district": "CHALLAKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721436,
    "state": "WEST BENGAL",
    "district": "MOHANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402103,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741247,
    "state": "WEST BENGAL",
    "district": "RANAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711306,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577452,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507119,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803115,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673310,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743130,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743232,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743251,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743274,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743291,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743297,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743405,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743423,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743437,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743456,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743710,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670692,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522316,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124010,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517326,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577144,
    "state": "KARNATAKA",
    "district": "TARIKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799131,
    "state": "TRIPURA",
    "district": "AGARTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577557,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 171301,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507118,
    "state": "ANDHRA PRADESH",
    "district": "KOTHAGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516444,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755051,
    "state": "ORISSA",
    "district": "KUAKHIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396145,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 560135,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785112,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522401,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585307,
    "state": "KARNATAKA",
    "district": "CHINCHOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841417,
    "state": "BIHAR",
    "district": "MASHRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848122,
    "state": "BIHAR",
    "district": "VAISHALI (BH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613501,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577211,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782125,
    "state": "ASSAM",
    "district": "NAGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142042,
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 147111,
    "state": "PUNJAB",
    "district": "PATIALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176083,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734214,
    "state": "WEST BENGAL",
    "district": "MIRIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480886,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141020,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185131,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202720,
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204213,
    "state": "UTTAR PRADESH",
    "district": "IGLAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204216,
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205125,
    "state": "UTTAR PRADESH",
    "district": "SHIKOHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205151,
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205262,
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205265,
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205301,
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209726,
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247121,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248161,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249409,
    "state": "UTTARAKHAND",
    "district": "HARDWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251307,
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281124,
    "state": "UTTAR PRADESH",
    "district": "VRINDABAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281306,
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281401,
    "state": "UTTAR PRADESH",
    "district": "KOSI KALAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 283104,
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422221,
    "state": "MAHARASHTRA",
    "district": "NIPHAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450017,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471001,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515871,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516380,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517641,
    "state": "ANDHRA PRADESH",
    "district": "SRIKALAHASTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 520005,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581340,
    "state": "KARNATAKA",
    "district": "SIDDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581354,
    "state": "KARNATAKA",
    "district": "BHATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581450,
    "state": "KARNATAKA",
    "district": "SIDDAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582205,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626104,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626112,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626531,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627802,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627807,
    "state": "TAMIL NADU",
    "district": "SENCOTTAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627810,
    "state": "TAMIL NADU",
    "district": "SENCOTTAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627813,
    "state": "TAMIL NADU",
    "district": "SENCOTTAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628007,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638181,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641202,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689549,
    "state": "KERALA",
    "district": "KOZHENCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691007,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691018,
    "state": "KERALA",
    "district": "THATTAMALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691019,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691504,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691518,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691542,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691581,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691584,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691588,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712208,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742148,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742149,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756040,
    "state": "ORISSA",
    "district": "NILAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382870,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582203,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582207,
    "state": "KARNATAKA",
    "district": "NARAGUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691315,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474012,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472001,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143534,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811213,
    "state": "BIHAR",
    "district": "HAWELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210421,
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210426,
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212635,
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245412,
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457550,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444312,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680722,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458667,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284123,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581103,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262404,
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628251,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624308,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212659,
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486111,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581453,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735301,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582211,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263151,
    "state": "UTTARAKHAND",
    "district": "RUDRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735207,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624206,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624802,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382825,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464993,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 852139,
    "state": "BIHAR",
    "district": "SAHARSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451556,
    "state": "MADHYA PRADESH",
    "district": "BADWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143203,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472338,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472366,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 687457,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721455,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811308,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185153,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190020,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193222,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193401,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284419,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202413,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628402,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582123,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690567,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691590,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110601,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110602,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110605,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144025,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605759,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328021,
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495002,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577523,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416219,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145025,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 283135,
    "state": "UTTAR PRADESH",
    "district": "SHIKOHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481661,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 744202,
    "state": "ANDAMAN & NICOBAR",
    "district": "PORT BLAIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464881,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141119,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425404,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321602,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854318,
    "state": "BIHAR",
    "district": "FORBESGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455227,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495671,
    "state": "CHHATTISGARH",
    "district": "CHAMPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 469571,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210129,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761018,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630108,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148033,
    "state": "PUNJAB",
    "district": "SANGRUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624702,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624706,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586205,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586113,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515766,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532410,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532243,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362560,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733133,
    "state": "WEST BENGAL",
    "district": "DAKSHIN DINAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509325,
    "state": "TELANGANA",
    "district": "KOTHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721131,
    "state": "WEST BENGAL",
    "district": "HAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581102,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517569,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635301,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521256,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673309,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678733,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678593,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136156,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177109,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250342,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284404,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284203,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 249141,
    "state": "UTTARAKHAND",
    "district": "BARKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577128,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791120,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631553,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504304,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576229,
    "state": "KARNATAKA",
    "district": "KOTESHWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768030,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458228,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460443,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470119,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224238,
    "state": "UTTAR PRADESH",
    "district": "FAIZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276202,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 191103,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385320,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721423,
    "state": "WEST BENGAL",
    "district": "MECHEDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713145,
    "state": "WEST BENGAL",
    "district": "MANTESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670673,
    "state": "KERALA",
    "district": "KELAKAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695122,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587204,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431007,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415506,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755004,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228145,
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227207,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534280,
    "state": "ANDHRA PRADESH",
    "district": "PALAKOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501121,
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636109,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622502,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628206,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192122,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201015,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 463106,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486331,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623604,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626188,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629501,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629602,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442004,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442005,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442501,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444705,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441913,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444108,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490036,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444706,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444503,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493211,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582120,
    "state": "KARNATAKA",
    "district": "SHIRATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585216,
    "state": "KARNATAKA",
    "district": "HUVINAHADAGALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585326,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585313,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585414,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587206,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380020,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431009,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627128,
    "state": "TAMIL NADU",
    "district": "VALLIOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628651,
    "state": "TAMIL NADU",
    "district": "TISAIYANVILLAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209701,
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713420,
    "state": "WEST BENGAL",
    "district": "BUD BUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148104,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752111,
    "state": "ORISSA",
    "district": "KONARK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421401,
    "state": "MAHARASHTRA",
    "district": "MURBOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402101,
    "state": "MAHARASHTRA",
    "district": "PANVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581348,
    "state": "KARNATAKA",
    "district": "HONNAVARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635701,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303338,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638109,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313211,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382140,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788722,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284206,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341516,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342802,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518583,
    "state": "ANDHRA PRADESH",
    "district": "NANDYAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741401,
    "state": "WEST BENGAL",
    "district": "FULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177202,
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574115,
    "state": "KARNATAKA",
    "district": "SHIRVA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574101,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576001,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576224,
    "state": "KARNATAKA",
    "district": "KUNDAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576230,
    "state": "KARNATAKA",
    "district": "KUNDAPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363310,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364270,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425306,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141104,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148105,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585331,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201017,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494449,
    "state": "CHHATTISGARH",
    "district": "DANTEWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140417,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148106,
    "state": "PUNJAB",
    "district": "PATIALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143601,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522437,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127201,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629502,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713513,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791009,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751029,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122014,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122021,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125034,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132118,
    "state": "HARYANA",
    "district": "KARNAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141309,
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141310,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247111,
    "state": "UTTAR PRADESH",
    "district": "SHAHARANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250006,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281112,
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303011,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400105,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400609,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410107,
    "state": "MAHARASHTRA",
    "district": "PANVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421006,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422106,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422405,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490008,
    "state": "CHHATTISGARH",
    "district": "DURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490012,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491004,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491009,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500123,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500265,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500380,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501323,
    "state": "ANDHRA PRADESH",
    "district": "GAGANPAHAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501507,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531145,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532128,
    "state": "ANDHRA PRADESH",
    "district": "CHEEPURUPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532558,
    "state": "ANDHRA PRADESH",
    "district": "BOBBILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577602,
    "state": "KARNATAKA",
    "district": "HARIHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581125,
    "state": "KARNATAKA",
    "district": "HIREKERUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590013,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602102,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622408,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623303,
    "state": "TAMIL NADU",
    "district": "DEVAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625112,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625113,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625401,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627122,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627433,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628221,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629182,
    "state": "TAMIL NADU",
    "district": "THUCKALAY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629187,
    "state": "TAMIL NADU",
    "district": "THUCKALAY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629188,
    "state": "TAMIL NADU",
    "district": "THUCKALAY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629189,
    "state": "TAMIL NADU",
    "district": "THUCKALAY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629190,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629191,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629195,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629197,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629304,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629504,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629805,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629806,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629807,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629854,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629855,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638302,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641102,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641405,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643222,
    "state": "TAMIL NADU",
    "district": "KOTAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671320,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673651,
    "state": "KERALA",
    "district": "KONDOTTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676308,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676554,
    "state": "KERALA",
    "district": "VALANCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678709,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680124,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 682510,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683524,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683584,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686142,
    "state": "KERALA",
    "district": "VAIKOM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686524,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686549,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689630,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690554,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690563,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690566,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691548,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691625,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695106,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695130,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743155,
    "state": "WEST BENGAL",
    "district": "KHARDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743176,
    "state": "WEST BENGAL",
    "district": "NAIHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743177,
    "state": "WEST BENGAL",
    "district": "AGARPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743436,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753051,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768230,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753000,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462005,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227202,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442706,
    "state": "MAHARASHTRA",
    "district": "RAJURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110079,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121000,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121206,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122000,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123413,
    "state": "HARYANA",
    "district": "DHARUHERA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123504,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123506,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124517,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125057,
    "state": "HARYANA",
    "district": "SIRSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125122,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126001,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126126,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126127,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126128,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 127020,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132119,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132123,
    "state": "HARYANA",
    "district": "KARNAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132152,
    "state": "HARYANA",
    "district": "KARNAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133021,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134110,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134119,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134151,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134152,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140202,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140203,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140502,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140508,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141021,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141027,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141111,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141124,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141301,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141302,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141303,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141306,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141308,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141311,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141317,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141318,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143007,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143010,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143021,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143026,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143036,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143044,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143093,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143104,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143106,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143110,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143306,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143417,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143418,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143421,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143423,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143508,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143510,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143523,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143536,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143537,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143607,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144015,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144046,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144047,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144048,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144049,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144050,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144051,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144052,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144053,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144218,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144225,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144304,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145003,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145021,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 145105,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146006,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148006,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148009,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148036,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148040,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148041,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148042,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148045,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148046,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148047,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148049,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148050,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148051,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151110,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152102,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152103,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152120,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152131,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160006,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160007,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160021,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160035,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160050,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160051,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160053,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160063,
    "state": "PUNJAB",
    "district": "MOHALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160106,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 170001,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173002,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173004,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175022,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR  ( H.P.)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201106,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201202,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201205,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201300,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202117,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202305,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202392,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203121,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203145,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203208,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204103,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204105,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204106,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 204207,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 208039,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209608,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209624,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209744,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209800,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210009,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210010,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210011,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210012,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212410,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221111,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221113,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221210,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221211,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221506,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221605,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222103,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222104,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222107,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224211,
    "state": "UTTAR PRADESH",
    "district": "FAIZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224220,
    "state": "UTTAR PRADESH",
    "district": "FAIZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224401,
    "state": "UTTAR PRADESH",
    "district": "FAIZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227106,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227208,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232112,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242222,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243124,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243125,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243127,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243204,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243205,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243208,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243215,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243408,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243643,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244224,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244226,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245102,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245406,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245408,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247672,
    "state": "UTTAR PRADESH",
    "district": "SHAHARANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248110,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248116,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248126,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248147,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248201,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250007,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250010,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250013,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250102,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 250105,
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263143,
    "state": "UTTARAKHAND",
    "district": "RUDRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263146,
    "state": "UTTARAKHAND",
    "district": "RUDRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263154,
    "state": "UTTARAKHAND",
    "district": "RUDRAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271211,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271212,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271214,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271857,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272102,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274122,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275107,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281503,
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284407,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301017,
    "state": "RAJASTHAN",
    "district": "BHIWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301031,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301033,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301419,
    "state": "RAJASTHAN",
    "district": "BHIWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301421,
    "state": "RAJASTHAN",
    "district": "BHIWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301422,
    "state": "RAJASTHAN",
    "district": "BHIWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301424,
    "state": "RAJASTHAN",
    "district": "BHIWADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301711,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302000,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302035,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302051,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302052,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302053,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302054,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302055,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303112,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303113,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303114,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303115,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303116,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303117,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303118,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303209,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303306,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303307,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303308,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303314,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303610,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303703,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303705,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303902,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304005,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304805,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304807,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305805,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305820,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313013,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313014,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313021,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313033,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384004,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384174,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384175,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384176,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384178,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384207,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384271,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384273,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384278,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384440,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387421,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389352,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391773,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394211,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394212,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394296,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395016,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395018,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395210,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396006,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396021,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396031,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396106,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396107,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396175,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396194,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396196,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396201,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396202,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396211,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396217,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396223,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396236,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396523,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396525,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400040,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400041,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400044,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400046,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400047,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400048,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400073,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400611,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400613,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400617,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400700,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401505,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 403514,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410211,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410217,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410219,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413009,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413010,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413125,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413126,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413127,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416125,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416423,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416425,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416426,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416428,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416429,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416618,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416622,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416802,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421205,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421206,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421300,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422107,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422216,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422503,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425117,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425120,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425123,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425124,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425125,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425126,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425130,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425131,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425132,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425135,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425136,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431100,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440038,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442909,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442910,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442911,
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR -MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444308,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452019,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 452056,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455002,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455003,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455048,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455112,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455113,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455114,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456002,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456008,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456009,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473229,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474040,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474042,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474050,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 474055,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485002,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485003,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490013,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490015,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490027,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490028,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492011,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507004,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638602,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638603,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638606,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638652,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641061,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641064,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641065,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670015,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670016,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670564,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670565,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670566,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670603,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670605,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670614,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670615,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676110,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676111,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676310,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676313,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676314,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676315,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676318,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676511,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676512,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676513,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676515,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678019,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678020,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678558,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678559,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678575,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678589,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678600,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678609,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678614,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678615,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678616,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686107,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686108,
    "state": "KERALA",
    "district": "CHANGANACHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686550,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686600,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686627,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686638,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686640,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686641,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686642,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689516,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689518,
    "state": "KERALA",
    "district": "TIRUVALLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691318,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691320,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691335,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691514,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691539,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691545,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691546,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691547,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691580,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691587,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691603,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691604,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691623,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691624,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691641,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 701101,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 701102,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 701111,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711001,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711247,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711320,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713161,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713308,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721662,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721666,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722103,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722107,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723159,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723164,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723167,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732001,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732104,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732149,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732151,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732155,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732156,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732157,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732158,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732159,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732160,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732161,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732162,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732163,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734016,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734402,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734407,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736136,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736180,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736181,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741314,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741318,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742109,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742124,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742150,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742152,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742157,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742162,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742167,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742176,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742177,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742178,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742179,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742180,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742181,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742182,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742183,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742190,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742191,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743250,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743316,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743369,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743380,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743388,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743397,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753025,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753052,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753071,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755040,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755042,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756071,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756072,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756074,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756136,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759131,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759133,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759134,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759135,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759137,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759138,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759139,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759144,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760031,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760033,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760034,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764008,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764083,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765031,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767003,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767004,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767005,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767006,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768011,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769032,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782010,
    "state": "ASSAM",
    "district": "NAOGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786053,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786054,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786124,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826015,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 826106,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601105,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601207,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601208,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601209,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601210,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601211,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601212,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601213,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601214,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601295,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603115,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603119,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603120,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603121,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603122,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603316,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603408,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624006,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624007,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624008,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624009,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624010,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629051,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629183,
    "state": "TAMIL NADU",
    "district": "THUCKALAY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629196,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629205,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629404,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629706,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629707,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629708,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629808,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450006,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450334,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466002,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 430507,
    "state": "GOA",
    "district": "PANJIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572161,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574159,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574161,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574162,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574189,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575021,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575024,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575027,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577503,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581131,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581132,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581141,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581142,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581143,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581152,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581177,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581178,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581179,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581191,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581229,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583144,
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583148,
    "state": "KARNATAKA",
    "district": "KUDLIGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583204,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583265,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583270,
    "state": "KARNATAKA",
    "district": "THORANAGALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584119,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584150,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515232,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515426,
    "state": "ANDHRA PRADESH",
    "district": "NARPALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515427,
    "state": "ANDHRA PRADESH",
    "district": "NARPALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516166,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517621,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364215,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363412,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364457,
    "state": "GUJARAT",
    "district": "GONDAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364536,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626541,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626184,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624052,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621128,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473785,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612608,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781385,
    "state": "ASSAM",
    "district": "RANGIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782107,
    "state": "ASSAM",
    "district": "NAOGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783338,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783344,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783351,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783362,
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783374,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784162,
    "state": "ASSAM",
    "district": "BIHPURIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784503,
    "state": "ASSAM",
    "district": "RANGAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785011,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785694,
    "state": "ASSAM",
    "district": "SONARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786172,
    "state": "ASSAM",
    "district": "DIGBOI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626569,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621023,
    "state": "TAMIL NADU",
    "district": "THURAIYUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623001,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623002,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623216,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623318,
    "state": "TAMIL NADU",
    "district": "DEVAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623721,
    "state": "TAMIL NADU",
    "district": "PARAMAKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624504,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585240,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582212,
    "state": "KARNATAKA",
    "district": "NARAGUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382831,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582220,
    "state": "KARNATAKA",
    "district": "RON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396245,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638664,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362221,
    "state": "GUJARAT",
    "district": "KESHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638671,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362733,
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363424,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363426,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364241,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364245,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364293,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364297,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626211,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493330,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585364,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626144,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364712,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364713,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364714,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424209,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450124,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384153,
    "state": "GUJARAT",
    "district": "SIDDHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584153,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364220,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385215,
    "state": "GUJARAT",
    "district": "CHHAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385315,
    "state": "GUJARAT",
    "district": "DHANERA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385541,
    "state": "GUJARAT",
    "district": "DEESA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385543,
    "state": "GUJARAT",
    "district": "DEESA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364560,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364601,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391241,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391245,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393111,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364561,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364225,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 561219,
    "state": "KARNATAKA",
    "district": "GAURIBIDANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364570,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623565,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364524,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577153,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423209,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622206,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577572,
    "state": "KARNATAKA",
    "district": "MOLAKALMURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450118,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473338,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431526,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458588,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585257,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450223,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788702,
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454345,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623309,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582217,
    "state": "KARNATAKA",
    "district": "RON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454350,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582228,
    "state": "KARNATAKA",
    "district": "NARAGUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582234,
    "state": "KARNATAKA",
    "district": "NARAGUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582236,
    "state": "KARNATAKA",
    "district": "RON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583149,
    "state": "KARNATAKA",
    "district": "KUDITHINI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583266,
    "state": "KARNATAKA",
    "district": "KARATAGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584110,
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584201,
    "state": "KARNATAKA",
    "district": "SHAKTINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585241,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587123,
    "state": "KARNATAKA",
    "district": "BADAMI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585251,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585263,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585266,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585334,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585341,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585345,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585346,
    "state": "KARNATAKA",
    "district": "BASAVAKALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585349,
    "state": "KARNATAKA",
    "district": "BASAVAKALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585350,
    "state": "KARNATAKA",
    "district": "BASAVAKALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585423,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585424,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585425,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587126,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587128,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587145,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587146,
    "state": "KARNATAKA",
    "district": "ILKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587147,
    "state": "KARNATAKA",
    "district": "ILKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626165,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587210,
    "state": "KARNATAKA",
    "district": "BADAMI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587317,
    "state": "KARNATAKA",
    "district": "BANHATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587328,
    "state": "KARNATAKA",
    "district": "MUDHOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626176,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362259,
    "state": "GUJARAT",
    "district": "VERAVAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497437,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450220,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450335,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451110,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451112,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454448,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585272,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458442,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460005,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461335,
    "state": "MADHYA PRADESH",
    "district": "HARDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465336,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466119,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470662,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622052,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475677,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475684,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624051,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476235,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480664,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486343,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585273,
    "state": "KARNATAKA",
    "district": "SHAHAPUR -KA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577177,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585362,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450053,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413547,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413560,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626179,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416321,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416322,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423304,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425106,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625577,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425439,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585279,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585280,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585378,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585270,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441919,
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585284,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585285,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755029,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755035,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755037,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480116,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582230,
    "state": "KARNATAKA",
    "district": "GAJENDREEGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455117,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461224,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461225,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328034,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624233,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577442,
    "state": "KARNATAKA",
    "district": "KOPPA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473333,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486342,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471401,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465418,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461427,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613207,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471505,
    "state": "MADHYA PRADESH",
    "district": "KHAJURAHO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461555,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614731,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454667,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465672,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458676,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622508,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454730,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454749,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626601,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626515,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626553,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624104,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624107,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624108,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625117,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624231,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624318,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384154,
    "state": "GUJARAT",
    "district": "SIDDHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624624,
    "state": "TAMIL NADU",
    "district": "ODDANCHATRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624627,
    "state": "TAMIL NADU",
    "district": "PALANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626154,
    "state": "TAMIL NADU",
    "district": "SRIVILLIPUTTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587133,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626164,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626175,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464670,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388544,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627815,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636816,
    "state": "TAMIL NADU",
    "district": "PENNAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637109,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637217,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389344,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391460,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641116,
    "state": "TAMIL NADU",
    "district": "METTUPALAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641303,
    "state": "TAMIL NADU",
    "district": "METTUPALAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641304,
    "state": "TAMIL NADU",
    "district": "METTUPALAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623611,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442310,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626160,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385326,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626145,
    "state": "TAMIL NADU",
    "district": "SIVAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415210,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523125,
    "state": "ANDHRA PRADESH",
    "district": "SINGARAYAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643229,
    "state": "TAMIL NADU",
    "district": "KOTAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756161,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380012,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683553,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642124,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531110,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574165,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574173,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574179,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574180,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574266,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 575009,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222112,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360583,
    "state": "GUJARAT",
    "district": "PORBUNDER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363535,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363626,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442103,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494002,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494005,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516441,
    "state": "ANDHRA PRADESH",
    "district": "JAMMALAMADAGU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517143,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532524,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533202,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533203,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534127,
    "state": "ANDHRA PRADESH",
    "district": "ACHANTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534137,
    "state": "ANDHRA PRADESH",
    "district": "ATTLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534271,
    "state": "ANDHRA PRADESH",
    "district": "NARASAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571160,
    "state": "KARNATAKA",
    "district": "T NARASIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571174,
    "state": "KARNATAKA",
    "district": "T NARASIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571184,
    "state": "KARNATAKA",
    "district": "T NARASIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571185,
    "state": "KARNATAKA",
    "district": "T NARASIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571327,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571331,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571334,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571337,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571479,
    "state": "KARNATAKA",
    "district": "KOLLEGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571493,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571498,
    "state": "KARNATAKA",
    "district": "KOLLEGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571499,
    "state": "KARNATAKA",
    "district": "KOLLEGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573145,
    "state": "KARNATAKA",
    "district": "SAKLESHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573150,
    "state": "KARNATAKA",
    "district": "ARAKALAGUDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577212,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581185,
    "state": "KARNATAKA",
    "district": "BHATKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581223,
    "state": "KARNATAKA",
    "district": "YELLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581224,
    "state": "KARNATAKA",
    "district": "YELLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584159,
    "state": "KARNATAKA",
    "district": "MADDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586229,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591137,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591140,
    "state": "KARNATAKA",
    "district": "BAILAHONGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591177,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591191,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591194,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591292,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591333,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627912,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632320,
    "state": "TAMIL NADU",
    "district": "ARNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632321,
    "state": "TAMIL NADU",
    "district": "ARNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638201,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638203,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638204,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638206,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641120,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642051,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642115,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642116,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642131,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642138,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642145,
    "state": "TAMIL NADU",
    "district": "KINATHUKADAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642147,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642153,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643210,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643247,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643264,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643265,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643269,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643277,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643278,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670354,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673338,
    "state": "KERALA",
    "district": "NADAKKAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689616,
    "state": "KERALA",
    "district": "RANNY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713162,
    "state": "WEST BENGAL",
    "district": "GUSKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713167,
    "state": "WEST BENGAL",
    "district": "GUSKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713173,
    "state": "WEST BENGAL",
    "district": "GUSKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713366,
    "state": "WEST BENGAL",
    "district": "BARAKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713367,
    "state": "WEST BENGAL",
    "district": "BARAKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733212,
    "state": "WEST BENGAL",
    "district": "DALKHOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733213,
    "state": "WEST BENGAL",
    "district": "DALKHOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733214,
    "state": "WEST BENGAL",
    "district": "DALKHOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743443,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752043,
    "state": "ORISSA",
    "district": "BASUDEVPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752059,
    "state": "ORISSA",
    "district": "JANLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752095,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761039,
    "state": "ORISSA",
    "district": "KHALLIKOTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761145,
    "state": "ORISSA",
    "district": "ASKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110101,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110102,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110103,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110104,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110105,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110106,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110107,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110108,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110109,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110112,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110113,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110114,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110115,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110116,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110117,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110118,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110119,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110120,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110121,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110122,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110124,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110125,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110302,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110401,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110402,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110403,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110501,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110503,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122211,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222108,
    "state": "UTTAR PRADESH",
    "district": "JOUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222110,
    "state": "UTTAR PRADESH",
    "district": "JOUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313012,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313303,
    "state": "RAJASTHAN",
    "district": "NATHDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313338,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313608,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321035,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321209,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321429,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322231,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325007,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325226,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326040,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327030,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331401,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331510,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331804,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332045,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332407,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332410,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332726,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332729,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332739,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333045,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333306,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341313,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341527,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341535,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341539,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341544,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341545,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341546,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341547,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341550,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342032,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342804,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343031,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343034,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344015,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361336,
    "state": "GUJARAT",
    "district": "DWARKA -GJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364022,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370202,
    "state": "GUJARAT",
    "district": "GANDHIDHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380057,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380062,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382051,
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382160,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382310,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382360,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382655,
    "state": "GUJARAT",
    "district": "KALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382716,
    "state": "GUJARAT",
    "district": "KALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382733,
    "state": "GUJARAT",
    "district": "KALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382736,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382743,
    "state": "GUJARAT",
    "district": "KALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382826,
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388122,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388435,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391242,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391347,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392013,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392031,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393016,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394010,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396112,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396425,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400106,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402100,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402123,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410200,
    "state": "MAHARASHTRA",
    "district": "PANVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411201,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413122,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413237,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413245,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413540,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413541,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413569,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413615,
    "state": "MAHARASHTRA",
    "district": "OMERGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414404,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415531,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415532,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421032,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421051,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421307,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421313,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421507,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421607,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425434,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425521,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425523,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431531,
    "state": "MAHARASHTRA",
    "district": "AMBEJOGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441114,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441115,
    "state": "MAHARASHTRA",
    "district": "BUTIBORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441216,
    "state": "MAHARASHTRA",
    "district": "UMRER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441503,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441606,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441808,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441920,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441930,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442204,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443110,
    "state": "MAHARASHTRA",
    "district": "BULDANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443207,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444307,
    "state": "MAHARASHTRA",
    "district": "KHAMGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444718,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444811,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444818,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444826,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444914,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445212,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445311,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453463,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453562,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453576,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453643,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453652,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457111,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457551,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457552,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457769,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462006,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462017,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462025,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462028,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462029,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462034,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490010,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 494775,
    "state": "CHHATTISGARH",
    "district": "DURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500177,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500178,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500252,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500253,
    "state": "TELANGANA",
    "district": "MOGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500267,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500361,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500457,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500482,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500594,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500605,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500659,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500660,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500762,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500890,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501201,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506010,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509218,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521176,
    "state": "ANDHRA PRADESH",
    "district": "JAGGHAIAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522116,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522294,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531303,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533439,
    "state": "ANDHRA PRADESH",
    "district": "PEDDAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570013,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571321,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571322,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571325,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571328,
    "state": "KARNATAKA",
    "district": "KUSHALNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 572145,
    "state": "KARNATAKA",
    "district": "TUMKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577149,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577152,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577159,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577161,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577165,
    "state": "KARNATAKA",
    "district": "BIRUR KA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577580,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580117,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580214,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581161,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581225,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581226,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582124,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582131,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582135,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582214,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582221,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582227,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582231,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582237,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583133,
    "state": "KARNATAKA",
    "district": "HARAPANAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 590012,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591133,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591169,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591181,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591198,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591339,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601303,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601304,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602022,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602028,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602029,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602030,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602031,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602109,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602111,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602112,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602113,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602114,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603011,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603048,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605113,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605116,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605118,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605503,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605604,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605605,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606914,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607051,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607305,
    "state": "TAMIL NADU",
    "district": "NEYVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607307,
    "state": "TAMIL NADU",
    "district": "NEYVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607404,
    "state": "TAMIL NADU",
    "district": "NEYVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620052,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623304,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624209,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624218,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625124,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626549,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627126,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627702,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628051,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628153,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628154,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628155,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628223,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628803,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631057,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631060,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631061,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631104,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631105,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631401,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631404,
    "state": "TAMIL NADU",
    "district": "TIRUVALLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631602,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632051,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632052,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632053,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632054,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632108,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632208,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632522,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632524,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632525,
    "state": "TAMIL NADU",
    "district": "CHEYYAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632605,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632606,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635818,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635825,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635856,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638666,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638668,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638802,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639204,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641404,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641408,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670109,
    "state": "KERALA",
    "district": "TELLICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670312,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670313,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670314,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670315,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670316,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670317,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670318,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670319,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670321,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670322,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670330,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670332,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670333,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670337,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670338,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670339,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670343,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670346,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670522,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670583,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670677,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670695,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671535,
    "state": "KERALA",
    "district": "KANHANGAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673126,
    "state": "KERALA",
    "district": "KALPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673320,
    "state": "KERALA",
    "district": "TELLICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673578,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673648,
    "state": "KERALA",
    "district": "KONDOTTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673649,
    "state": "KERALA",
    "district": "KONDOTTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676516,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676518,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676520,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676556,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676557,
    "state": "KERALA",
    "district": "KUTTIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678509,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678511,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678513,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678585,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678586,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678634,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678637,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678761,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679310,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679311,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679314,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679517,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679518,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679556,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679633,
    "state": "KERALA",
    "district": "KUNNAMKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680603,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680692,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680693,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680694,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680695,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680698,
    "state": "KERALA",
    "district": "IRINJALAKUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683582,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683583,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683586,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685005,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686145,
    "state": "KERALA",
    "district": "VAIKOM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686614,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686620,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686723,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686726,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688558,
    "state": "KERALA",
    "district": "CHERTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689660,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689706,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690541,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690543,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690552,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690553,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690555,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690556,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690557,
    "state": "KERALA",
    "district": "ALLEPPEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690568,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690569,
    "state": "KERALA",
    "district": "OACHIRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691321,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691324,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691325,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691326,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691329,
    "state": "KERALA",
    "district": "PUNALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691513,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691517,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691519,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691529,
    "state": "KERALA",
    "district": "KOTTARAKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695120,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695127,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695128,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695323,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695509,
    "state": "KERALA",
    "district": "NEYYATTINKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695560,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695566,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695618,
    "state": "KERALA",
    "district": "NEDUMKANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711406,
    "state": "WEST BENGAL",
    "district": "HOOGLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712703,
    "state": "WEST BENGAL",
    "district": "HOOGLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713310,
    "state": "WEST BENGAL",
    "district": "PANURIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721123,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721138,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722159,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723150,
    "state": "WEST BENGAL",
    "district": "ASANSOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723157,
    "state": "WEST BENGAL",
    "district": "ASANSOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723158,
    "state": "WEST BENGAL",
    "district": "ASANSOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723165,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723166,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723214,
    "state": "WEST BENGAL",
    "district": "JHALDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731134,
    "state": "WEST BENGAL",
    "district": "DUBRAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731135,
    "state": "WEST BENGAL",
    "district": "BAKRESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731217,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731246,
    "state": "WEST BENGAL",
    "district": "SAINTHIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731250,
    "state": "WEST BENGAL",
    "district": "AMTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731253,
    "state": "WEST BENGAL",
    "district": "SAINTHIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731284,
    "state": "WEST BENGAL",
    "district": "AHMADPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733144,
    "state": "WEST BENGAL",
    "district": "RAIGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733146,
    "state": "WEST BENGAL",
    "district": "GANGARAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733148,
    "state": "WEST BENGAL",
    "district": "GANGARAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733149,
    "state": "WEST BENGAL",
    "district": "GANGARAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733157,
    "state": "WEST BENGAL",
    "district": "RAIGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734225,
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735138,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735236,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735306,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736132,
    "state": "WEST BENGAL",
    "district": "DINHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741111,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741168,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741170,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741173,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741174,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741177,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741182,
    "state": "WEST BENGAL",
    "district": "BETHUADAHARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741183,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741184,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741185,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741188,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741193,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741195,
    "state": "WEST BENGAL",
    "district": "BETHUADAHARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741198,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741243,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741403,
    "state": "WEST BENGAL",
    "district": "FULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742230,
    "state": "WEST BENGAL",
    "district": "RAGHUNATHGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742232,
    "state": "WEST BENGAL",
    "district": "DHULIAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743164,
    "state": "WEST BENGAL",
    "district": "NAIHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743301,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743313,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743352,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743353,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743358,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743506,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743517,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743705,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754015,
    "state": "ORISSA",
    "district": "TRISULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754080,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754252,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755033,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755048,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756140,
    "state": "ORISSA",
    "district": "BASUDEVPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758042,
    "state": "ORISSA",
    "district": "BARBIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758051,
    "state": "ORISSA",
    "district": "BARBIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758052,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759140,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761053,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766025,
    "state": "ORISSA",
    "district": "KESINGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766113,
    "state": "ORISSA",
    "district": "NUAPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768117,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768223,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768229,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783387,
    "state": "ASSAM",
    "district": "GOALPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784120,
    "state": "ASSAM",
    "district": "DHEKIAJULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785660,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785695,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786615,
    "state": "ASSAM",
    "district": "NAHARKATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786624,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787029,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464556,
    "state": "MADHYA PRADESH",
    "district": "MANDIDEEP (RAISEN)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721502,
    "state": "WEST BENGAL",
    "district": "FULKUSHMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571613,
    "state": "KARNATAKA",
    "district": "K.R.NAGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571616,
    "state": "KARNATAKA",
    "district": "K.R.NAGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591262,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591320,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591503,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110502,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451555,
    "state": "GUJARAT",
    "district": "ANJAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451557,
    "state": "GUJARAT",
    "district": "ANJAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533224,
    "state": "ANDHRA PRADESH",
    "district": "AMBAJIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533225,
    "state": "ANDHRA PRADESH",
    "district": "AMBAJIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721459,
    "state": "WEST BENGAL",
    "district": "BELDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721460,
    "state": "WEST BENGAL",
    "district": "BELDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110504,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110506,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110507,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110508,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110509,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110510,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110511,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110512,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110603,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110604,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110606,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110607,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110608,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 110609,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333038,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333517,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413241,
    "state": "MAHARASHTRA",
    "district": "PANDHARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413316,
    "state": "MAHARASHTRA",
    "district": "PANDHARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516271,
    "state": "ANDHRA PRADESH",
    "district": "RAYACHOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522274,
    "state": "ANDHRA PRADESH",
    "district": "REPALLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522279,
    "state": "ANDHRA PRADESH",
    "district": "REPALLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522282,
    "state": "ANDHRA PRADESH",
    "district": "REPALLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605809,
    "state": "TAMIL NADU",
    "district": "KALLAKURUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626706,
    "state": "TAMIL NADU",
    "district": "THIRUMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626709,
    "state": "TAMIL NADU",
    "district": "THIRUMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626712,
    "state": "TAMIL NADU",
    "district": "THIRUMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626719,
    "state": "TAMIL NADU",
    "district": "THIRUMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360335,
    "state": "GUJARAT",
    "district": "GONDAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363636,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364292,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364660,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383002,
    "state": "GUJARAT",
    "district": "HIMMATNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384152,
    "state": "GUJARAT",
    "district": "SIDDHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385325,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389158,
    "state": "GUJARAT",
    "district": "DAHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391442,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392162,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413563,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415120,
    "state": "MAHARASHTRA",
    "district": "KARAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415618,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415707,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415631,
    "state": "MAHARASHTRA",
    "district": "CHIPLUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416317,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416624,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416625,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424116,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424117,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425204,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425437,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441605,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441923,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442308,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443306,
    "state": "MAHARASHTRA",
    "district": "BULDANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451117,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466003,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515214,
    "state": "ANDHRA PRADESH",
    "district": "HINDUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515233,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574138,
    "state": "KARNATAKA",
    "district": "KARKALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577235,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577582,
    "state": "KARNATAKA",
    "district": "HOLALKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581426,
    "state": "KARNATAKA",
    "district": "SIRSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582232,
    "state": "KARNATAKA",
    "district": "NARAGUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582241,
    "state": "KARNATAKA",
    "district": "GADAG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583151,
    "state": "KARNATAKA",
    "district": "KUDITHINI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583141,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583273,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585286,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585289,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585109,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585344,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585250,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585261,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585264,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585268,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585361,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585336,
    "state": "KARNATAKA",
    "district": "CHINCHOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585339,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585360,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585340,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585342,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585347,
    "state": "KARNATAKA",
    "district": "BASAVAKALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585352,
    "state": "KARNATAKA",
    "district": "HUMNABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585429,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585432,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585433,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585441,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587213,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587215,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587319,
    "state": "KARNATAKA",
    "district": "BANHATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587320,
    "state": "KARNATAKA",
    "district": "BANHATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609813,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613051,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613054,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613052,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614632,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626181,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622056,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622105,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623554,
    "state": "TAMIL NADU",
    "district": "RAMNAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624054,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624305,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624310,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624053,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624230,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626516,
    "state": "TAMIL NADU",
    "district": "CUMBUM -TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626530,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626501,
    "state": "TAMIL NADU",
    "district": "PERIYAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626052,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626055,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626058,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626147,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626150,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626162,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626195,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626157,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626148,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627767,
    "state": "TAMIL NADU",
    "district": "SIVAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626180,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626171,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627765,
    "state": "TAMIL NADU",
    "district": "KADAYANALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627819,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627817,
    "state": "TAMIL NADU",
    "district": "SENCOTTAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623005,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623211,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623006,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623003,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623004,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623209,
    "state": "TAMIL NADU",
    "district": "DEVAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623317,
    "state": "TAMIL NADU",
    "district": "DEVAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624502,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624503,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623606,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623613,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635133,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635138,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635139,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635140,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635141,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635134,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635137,
    "state": "KARNATAKA",
    "district": "HOSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635209,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636751,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638130,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638653,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638696,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639144,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641115,
    "state": "TAMIL NADU",
    "district": "METTUPALAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638658,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765012,
    "state": "ORISSA",
    "district": "JAYKAPUR CHANDLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321616,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321618,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321636,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321637,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322232,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322233,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325225,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326503,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331020,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331034,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332409,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332413,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332730,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332734,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332740,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332735,
    "state": "RAJASTHAN",
    "district": "SRI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333044,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335527,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335528,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335806,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335807,
    "state": "RAJASTHAN",
    "district": "SURATGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362013,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362224,
    "state": "GUJARAT",
    "district": "KESHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362626,
    "state": "GUJARAT",
    "district": "KESHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364615,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362727,
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363333,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363669,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363665,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363667,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382043,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382155,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382352,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382709,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382718,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382731,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382737,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382871,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382875,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384211,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384231,
    "state": "GUJARAT",
    "district": "PATAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393018,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394114,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402118,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402124,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410410,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412113,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413121,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413240,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413244,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413242,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413243,
    "state": "MAHARASHTRA",
    "district": "BARSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413539,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413543,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413542,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414405,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416117,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416132,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425127,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415570,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431139,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431528,
    "state": "MAHARASHTRA",
    "district": "AMBEJOGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442110,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442205,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442207,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443405,
    "state": "MAHARASHTRA",
    "district": "BULDANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444122,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444703,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444721,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443305,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444727,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444716,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444812,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444815,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444821,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445003,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445213,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450333,
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500486,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500768,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500484,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507129,
    "state": "ANDHRA PRADESH",
    "district": "BHADRACHALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515736,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515752,
    "state": "ANDHRA PRADESH",
    "district": "KALYANDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515844,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515814,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518515,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515813,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515833,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515866,
    "state": "ANDHRA PRADESH",
    "district": "RAYADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515862,
    "state": "ANDHRA PRADESH",
    "district": "RAYADURGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516116,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516153,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516165,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516506,
    "state": "ANDHRA PRADESH",
    "district": "PORUMAMILLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516272,
    "state": "ANDHRA PRADESH",
    "district": "RAYACHOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518115,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518016,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518021,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518022,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518023,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518015,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518017,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518019,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518020,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518011,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518137,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518138,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518150,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518382,
    "state": "ANDHRA PRADESH",
    "district": "GUNTAKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518426,
    "state": "ANDHRA PRADESH",
    "district": "ATAMAKUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518675,
    "state": "ANDHRA PRADESH",
    "district": "NANDYAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518555,
    "state": "ANDHRA PRADESH",
    "district": "JAMMALAMADAGU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521112,
    "state": "ANDHRA PRADESH",
    "district": "HANUMAN JUNCTION",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521124,
    "state": "ANDHRA PRADESH",
    "district": "AVANIGADDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521155,
    "state": "ANDHRA PRADESH",
    "district": "KANKIPADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521144,
    "state": "ANDHRA PRADESH",
    "district": "KANKIPADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521265,
    "state": "ANDHRA PRADESH",
    "district": "KANKIPADU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522180,
    "state": "ANDHRA PRADESH",
    "district": "CHILLAKALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521179,
    "state": "ANDHRA PRADESH",
    "district": "CHILLAKALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521391,
    "state": "ANDHRA PRADESH",
    "district": "MACHILIPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521338,
    "state": "ANDHRA PRADESH",
    "district": "KAIKALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521370,
    "state": "ANDHRA PRADESH",
    "district": "MACHILIPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521436,
    "state": "ANDHRA PRADESH",
    "district": "CHILLAKALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522024,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522036,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522026,
    "state": "ANDHRA PRADESH",
    "district": "AMARAVATHI -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522050,
    "state": "ANDHRA PRADESH",
    "district": "AMARAVATHI -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522008,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522125,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522278,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522280,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522297,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522298,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522321,
    "state": "ANDHRA PRADESH",
    "district": "BAPATLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522332,
    "state": "ANDHRA PRADESH",
    "district": "DUGGIRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522407,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522515,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522631,
    "state": "ANDHRA PRADESH",
    "district": "VINUKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522630,
    "state": "ANDHRA PRADESH",
    "district": "VINUKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523121,
    "state": "ANDHRA PRADESH",
    "district": "SINGARAYAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523194,
    "state": "ANDHRA PRADESH",
    "district": "CHIRALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532501,
    "state": "ANDHRA PRADESH",
    "district": "VINUKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523219,
    "state": "ANDHRA PRADESH",
    "district": "MEDARAMETLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523243,
    "state": "ANDHRA PRADESH",
    "district": "PODILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523267,
    "state": "ANDHRA PRADESH",
    "district": "PODILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523277,
    "state": "ANDHRA PRADESH",
    "district": "TANGUTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523297,
    "state": "ANDHRA PRADESH",
    "district": "TANGUTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530019,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530010,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530006,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530039,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530030,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530025,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 530042,
    "state": "ANDHRA PRADESH",
    "district": "VISHAKAPATNAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532417,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532599,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532612,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532617,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532663,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532550,
    "state": "ANDHRA PRADESH",
    "district": "PALAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532485,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533014,
    "state": "ANDHRA PRADESH",
    "district": "KAKINADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533258,
    "state": "ANDHRA PRADESH",
    "district": "RAZOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533566,
    "state": "ANDHRA PRADESH",
    "district": "AMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533333,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533409,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534015,
    "state": "ANDHRA PRADESH",
    "district": "ELURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534108,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534291,
    "state": "ANDHRA PRADESH",
    "district": "NARASAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534314,
    "state": "ANDHRA PRADESH",
    "district": "KOYALAGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534407,
    "state": "ANDHRA PRADESH",
    "district": "TADEPALIIGUDEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531201,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531203,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531204,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531217,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531220,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531270,
    "state": "ANDHRA PRADESH",
    "district": "GAJAPATHINAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532573,
    "state": "ANDHRA PRADESH",
    "district": "BOBBILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532579,
    "state": "ANDHRA PRADESH",
    "district": "BOBBILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532591,
    "state": "ANDHRA PRADESH",
    "district": "SALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571137,
    "state": "KARNATAKA",
    "district": "KOLLEGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571133,
    "state": "KARNATAKA",
    "district": "HUNSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571132,
    "state": "KARNATAKA",
    "district": "HUNSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571264,
    "state": "KARNATAKA",
    "district": "VIRAJPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571156,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571332,
    "state": "KARNATAKA",
    "district": "NANJANGUD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571437,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577568,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573147,
    "state": "KARNATAKA",
    "district": "ARAKALAGUDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573160,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574158,
    "state": "KARNATAKA",
    "district": "MULKY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577148,
    "state": "KARNATAKA",
    "district": "CHIKMAGALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577150,
    "state": "KARNATAKA",
    "district": "THIRTHAHALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577234,
    "state": "KARNATAKA",
    "district": "CHANNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577571,
    "state": "KARNATAKA",
    "district": "CHALLAKERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577591,
    "state": "KARNATAKA",
    "district": "RANEBENNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580110,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580115,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580116,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580216,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581124,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581140,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 580212,
    "state": "KARNATAKA",
    "district": "HUBLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581127,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581166,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581150,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581167,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581176,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581192,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581170,
    "state": "KARNATAKA",
    "district": "RANEBENNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581236,
    "state": "KARNATAKA",
    "district": "RANEBENNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581183,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581153,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581172,
    "state": "KARNATAKA",
    "district": "HAVERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581158,
    "state": "KARNATAKA",
    "district": "HIREKERUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581190,
    "state": "KARNATAKA",
    "district": "HIREKERUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581159,
    "state": "KARNATAKA",
    "district": "SAVANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581228,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581231,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582238,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 582243,
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583138,
    "state": "KARNATAKA",
    "district": "KUDLIGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584151,
    "state": "KARNATAKA",
    "district": "LINGASUGUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 584144,
    "state": "KARNATAKA",
    "district": "LINGASUGUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585269,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585276,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585249,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585275,
    "state": "KARNATAKA",
    "district": "YADGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586107,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586136,
    "state": "KARNATAKA",
    "district": "BIJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586150,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586235,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586241,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586245,
    "state": "KARNATAKA",
    "district": "MUDDEBIHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587135,
    "state": "KARNATAKA",
    "district": "JAMKHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587321,
    "state": "KARNATAKA",
    "district": "JAMKHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587323,
    "state": "KARNATAKA",
    "district": "JAMKHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591175,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591163,
    "state": "KARNATAKA",
    "district": "BAILAHONGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591190,
    "state": "KARNATAKA",
    "district": "BAILAHONGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591701,
    "state": "KARNATAKA",
    "district": "BAILAHONGALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591151,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591155,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591189,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591264,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591273,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591299,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591512,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591283,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591255,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591516,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591269,
    "state": "KARNATAKA",
    "district": "NIPPANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591280,
    "state": "KARNATAKA",
    "district": "NIPPANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591284,
    "state": "KARNATAKA",
    "district": "NIPPANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591256,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591249,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591327,
    "state": "KARNATAKA",
    "district": "ATHNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591318,
    "state": "KARNATAKA",
    "district": "GOKAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591506,
    "state": "KARNATAKA",
    "district": "GOKAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591297,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591332,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610051,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620051,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623535,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623545,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623546,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625052,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624222,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636815,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625114,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625116,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625126,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625111,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625051,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627051,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627305,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627419,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627551,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627770,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627768,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627905,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627701,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627727,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632607,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632608,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635611,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638058,
    "state": "TAMIL NADU",
    "district": "PERUNDURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642146,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642054,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642052,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642053,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642055,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638669,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642119,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642152,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642148,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642149,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642142,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642143,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642144,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642139,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642137,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642140,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643051,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643260,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643053,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643257,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643054,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643256,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643258,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643259,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643279,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643052,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643261,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643250,
    "state": "TAMIL NADU",
    "district": "GUDALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643245,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643276,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712154,
    "state": "WEST BENGAL",
    "district": "BANDEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712155,
    "state": "WEST BENGAL",
    "district": "BANDEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712156,
    "state": "WEST BENGAL",
    "district": "BANDEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721163,
    "state": "WEST BENGAL",
    "district": "DEBRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721164,
    "state": "WEST BENGAL",
    "district": "DEBRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721169,
    "state": "WEST BENGAL",
    "district": "MECHEDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721307,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721660,
    "state": "WEST BENGAL",
    "district": "MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721668,
    "state": "WEST BENGAL",
    "district": "TAMLUK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731144,
    "state": "WEST BENGAL",
    "district": "BAKRESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731146,
    "state": "WEST BENGAL",
    "district": "BAKRESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731247,
    "state": "WEST BENGAL",
    "district": "AHMADPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731249,
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733147,
    "state": "WEST BENGAL",
    "district": "BUNIADPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733150,
    "state": "WEST BENGAL",
    "district": "KALIAGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735235,
    "state": "WEST BENGAL",
    "district": "MAYNAGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735307,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741104,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741196,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741169,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741236,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742231,
    "state": "WEST BENGAL",
    "district": "DHULIAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743393,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743402,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743505,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743508,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743507,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743612,
    "state": "WEST BENGAL",
    "district": "KALYANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752112,
    "state": "ORISSA",
    "district": "PIPILI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755046,
    "state": "ORISSA",
    "district": "SUKINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756052,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756053,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756054,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766112,
    "state": "ORISSA",
    "district": "KESINGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768116,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768120,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768051,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781130,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786630,
    "state": "ASSAM",
    "district": "NAMRUP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412407,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425436,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451327,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577567,
    "state": "KARNATAKA",
    "district": "BANGALORE123",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577577,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587209,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587211,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587242,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591253,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591268,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591343,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591507,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638471,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638469,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752042,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752036,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752033,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752044,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752117,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761136,
    "state": "ORISSA",
    "district": "ASKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768046,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591162,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591180,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628657,
    "state": "TAMIL NADU",
    "district": "TISAIYANVILLAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713160,
    "state": "WEST BENGAL",
    "district": "ANDAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721165,
    "state": "WEST BENGAL",
    "district": "CHANDRAKONA ROAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721257,
    "state": "WEST BENGAL",
    "district": "CHANDRAKONA ROAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721258,
    "state": "WEST BENGAL",
    "district": "CHANDRAKONA ROAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741190,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741192,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382270,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 688584,
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743382,
    "state": "WEST BENGAL",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743390,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743396,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743514,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743608,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532270,
    "state": "ANDHRA PRADESH",
    "district": "KONDAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532101,
    "state": "ANDHRA PRADESH",
    "district": "AMADALAVALASA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532189,
    "state": "ANDHRA PRADESH",
    "district": "AMADALAVALASA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534303,
    "state": "ANDHRA PRADESH",
    "district": "NIDADAVOLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534351,
    "state": "ANDHRA PRADESH",
    "district": "CHAGALLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516102,
    "state": "ANDHRA PRADESH",
    "district": "KODUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516103,
    "state": "ANDHRA PRADESH",
    "district": "KODUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515416,
    "state": "ANDHRA PRADESH",
    "district": "TADPATRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515419,
    "state": "ANDHRA PRADESH",
    "district": "TADPATRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515421,
    "state": "ANDHRA PRADESH",
    "district": "TADPATRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523269,
    "state": "ANDHRA PRADESH",
    "district": "THROVAGUNTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533133,
    "state": "ANDHRA PRADESH",
    "district": "KADIYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522608,
    "state": "ANDHRA PRADESH",
    "district": "NARASARAOPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522620,
    "state": "ANDHRA PRADESH",
    "district": "NARASARAOPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522511,
    "state": "ANDHRA PRADESH",
    "district": "MANGALAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518550,
    "state": "ANDHRA PRADESH",
    "district": "ALLAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416134,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416145,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416224,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431146,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441117,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442912,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451337,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451435,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451552,
    "state": "MADHYA PRADESH",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451661,
    "state": "MADHYA PRADESH",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451663,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451664,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451665,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451667,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451669,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451695,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464676,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574264,
    "state": "KARNATAKA",
    "district": "BANTWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591159,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591168,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591183,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591188,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591328,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591504,
    "state": "KARNATAKA",
    "district": "RAMDURG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627725,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627911,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643251,
    "state": "TAMIL NADU",
    "district": "GUDALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670144,
    "state": "KERALA",
    "district": "TALIPARAMBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670732,
    "state": "KERALA",
    "district": "WAYANAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671125,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671128,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671328,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671329,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671341,
    "state": "KERALA",
    "district": "CHERUVATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671344,
    "state": "KERALA",
    "district": "CHERUVATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671345,
    "state": "KERALA",
    "district": "CHERUVATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671349,
    "state": "KERALA",
    "district": "CHERUVATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671350,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671353,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671357,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671545,
    "state": "KERALA",
    "district": "KASARGOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673333,
    "state": "KERALA",
    "district": "NADAKKAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673530,
    "state": "KERALA",
    "district": "PAYYOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673644,
    "state": "KERALA",
    "district": "MANJERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673650,
    "state": "KERALA",
    "district": "FEROKE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673652,
    "state": "KERALA",
    "district": "FEROKE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673653,
    "state": "KERALA",
    "district": "FEROKE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676126,
    "state": "KERALA",
    "district": "MANJERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676127,
    "state": "KERALA",
    "district": "MANJERI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678605,
    "state": "KERALA",
    "district": "ALANALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679124,
    "state": "KERALA",
    "district": "SHORANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679125,
    "state": "KERALA",
    "district": "SHORANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679343,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679344,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679348,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679350,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679354,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679355,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679356,
    "state": "KERALA",
    "district": "PATTAMBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679588,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679589,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680593,
    "state": "KERALA",
    "district": "GURUVAYOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680672,
    "state": "KERALA",
    "district": "KODUNGALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680735,
    "state": "KERALA",
    "district": "TRICHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683523,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683525,
    "state": "KERALA",
    "district": "NORTH PAROOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683554,
    "state": "KERALA",
    "district": "ANGAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683555,
    "state": "KERALA",
    "district": "ANGAMALY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 683593,
    "state": "KERALA",
    "district": "ALWAYE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685592,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685597,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685621,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686124,
    "state": "KERALA",
    "district": "ERATTPETTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686523,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686527,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686565,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686588,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686589,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686590,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686591,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686592,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686594,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686597,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686654,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686655,
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686676,
    "state": "KERALA",
    "district": "VAZHAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686680,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686683,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686686,
    "state": "KERALA",
    "district": "COCHIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686694,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686695,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686696,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686697,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686698,
    "state": "KERALA",
    "district": "KOTHAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689629,
    "state": "KERALA",
    "district": "MANNAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689632,
    "state": "KERALA",
    "district": "MALLAPPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690109,
    "state": "KERALA",
    "district": "MAVELIKARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690560,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690564,
    "state": "KERALA",
    "district": "CHARUMOODU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 690570,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691317,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691330,
    "state": "KERALA",
    "district": "PATHANAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695105,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695314,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695315,
    "state": "KERALA",
    "district": "ATTINGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695544,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695557,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721252,
    "state": "WEST BENGAL",
    "district": "WEST MIDNAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721254,
    "state": "WEST BENGAL",
    "district": "WEST MIDNAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721259,
    "state": "WEST BENGAL",
    "district": "WEST MIDNAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752096,
    "state": "ORISSA",
    "district": "JAGATSINGHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754017,
    "state": "ORISSA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754115,
    "state": "ORISSA",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754229,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754230,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754232,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754233,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754247,
    "state": "ORISSA",
    "district": "BALESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754282,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754284,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754285,
    "state": "ORISSA",
    "district": "BALESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756082,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761051,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761113,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761127,
    "state": "ORISSA",
    "district": "ASKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761134,
    "state": "ORISSA",
    "district": "NABARANGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768043,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628707,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643106,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768047,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638406,
    "state": "TAMIL NADU",
    "district": "SATHYAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636463,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637508,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344028,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360585,
    "state": "GUJARAT",
    "district": "PORBUNDER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125021,
    "state": "HARYANA",
    "district": "BHIWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783304,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783305,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783306,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783307,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783308,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783309,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783310,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783311,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783312,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783313,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783314,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783315,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783316,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783317,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783318,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783319,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783320,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783321,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783322,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799252,
    "state": "TRIPURA",
    "district": "BAGBASSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781150,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502320,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502779,
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506012,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 512200,
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501539,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508216,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500000,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500264,
    "state": "TELANGANA",
    "district": "MOGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500475,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500991,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500146,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500170,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500472,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500476,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500488,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500960,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 599991,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180008,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 111105,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 111112,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 111114,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 111120,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 111121,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190013,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175010,
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303102,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721518,
    "state": "WEST BENGAL",
    "district": "FULKUSHMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721519,
    "state": "WEST BENGAL",
    "district": "FULKUSHMA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721466,
    "state": "WEST BENGAL",
    "district": "BELDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784002,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784003,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784004,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785012,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785016,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785018,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785020,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785057,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785623,
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785624,
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785627,
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785628,
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785677,
    "state": "ASSAM",
    "district": "MORANHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785678,
    "state": "ASSAM",
    "district": "MORANHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785679,
    "state": "ASSAM",
    "district": "AMGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786121,
    "state": "ASSAM",
    "district": "CHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786629,
    "state": "ASSAM",
    "district": "NAMRUP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786684,
    "state": "ASSAM",
    "district": "NAMRUP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787027,
    "state": "ASSAM",
    "district": "GOGAMUKH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787160,
    "state": "ASSAM",
    "district": "DHEMAJI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 838303,
    "state": "JHARKHAND",
    "district": "LOHARDAGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754261,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757012,
    "state": "ORISSA",
    "district": "BARIPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765062,
    "state": "ORISSA",
    "district": "GUNUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767091,
    "state": "ORISSA",
    "district": "TALCHER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767184,
    "state": "ORISSA",
    "district": "TALCHER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768130,
    "state": "ORISSA",
    "district": "DEOGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768142,
    "state": "ORISSA",
    "district": "DEOGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711120,
    "state": "WEST BENGAL",
    "district": "BALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711212,
    "state": "WEST BENGAL",
    "district": "BALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712224,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712344,
    "state": "WEST BENGAL",
    "district": "KONNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712365,
    "state": "WEST BENGAL",
    "district": "ASANSOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713431,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 715513,
    "state": "WEST BENGAL",
    "district": "KATWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721162,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721315,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721630,
    "state": "WEST BENGAL",
    "district": "TAMLUK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721638,
    "state": "WEST BENGAL",
    "district": "PANSKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721664,
    "state": "WEST BENGAL",
    "district": "TAMLUK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722170,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722171,
    "state": "WEST BENGAL",
    "district": "KHATRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722172,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722179,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722180,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722181,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731203,
    "state": "WEST BENGAL",
    "district": "RAMPURHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731212,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731251,
    "state": "WEST BENGAL",
    "district": "RAMPURHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731252,
    "state": "WEST BENGAL",
    "district": "RAMPURHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732236,
    "state": "WEST BENGAL",
    "district": "FARAKKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732312,
    "state": "WEST BENGAL",
    "district": "FARAKKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733154,
    "state": "WEST BENGAL",
    "district": "GANGARAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733155,
    "state": "WEST BENGAL",
    "district": "BALURGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733246,
    "state": "WEST BENGAL",
    "district": "HARIRAMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733302,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734333,
    "state": "WEST BENGAL",
    "district": "SHIVMANDIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735152,
    "state": "WEST BENGAL",
    "district": "BALURGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735238,
    "state": "WEST BENGAL",
    "district": "MALBAZAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735503,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735505,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741186,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741187,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741225,
    "state": "WEST BENGAL",
    "district": "RANAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741510,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741511,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741512,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741513,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741514,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741515,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741516,
    "state": "WEST BENGAL",
    "district": "BAGULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742000,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743001,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743200,
    "state": "WEST BENGAL",
    "district": "BARRACKPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743212,
    "state": "WEST BENGAL",
    "district": "BARRACKPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743296,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743511,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743516,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 747273,
    "state": "WEST BENGAL",
    "district": "SWARUPNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753121,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753127,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753132,
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754157,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754158,
    "state": "ORISSA",
    "district": "JAGATSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754161,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754281,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754283,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754287,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741171,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741179,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741197,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711415,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712307,
    "state": "WEST BENGAL",
    "district": "HOOGLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713174,
    "state": "WEST BENGAL",
    "district": "MEMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741194,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742185,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743605,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761021,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786631,
    "state": "ASSAM",
    "district": "NAMRUP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752028,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752029,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752067,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768100,
    "state": "ORISSA",
    "district": "BARGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761038,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759036,
    "state": "ORISSA",
    "district": "DHENKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722177,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722145,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722165,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743304,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743339,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743392,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743601,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743603,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743604,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743606,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743607,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721141,
    "state": "WEST BENGAL",
    "district": "JHARGRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752006,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752058,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752086,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754016,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754156,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754234,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754280,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754286,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756078,
    "state": "ORISSA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761036,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761040,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761112,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761128,
    "state": "ORISSA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761135,
    "state": "ORISSA",
    "district": "THIRUVANANTHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768114,
    "state": "ORISSA",
    "district": "PALAKKAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 726206,
    "state": "WEST BENGAL",
    "district": "ALIPURDWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743486,
    "state": "WEST BENGAL",
    "district": "BADURIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743244,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743299,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743440,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743744,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713518,
    "state": "WEST BENGAL",
    "district": "KATWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721174,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721363,
    "state": "WEST BENGAL",
    "district": "TAMLUK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732013,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732706,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734318,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734325,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734428,
    "state": "WEST BENGAL",
    "district": "MATIGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734430,
    "state": "WEST BENGAL",
    "district": "BAGDOGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734432,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734433,
    "state": "WEST BENGAL",
    "district": "SHIVMANDIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742307,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743004,
    "state": "WEST BENGAL",
    "district": "RAMPURHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743101,
    "state": "WEST BENGAL",
    "district": "BARRACKPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743102,
    "state": "WEST BENGAL",
    "district": "BARRACKPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743120,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743121,
    "state": "WEST BENGAL",
    "district": "KHARDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743170,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743188,
    "state": "WEST BENGAL",
    "district": "TITAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743266,
    "state": "WEST BENGAL",
    "district": "HABRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753023,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 753027,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755021,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756018,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759031,
    "state": "ORISSA",
    "district": "DHENKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760032,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 763036,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768205,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785203,
    "state": "WEST BENGAL",
    "district": "BINNAGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736162,
    "state": "WEST BENGAL",
    "district": "JAIGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752041,
    "state": "ORISSA",
    "district": "SAKHIGOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713706,
    "state": "WEST BENGAL",
    "district": "GALSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785232,
    "state": "WEST BENGAL",
    "district": "BINNAGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721170,
    "state": "WEST BENGAL",
    "district": "MIDNAPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 733216,
    "state": "WEST BENGAL",
    "district": "SILIGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722163,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700404,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 700408,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736358,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799011,
    "state": "TRIPURA",
    "district": "BISALGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713164,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713317,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713345,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713379,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713382,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713387,
    "state": "WEST BENGAL",
    "district": "DURGAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721142,
    "state": "WEST BENGAL",
    "district": "MECHEDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721665,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721669,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721670,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723160,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723163,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732145,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732148,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732152,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732153,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732154,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736166,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736257,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742131,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742139,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742169,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742170,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742172,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742173,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742186,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743322,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743360,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743381,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743394,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 751062,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754020,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755039,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755041,
    "state": "ORISSA",
    "district": "JAJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756009,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756017,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756057,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756073,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756075,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756076,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756077,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756110,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759114,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759136,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 759142,
    "state": "ORISSA",
    "district": "ANGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760020,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 760100,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764012,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764022,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764054,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764082,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765028,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765030,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769018,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 769019,
    "state": "ORISSA",
    "district": "ROURKELA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786052,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721661,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785604,
    "state": "ASSAM",
    "district": "SARUPATHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786180,
    "state": "ASSAM",
    "district": "DIGBOI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788790,
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761034,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 762108,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 762111,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764053,
    "state": "ORISSA",
    "district": "MALKANGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722178,
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713374,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721256,
    "state": "WEST BENGAL",
    "district": "KHIRPAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722110,
    "state": "WEST BENGAL",
    "district": "SONAMUKHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722111,
    "state": "WEST BENGAL",
    "district": "SONAMUKHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722112,
    "state": "WEST BENGAL",
    "district": "SONAMUKHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722209,
    "state": "WEST BENGAL",
    "district": "SONAMUKHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735237,
    "state": "WEST BENGAL",
    "district": "FALAKATA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743391,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754116,
    "state": "ORISSA",
    "district": "BIRIDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711416,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713159,
    "state": "WEST BENGAL",
    "district": "SAMUDRAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723162,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723216,
    "state": "WEST BENGAL",
    "district": "JHALDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741178,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741180,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741199,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742403,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743288,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743295,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743311,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743379,
    "state": "WEST BENGAL",
    "district": "CANNING TOWN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743441,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743700,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743706,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743708,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754014,
    "state": "ORISSA",
    "district": "BANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754070,
    "state": "ORISSA",
    "district": "CHARBATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754118,
    "state": "ORISSA",
    "district": "BENTAKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754241,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756050,
    "state": "ORISSA",
    "district": "BARIPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758033,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758054,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758061,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825327,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 678581,
    "state": "KERALA",
    "district": "PALGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695523,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464886,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415109,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180121,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180133,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273408,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410308,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410615,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410707,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411000,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411054,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411055,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411056,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411099,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411100,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411105,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411107,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411125,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411220,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411230,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411406,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411412,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411501,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 411925,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412001,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412309,
    "state": "MAHARASHTRA",
    "district": "BARAMATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412310,
    "state": "MAHARASHTRA",
    "district": "BARAMATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413019,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413117,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413123,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413124,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413128,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413129,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413225,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413254,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413270,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413413,
    "state": "MAHARASHTRA",
    "district": "BARSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413535,
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413565,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413566,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413567,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413568,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413570,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413572,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413573,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413574,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413579,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413612,
    "state": "MAHARASHTRA",
    "district": "OMERGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414004,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414011,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414107,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414109,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414112,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414206,
    "state": "MAHARASHTRA",
    "district": "BEED",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414578,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414702,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414703,
    "state": "MAHARASHTRA",
    "district": "DAUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414709,
    "state": "MAHARASHTRA",
    "district": "DAUND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415005,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415016,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415017,
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415119,
    "state": "MAHARASHTRA",
    "district": "KARAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 415417,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416009,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416014,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416015,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416019,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416022,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416034,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416123,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416127,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416137,
    "state": "MAHARASHTRA",
    "district": "GADHINGLAJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416227,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416228,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416320,
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416536,
    "state": "MAHARASHTRA",
    "district": "GADHINGLAJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416541,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416607,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416621,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416809,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 418010,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 418101,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 418110,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 418115,
    "state": "MAHARASHTRA",
    "district": "KANKAVLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422108,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422111,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422217,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422220,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423116,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423305,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423704,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424003,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424026,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424027,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424113,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424312,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424313,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424315,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 424316,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425118,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425119,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425121,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425122,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425128,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425129,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425133,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425134,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425202,
    "state": "MAHARASHTRA",
    "district": "BHUSAWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425211,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425312,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425313,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425314,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425316,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425317,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425319,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425321,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425322,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425323,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425324,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425325,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425326,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425336,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425429,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425443,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425445,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425448,
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425449,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425451,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425453,
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425509,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425511,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425512,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425515,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425517,
    "state": "MAHARASHTRA",
    "district": "BHUSAWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425518,
    "state": "MAHARASHTRA",
    "district": "BHUSAWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425519,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425520,
    "state": "MAHARASHTRA",
    "district": "BHUSAWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431108,
    "state": "MAHARASHTRA",
    "district": "PAITHAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431119,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431138,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431200,
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431201,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431406,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431539,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443105,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443109,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443111,
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461109,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362267,
    "state": "GUJARAT",
    "district": "VERAVAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363007,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389351,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363646,
    "state": "GUJARAT",
    "district": "MORBI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383004,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384261,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387100,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387113,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387135,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387140,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387331,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387382,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387385,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362278,
    "state": "GUJARAT",
    "district": "VERAVAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380017,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395345,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395620,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388445,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389322,
    "state": "GUJARAT",
    "district": "GODHRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389325,
    "state": "GUJARAT",
    "district": "GODHRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389347,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389348,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389355,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393021,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396443,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396452,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396480,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 346002,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 346003,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 346004,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 346005,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360008,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382625,
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382644,
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382719,
    "state": "GUJARAT",
    "district": "KALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382720,
    "state": "GUJARAT",
    "district": "KALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384131,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385007,
    "state": "GUJARAT",
    "district": "PALANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388011,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388020,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388051,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388052,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388201,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388321,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389122,
    "state": "GUJARAT",
    "district": "GODHRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389123,
    "state": "GUJARAT",
    "district": "GODHRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 389150,
    "state": "GUJARAT",
    "district": "DAHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391351,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391352,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391353,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391354,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391447,
    "state": "GUJARAT",
    "district": "HALOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392003,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392004,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392014,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392105,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 392221,
    "state": "GUJARAT",
    "district": "BHARUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393003,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393004,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393005,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393006,
    "state": "GUJARAT",
    "district": "ANKLESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393133,
    "state": "GUJARAT",
    "district": "NAVSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395375,
    "state": "GUJARAT",
    "district": "BARDOLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396108,
    "state": "GUJARAT",
    "district": "BILIMORA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396301,
    "state": "GUJARAT",
    "district": "BILIMORA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362271,
    "state": "GUJARAT",
    "district": "VERAVAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382851,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 121011,
    "state": "HARYANA",
    "district": "FARIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384011,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384121,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384122,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384206,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384256,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384257,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384270,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384274,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384276,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384277,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384280,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384291,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384292,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384311,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384411,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387435,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387531,
    "state": "GUJARAT",
    "district": "NADIAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394243,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394244,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396015,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396200,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396209,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396330,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396331,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362615,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363312,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362136,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380011,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382704,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382713,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382717,
    "state": "GUJARAT",
    "district": "KADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382727,
    "state": "GUJARAT",
    "district": "KADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382741,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382805,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382806,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382816,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382833,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382857,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382861,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384165,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384171,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384172,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384177,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384213,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384250,
    "state": "GUJARAT",
    "district": "VISNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384319,
    "state": "GUJARAT",
    "district": "VISNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385011,
    "state": "GUJARAT",
    "district": "PALANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385012,
    "state": "GUJARAT",
    "district": "PALANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385111,
    "state": "GUJARAT",
    "district": "PALANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385112,
    "state": "GUJARAT",
    "district": "PALANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 346110,
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360011,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360012,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360013,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360018,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360075,
    "state": "GUJARAT",
    "district": "GONDAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 361101,
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362248,
    "state": "GUJARAT",
    "district": "KESHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 362249,
    "state": "GUJARAT",
    "district": "KESHOD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363022,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363023,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363031,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363039,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363631,
    "state": "GUJARAT",
    "district": "VERAVAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364455,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364540,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365001,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365615,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365616,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365730,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370002,
    "state": "GUJARAT",
    "district": "BHUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370111,
    "state": "GUJARAT",
    "district": "GANDHIDHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370204,
    "state": "GUJARAT",
    "district": "GANDHIDHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380000,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380029,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380030,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380041,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380045,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380123,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380202,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380210,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380215,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380316,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 381520,
    "state": "GUJARAT",
    "district": "VALSAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382211,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382324,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382333,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382404,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382420,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382442,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388888,
    "state": "GUJARAT",
    "district": "GODHRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 390915,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391380,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391411,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 391441,
    "state": "GUJARAT",
    "district": "BARODA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 393236,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394307,
    "state": "GUJARAT",
    "district": "VALSAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396101,
    "state": "GUJARAT",
    "district": "VAPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363315,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384350,
    "state": "GUJARAT",
    "district": "VISNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203203,
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232103,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210121,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394218,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 395021,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382706,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382707,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382708,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382712,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 364537,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 380452,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 381156,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470277,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456004,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456005,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460002,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461444,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461772,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462035,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454020,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454051,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454435,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455224,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455225,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456662,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457003,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457112,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457440,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457778,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457780,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457880,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460008,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462019,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457886,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456300,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451877,
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455119,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455302,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451222,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451223,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451229,
    "state": "MADHYA PRADESH",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451448,
    "state": "MADHYA PRADESH",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451451,
    "state": "MADHYA PRADESH",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451559,
    "state": "MADHYA PRADESH",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 220002,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441406,
    "state": "MAHARASHTRA",
    "district": "RAMTEK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490003,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490004,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490005,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490007,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493002,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493003,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495007,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495008,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495577,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495617,
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 496197,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492021,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440531,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 440705,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441125,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444309,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490054,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 495005,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444508,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443307,
    "state": "MAHARASHTRA",
    "district": "BULDANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 445217,
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497210,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444112,
    "state": "MAHARASHTRA",
    "district": "MURTIZAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441118,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441121,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441400,
    "state": "MAHARASHTRA",
    "district": "RAMTEK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441602,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441603,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441604,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441607,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441608,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441609,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441611,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441612,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 441613,
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442108,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442109,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442112,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444125,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444509,
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444712,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444713,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444819,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444827,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444909,
    "state": "MAHARASHTRA",
    "district": "AMARAVATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444123,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535006,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492075,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444113,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444114,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444116,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444119,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444124,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 444129,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785104,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134006,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 160013,
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131303,
    "state": "HARYANA",
    "district": "KUNDLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132110,
    "state": "HARYANA",
    "district": "PANIPAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132151,
    "state": "HARYANA",
    "district": "PANIPAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134009,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141033,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141231,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141234,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142059,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142061,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143420,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143503,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143535,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143538,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144038,
    "state": "PUNJAB",
    "district": "PHAGWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144423,
    "state": "PUNJAB",
    "district": "PHAGWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148110,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148111,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148112,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148113,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148114,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148115,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148116,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148117,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151107,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151511,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 152125,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141400,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148000,
    "state": "PUNJAB",
    "district": "RAJPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302027,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 205264,
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332025,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123411,
    "state": "HARYANA",
    "district": "REWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623802,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623808,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624513,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625118,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625129,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625160,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625307,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625905,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626512,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627121,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627252,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629181,
    "state": "TAMIL NADU",
    "district": "THUCKALAY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629194,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 640103,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641040,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630006,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625418,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626190,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629103,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629192,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629406,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629509,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629603,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613206,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623202,
    "state": "TAMIL NADU",
    "district": "DEVAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626579,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626178,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623719,
    "state": "TAMIL NADU",
    "district": "RAMNAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621129,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622306,
    "state": "TAMIL NADU",
    "district": "PALLAPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622307,
    "state": "TAMIL NADU",
    "district": "PALLAPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622313,
    "state": "TAMIL NADU",
    "district": "PALLAPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622314,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622513,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626517,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626524,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626705,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623617,
    "state": "TAMIL NADU",
    "district": "RAMNAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626571,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626572,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626146,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626170,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626155,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627822,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614728,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638129,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638319,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639210,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624203,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622053,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623307,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623320,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627771,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627774,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627866,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627954,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627956,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624223,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624227,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624232,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624234,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625123,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625127,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625302,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625304,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625305,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626514,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626527,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626533,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627129,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627153,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627154,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627251,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627254,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627301,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627302,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627303,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627360,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627712,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627722,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627726,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628220,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628222,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628224,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628225,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628227,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628228,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628306,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628308,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628309,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628624,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628625,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628626,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628627,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628628,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628629,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628630,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628631,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628652,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628660,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628661,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628662,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628663,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622410,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623205,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627724,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627434,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628214,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628706,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611006,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611008,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612006,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612806,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612807,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613406,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613706,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613707,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621017,
    "state": "TAMIL NADU",
    "district": "THURAIYUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621591,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623111,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623201,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623213,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623313,
    "state": "TAMIL NADU",
    "district": "DEVAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623314,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623560,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623561,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623562,
    "state": "TAMIL NADU",
    "district": "RAMNAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623801,
    "state": "TAMIL NADU",
    "district": "RAMNAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623807,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624105,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624106,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624205,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624414,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624507,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624611,
    "state": "TAMIL NADU",
    "district": "PALANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624714,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624803,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625013,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625217,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625403,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625404,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625547,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625572,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626173,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626513,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626544,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626547,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627253,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627304,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627436,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627723,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627752,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627903,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627904,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627706,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627902,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628313,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630009,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630209,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630214,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630215,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630310,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630317,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630318,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630560,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641118,
    "state": "TAMIL NADU",
    "district": "METTUPALAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642135,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609610,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613107,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613106,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613304,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622514,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622509,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622510,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624228,
    "state": "TAMIL NADU",
    "district": "BATLAGUNDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624224,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624225,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626518,
    "state": "TAMIL NADU",
    "district": "CUMBUM -TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626520,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626519,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626521,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626523,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626525,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626526,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626528,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626210,
    "state": "TAMIL NADU",
    "district": "AUNDIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626536,
    "state": "TAMIL NADU",
    "district": "AUNDIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626540,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626582,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626159,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626151,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626186,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626167,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626208,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626209,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626704,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627823,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623210,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638605,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638687,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638684,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611117,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622312,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622317,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625120,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625121,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624214,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624221,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624217,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626529,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627123,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627132,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627431,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627435,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628659,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627714,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627769,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627762,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627773,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627763,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627955,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628305,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628307,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627716,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627721,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623102,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623103,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623104,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623208,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623101,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623551,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638654,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626717,
    "state": "TAMIL NADU",
    "district": "TINDIVANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622106,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622107,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622205,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622208,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622406,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622414,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622419,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622415,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627717,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627718,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622416,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627907,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627909,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628654,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627867,
    "state": "TAMIL NADU",
    "district": "KADAYANALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628705,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122209,
    "state": "HARYANA",
    "district": "MANESAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122019,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122020,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122023,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122024,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122025,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122027,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122028,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122029,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122030,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122031,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122055,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122215,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122218,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122219,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122220,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122224,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122226,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122227,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122229,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122230,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122231,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122232,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122233,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122234,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122208,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122213,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122214,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122216,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122217,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122225,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122228,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122203,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122204,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122206,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122207,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 122223,
    "state": "HARYANA",
    "district": "GURGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342015,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342014,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344044,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342026,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342310,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342306,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306303,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345027,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345022,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345028,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345025,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344702,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342305,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306301,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306709,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313603,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313601,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313602,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312203,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312204,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313207,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327022,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327025,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327026,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327034,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327023,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314031,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314027,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307510,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313342,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313329,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313331,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313334,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313026,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313038,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323615,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323613,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323614,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325203,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325215,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325206,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325201,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325218,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325216,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326520,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326022,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326036,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325003,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305621,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305622,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305630,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305922,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305006,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305008,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305024,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202124,
    "state": "UTTAR PRADESH",
    "district": "IGLAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523368,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273163,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761104,
    "state": "ORISSA",
    "district": "BERHAMPUR -OR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591109,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587155,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609605,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627113,
    "state": "TAMIL NADU",
    "district": "ARALVAIMOZHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226015,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212104,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285205,
    "state": "UTTAR PRADESH",
    "district": "ORAI (JALAUN)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209722,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307001,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342027,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251201,
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244222,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263642,
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203411,
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721506,
    "state": "WEST BENGAL",
    "district": "JHARGRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465669,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451228,
    "state": "MADHYA PRADESH",
    "district": "WEST NIMAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670705,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517581,
    "state": "ANDHRA PRADESH",
    "district": "PUTTUR -AP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486441,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486889,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785686,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307029,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307033,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344034,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343002,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306304,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343022,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306421,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345032,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306308,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313326,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326529,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326517,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325001,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305802,
    "state": "RAJASTHAN",
    "district": "KISHANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305202,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305203,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305625,
    "state": "ASSAM",
    "district": "BIJAYNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305812,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305813,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305814,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305815,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305817,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305819,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305923,
    "state": "RAJASTHAN",
    "district": "BEAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305924,
    "state": "RAJASTHAN",
    "district": "BEAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305925,
    "state": "RAJASTHAN",
    "district": "BEAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305926,
    "state": "RAJASTHAN",
    "district": "BEAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305927,
    "state": "RAJASTHAN",
    "district": "BEAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305021,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305201,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305402,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305405,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305406,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305407,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305408,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305412,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305415,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 182301,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 190006,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184104,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 180009,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181102,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184144,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 184152,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193121,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193201,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181132,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 181221,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400162,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400167,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400201,
    "state": "MAHARASHTRA",
    "district": "BHIWANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400202,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400207,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400208,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400209,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400045,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400100,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401200,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401214,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401400,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401406,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401407,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410213,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402206,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402225,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402405,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402406,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 421405,
    "state": "MAHARASHTRA",
    "district": "KALYAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400108,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400109,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400110,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400111,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400112,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400113,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400114,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400125,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400410,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400547,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400713,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 400901,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401016,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401100,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 404502,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 410303,
    "state": "MAHARASHTRA",
    "district": "VASAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 420421,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431302,
    "state": "MAHARASHTRA",
    "district": "THANE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402205,
    "state": "MAHARASHTRA",
    "district": "ALIBAUG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402121,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132105,
    "state": "HARYANA",
    "district": "PANIPAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141420,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143530,
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143533,
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144009,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141016,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143103,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141201,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143116,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144010,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144024,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144027,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142021,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141105,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134108,
    "state": "HARYANA",
    "district": "PANCHKULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577566,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221310,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272127,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 132102,
    "state": "HARYANA",
    "district": "PANIPAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131038,
    "state": "HARYANA",
    "district": "PANIPAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131305,
    "state": "HARYANA",
    "district": "GOHANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144632,
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146002,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 133007,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 134202,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173214,
    "state": "HIMACHAL PRADESH",
    "district": "BADDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173215,
    "state": "HIMACHAL PRADESH",
    "district": "KANDAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225002,
    "state": "PUNJAB",
    "district": "TANDA(PJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225414,
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227305,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227813,
    "state": "UTTAR PRADESH",
    "district": "AMETHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228118,
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242306,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225401,
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201016,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 247665,
    "state": "UTTARAKHAND",
    "district": "HARDWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251314,
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201019,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 227405,
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 241127,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460110,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244223,
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625702,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477557,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174005,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR  ( H.P.)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334023,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791125,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585416,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148025,
    "state": "PUNJAB",
    "district": "PATIALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 797113,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466446,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464770,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284303,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670701,
    "state": "KERALA",
    "district": "MATTANUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627764,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622507,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628722,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210424,
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222142,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209732,
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522329,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523264,
    "state": "ANDHRA PRADESH",
    "district": "MEDARAMETLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845456,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460661,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825409,
    "state": "JHARKHAND",
    "district": "JHUMRI TILIYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835207,
    "state": "JHARKHAND",
    "district": "GUMLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829102,
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756020,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627418,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224229,
    "state": "UTTAR PRADESH",
    "district": "FAIZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303712,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635113,
    "state": "KARNATAKA",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523212,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272201,
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTHA NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502300,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585417,
    "state": "KARNATAKA",
    "district": "BIDAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276204,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276205,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273161,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209870,
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209821,
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243407,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 230404,
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209502,
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245208,
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231221,
    "state": "UTTAR PRADESH",
    "district": "RENUKOOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203129,
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222141,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212620,
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203155,
    "state": "UTTAR PRADESH",
    "district": "GAUTAM+BUDH+NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244602,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231309,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231306,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225306,
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242406,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209869,
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 281504,
    "state": "UTTAR PRADESH",
    "district": "VRINDABAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231207,
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244415,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244411,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274405,
    "state": "UTTAR PRADESH",
    "district": "AMETHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274801,
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272171,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272150,
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272192,
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTHA NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 243203,
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 224232,
    "state": "UTTAR PRADESH",
    "district": "FAIZABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226203,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274149,
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273405,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232120,
    "state": "UTTAR PRADESH",
    "district": "CHANDOULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209739,
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244245,
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 223104,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248122,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248011,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203002,
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261145,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 261206,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210422,
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR (UP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210506,
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR (UP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244414,
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248012,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226030,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276139,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273403,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221601,
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276127,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221106,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 244401,
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221208,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 275303,
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226101,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273212,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276301,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271126,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 285127,
    "state": "UTTAR PRADESH",
    "district": "ORAI (JALAUN)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 226027,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209651,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272271,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284205,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 223103,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233221,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 222161,
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262906,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209307,
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR�NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209305,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242042,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 225409,
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209303,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209202,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209205,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209881,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271502,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251202,
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306115,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515331,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517192,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509152,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443204,
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306701,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303327,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146112,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342303,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331023,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331024,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788025,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185151,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123102,
    "state": "HARYANA",
    "district": "BAWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144529,
    "state": "PUNJAB",
    "district": "PHAGWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465697,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274302,
    "state": "UTTAR PRADESH",
    "district": "KUSHINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272173,
    "state": "UTTAR PRADESH",
    "district": "KHALILABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177042,
    "state": "HIMACHAL PRADESH",
    "district": "NADAUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 232110,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185101,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585325,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573112,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 573124,
    "state": "KARNATAKA",
    "district": "HASSAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151509,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 177103,
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577243,
    "state": "KARNATAKA",
    "district": "BHADRAVATHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507211,
    "state": "ANDHRA PRADESH",
    "district": "MAHABUBABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713124,
    "state": "WEST BENGAL",
    "district": "BARSUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508278,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502311,
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515722,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632512,
    "state": "TAMIL NADU",
    "district": "POLUR - ARANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504202,
    "state": "TELANGANA",
    "district": "NIRMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 501202,
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304022,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425405,
    "state": "MAHARASHTRA",
    "district": "SHIRPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621601,
    "state": "TAMIL NADU",
    "district": "LALGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 245301,
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442304,
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 125106,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456221,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143114,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601101,
    "state": "TAMIL NADU",
    "district": "GUMMIDIPONDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174004,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR  ( H.P.)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721149,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148102,
    "state": "PUNJAB",
    "district": "BARNALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731301,
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477445,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 383205,
    "state": "GUJARAT",
    "district": "HIMMATNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 396436,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334801,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574153,
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787058,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799205,
    "state": "TRIPURA",
    "district": "TELIAMURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741137,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783125,
    "state": "ASSAM",
    "district": "GOALPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743442,
    "state": "WEST BENGAL",
    "district": "BASIRHAT R S",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734102,
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788121,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756162,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758041,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471201,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176025,
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151507,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175129,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR  ( H.P.)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515641,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505453,
    "state": "TELANGANA",
    "district": "JAGTIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473443,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273406,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273411,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635804,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274206,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273309,
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273304,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670641,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670305,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627753,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627761,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625701,
    "state": "TAMIL NADU",
    "district": "KALLIGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713502,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713408,
    "state": "WEST BENGAL",
    "district": "KALYANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713151,
    "state": "WEST BENGAL",
    "district": "MEMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481445,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176059,
    "state": "PUNJAB",
    "district": "NANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402203,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458118,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768025,
    "state": "ORISSA",
    "district": "SAMBALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 151102,
    "state": "PUNJAB",
    "district": "BHATINDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144628,
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124514,
    "state": "HARYANA",
    "district": "ROHTAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210429,
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209825,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209727,
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784180,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332403,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 586123,
    "state": "KARNATAKA",
    "district": "BIJAPUR(KAR)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504102,
    "state": "TELANGANA",
    "district": "NIRMAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507168,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262531,
    "state": "UTTARAKHAND",
    "district": "HALDWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781103,
    "state": "ASSAM",
    "district": "SUALKUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523326,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523304,
    "state": "ANDHRA PRADESH",
    "district": "DONAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523260,
    "state": "ANDHRA PRADESH",
    "district": "MEDARAMETLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523281,
    "state": "ANDHRA PRADESH",
    "district": "KAVALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523261,
    "state": "ANDHRA PRADESH",
    "district": "PRAKASHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721122,
    "state": "WEST BENGAL",
    "district": "KHARAGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 263639,
    "state": "UTTARAKHAND",
    "district": "HALDWANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509126,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516247,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531025,
    "state": "ANDHRA PRADESH",
    "district": "GAJUWAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517592,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524312,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523168,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509382,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524134,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508221,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761027,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 173024,
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470227,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713512,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722154,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742305,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636111,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622302,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621206,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614102,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627755,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628102,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627417,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627412,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628614,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628904,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628105,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629160,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629151,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609604,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609401,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625605,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611003,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627103,
    "state": "TAMIL NADU",
    "district": "VALLIOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627109,
    "state": "TAMIL NADU",
    "district": "PANAGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627422,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627424,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627426,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628552,
    "state": "TAMIL NADU",
    "district": "SANKARANKOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629102,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629154,
    "state": "TAMIL NADU",
    "district": "NITHIRAVILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629172,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629176,
    "state": "TAMIL NADU",
    "district": "NITHIRAVILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636119,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611106,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626116,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626133,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611104,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642111,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627152,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627427,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627453,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628623,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627102,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628903,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627853,
    "state": "TAMIL NADU",
    "district": "KADAYANALLUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642130,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638010,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610109,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637406,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639116,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621302,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626138,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627101,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628301,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628703,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636117,
    "state": "TAMIL NADU",
    "district": "ATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623524,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638752,
    "state": "TAMIL NADU",
    "district": "BHAVANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614904,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625603,
    "state": "TAMIL NADU",
    "district": "PERIYAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627760,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626108,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625205,
    "state": "TAMIL NADU",
    "district": "VADIPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609003,
    "state": "TAMIL NADU",
    "district": "MYLAPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642108,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620101,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629152,
    "state": "TAMIL NADU",
    "district": "MARTHANDAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638506,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628201,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627151,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627415,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626105,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621713,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627451,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628219,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628207,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627852,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627413,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623517,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628209,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628907,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628905,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627356,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642107,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628304,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627105,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637303,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627420,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628701,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628210,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637105,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626204,
    "state": "TAMIL NADU",
    "district": "SATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627421,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627806,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638057,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625534,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614630,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625203,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635108,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637202,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637201,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611101,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626118,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622422,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622104,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622303,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613301,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621107,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636104,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621014,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609606,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609601,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627858,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636204,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612104,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611108,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635201,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638104,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612501,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625529,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626004,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626002,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630107,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630106,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630202,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635106,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630208,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614016,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638312,
    "state": "TAMIL NADU",
    "district": "BHAVANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621115,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622401,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630410,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622403,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614619,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614620,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630709,
    "state": "TAMIL NADU",
    "district": "PARAMAKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635205,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635204,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612302,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614613,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612102,
    "state": "TAMIL NADU",
    "district": "KUMBAKONAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610203,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622515,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626134,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626113,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621218,
    "state": "TAMIL NADU",
    "district": "LALGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621712,
    "state": "TAMIL NADU",
    "district": "LALGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614711,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614902,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638456,
    "state": "TAMIL NADU",
    "district": "BHAVANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638108,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636301,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622301,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622506,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622505,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630103,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622503,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627814,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630104,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623603,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638101,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638154,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636809,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636806,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628721,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636805,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635307,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635306,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635304,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626205,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625221,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609609,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635120,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628714,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628952,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626119,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614014,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621307,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625562,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193404,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334603,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332021,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 176048,
    "state": "PUNJAB",
    "district": "NANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464228,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713423,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756129,
    "state": "ORISSA",
    "district": "GHANTESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423701,
    "state": "MAHARASHTRA",
    "district": "AURANGABAD+MH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628712,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624707,
    "state": "TAMIL NADU",
    "district": "BATLAGUNDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335073,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144213,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143111,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756033,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497226,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 443402,
    "state": "MAHARASHTRA",
    "district": "KHAMGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756028,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465226,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136033,
    "state": "HARYANA",
    "district": "AMBALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522303,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515465,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412206,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609603,
    "state": "TAMIL NADU",
    "district": "KARAIKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612203,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626149,
    "state": "TAMIL NADU",
    "district": "WATRAP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635211,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635309,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636706,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642032,
    "state": "TAMIL NADU",
    "district": "KINATHUKADAVU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613104,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613105,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614202,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614207,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614401,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614612,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614623,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621113,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621708,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621714,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621729,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626107,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626110,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626114,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626129,
    "state": "TAMIL NADU",
    "district": "ARUPPUKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626141,
    "state": "TAMIL NADU",
    "district": "SIVAKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626202,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636902,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636904,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641665,
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641667,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642105,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642117,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 642125,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721633,
    "state": "WEST BENGAL",
    "district": "HALDIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 223223,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276140,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522660,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 854328,
    "state": "BIHAR",
    "district": "ARARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843314,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272302,
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274306,
    "state": "UTTAR PRADESH",
    "district": "KUSHINAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274502,
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 143502,
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742401,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185121,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 182202,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466115,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 136044,
    "state": "HARYANA",
    "district": "KAITHAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185211,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 185111,
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515741,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 803202,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203395,
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 203396,
    "state": "UTTAR PRADESH",
    "district": "DIBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508247,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508112,
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756027,
    "state": "ORISSA",
    "district": "BALASORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825412,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606805,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606802,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603104,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632311,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632317,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632315,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606903,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632506,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608601,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604305,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604306,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605754,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605756,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606205,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606611,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604601,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631605,
    "state": "TAMIL NADU",
    "district": "SRIPERUMPUDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601102,
    "state": "TAMIL NADU",
    "district": "POLUR - ARANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632055,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606904,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632101,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632104,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635803,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635809,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632326,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604204,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604151,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608702,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605752,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605103,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607202,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607201,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606208,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609117,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484110,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638461,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458330,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614617,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620016,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620025,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621314,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621651,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622202,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622209,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622304,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622402,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622404,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622409,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622411,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623308,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630101,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630102,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630201,
    "state": "TAMIL NADU",
    "district": "SIVAGANGAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630205,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781128,
    "state": "ASSAM",
    "district": "GUWAHATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630307,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 802212,
    "state": "BIHAR",
    "district": "BIKRAMGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304502,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 734426,
    "state": "WEST BENGAL",
    "district": "BIDHANNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 832301,
    "state": "JHARKHAND",
    "district": "JAMSHEDPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534329,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689594,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522408,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521125,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413544,
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174321,
    "state": "PUNJAB",
    "district": "NANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 401403,
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712121,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413802,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504272,
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509408,
    "state": "TELANGANA",
    "district": "RANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313322,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506313,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503308,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632517,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506142,
    "state": "TELANGANA",
    "district": "HANUMAKONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756117,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755016,
    "state": "ORISSA",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600140,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601506,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601802,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603602,
    "state": "TAMIL NADU",
    "district": "GUDUVANCHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606006,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606016,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608109,
    "state": "TAMIL NADU",
    "district": "SIVAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609002,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614818,
    "state": "TAMIL NADU",
    "district": "ARANTHANGI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620106,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620108,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 620110,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621619,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622018,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622019,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622020,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623505,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623702,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624126,
    "state": "TAMIL NADU",
    "district": "UDUMALPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624128,
    "state": "TAMIL NADU",
    "district": "UDUMALPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624154,
    "state": "TAMIL NADU",
    "district": "UDUMALPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625220,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625620,
    "state": "TAMIL NADU",
    "district": "PERIYAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626177,
    "state": "TAMIL NADU",
    "district": "RAJAPALYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626639,
    "state": "TAMIL NADU",
    "district": "RAJAPALYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627405,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627545,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627555,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627556,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628852,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629303,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629305,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629902,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630021,
    "state": "TAMIL NADU",
    "district": "KARAIKUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 630607,
    "state": "TAMIL NADU",
    "district": "MANAMADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636063,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638450,
    "state": "TAMIL NADU",
    "district": "GOBICHETTYPALYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639151,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643271,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689006,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 641657,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600186,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600121,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625504,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639106,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 601104,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603113,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603114,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603117,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603118,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603315,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603317,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603318,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603320,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603404,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629503,
    "state": "TAMIL NADU",
    "district": "NAGERCOIL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623107,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626207,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613305,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638202,
    "state": "TAMIL NADU",
    "district": "POLLACHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609121,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635127,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635128,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635131,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635208,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606711,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606713,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606715,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606716,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606718,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626183,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627430,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632322,
    "state": "TAMIL NADU",
    "district": "ARNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632323,
    "state": "TAMIL NADU",
    "district": "ARNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632324,
    "state": "TAMIL NADU",
    "district": "ARNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632325,
    "state": "TAMIL NADU",
    "district": "ARNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643273,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602027,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 602104,
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604103,
    "state": "TAMIL NADU",
    "district": "TINDIVANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604155,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604211,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604212,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604213,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604412,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605051,
    "state": "PONDICHERY",
    "district": "PONDICHERRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605655,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606120,
    "state": "TAMIL NADU",
    "district": "ULUNDURPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606123,
    "state": "TAMIL NADU",
    "district": "ULUNDURPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606810,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606910,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607207,
    "state": "TAMIL NADU",
    "district": "ULUNDURPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608803,
    "state": "TAMIL NADU",
    "district": "CHIDAMBARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623105,
    "state": "TAMIL NADU",
    "district": "KATPADI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623319,
    "state": "TAMIL NADU",
    "district": "VANDAVASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625119,
    "state": "TAMIL NADU",
    "district": "MELUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627131,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627361,
    "state": "TAMIL NADU",
    "district": "PALAYAMKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627659,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631027,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631053,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631118,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631609,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631703,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632109,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632110,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632205,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632206,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632207,
    "state": "TAMIL NADU",
    "district": "GUDIYATHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632211,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632218,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632234,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632523,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632526,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635826,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638117,
    "state": "TAMIL NADU",
    "district": "PERUNDURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623109,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623110,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632527,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606221,
    "state": "TAMIL NADU",
    "district": "KALLAKURUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606223,
    "state": "TAMIL NADU",
    "district": "KALLAKURUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606307,
    "state": "TAMIL NADU",
    "district": "KALLAKURUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627432,
    "state": "TAMIL NADU",
    "district": "AMBASAMUDRAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635819,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638324,
    "state": "TAMIL NADU",
    "district": "BHAVANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638327,
    "state": "TAMIL NADU",
    "district": "BHAVANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638328,
    "state": "TAMIL NADU",
    "district": "BHAVANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 604914,
    "state": "TAMIL NADU",
    "district": "CHIDAMBARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624207,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627720,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627908,
    "state": "TAMIL NADU",
    "district": "KOVILPATTI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632631,
    "state": "TAMIL NADU",
    "district": "RANIPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638113,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638675,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643055,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643246,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643252,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643267,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643518,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 666213,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637420,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638807,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609130,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609128,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609129,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609122,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609119,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609125,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609126,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609131,
    "state": "TAMIL NADU",
    "district": "SIRKALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626152,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626206,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627952,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635656,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635659,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635661,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635660,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621229,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635662,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 626522,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635705,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635706,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635709,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635817,
    "state": "TAMIL NADU",
    "district": "AMBUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635820,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635857,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636318,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637024,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637026,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637418,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638118,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643272,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638466,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623108,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 632529,
    "state": "TAMIL NADU",
    "district": "SHOLINGHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635855,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605753,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636604,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636915,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603019,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638054,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638055,
    "state": "TAMIL NADU",
    "district": "PERUNDURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638454,
    "state": "TAMIL NADU",
    "district": "GOBICHETTYPALYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638502,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638503,
    "state": "TAMIL NADU",
    "district": "SATHYAMANGALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638505,
    "state": "TAMIL NADU",
    "district": "GOBICHETTYPALYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638660,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638661,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638673,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638702,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638703,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638706,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636138,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636139,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636202,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636406,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636452,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636454,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636456,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636458,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636602,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637003,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637013,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637014,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637019,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637020,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637103,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637107,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643206,
    "state": "TAMIL NADU",
    "district": "OOTY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643218,
    "state": "TAMIL NADU",
    "district": "COONOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608901,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622501,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 622504,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624103,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624210,
    "state": "TAMIL NADU",
    "district": "KODAIKANAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624211,
    "state": "TAMIL NADU",
    "district": "BATLAGUNDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624215,
    "state": "TAMIL NADU",
    "district": "NILAKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624216,
    "state": "TAMIL NADU",
    "district": "BATLAGUNDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624220,
    "state": "TAMIL NADU",
    "district": "BATLAGUNDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624307,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624610,
    "state": "TAMIL NADU",
    "district": "PALANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624612,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624614,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624616,
    "state": "TAMIL NADU",
    "district": "PALANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624616,
    "state": "TAMIL NADU",
    "district": "PALANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624704,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624705,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624711,
    "state": "TAMIL NADU",
    "district": "VEDASANDUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624712,
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639203,
    "state": "TAMIL NADU",
    "district": "BATLAGUNDU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614203,
    "state": "TAMIL NADU",
    "district": "PAPANASAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614628,
    "state": "TAMIL NADU",
    "district": "PERAVURANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609309,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609404,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609702,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610207,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614712,
    "state": "TAMIL NADU",
    "district": "VEDARANYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629101,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629164,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629166,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629174,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629178,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629179,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629193,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629402,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629851,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629901,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629809,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627107,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627110,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627114,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627115,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627116,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627127,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627202,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627351,
    "state": "TAMIL NADU",
    "district": "PALAYAMKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627651,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627652,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627654,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628103,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628104,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628205,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628208,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628212,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628213,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628302,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628401,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628612,
    "state": "TAMIL NADU",
    "district": "TIRUCHENDHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628618,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628619,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628620,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628621,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628622,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628704,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628751,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628753,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628901,
    "state": "TAMIL NADU",
    "district": "VILATHIKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628906,
    "state": "TAMIL NADU",
    "district": "VILATHIKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628908,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851133,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636462,
    "state": "TAMIL NADU",
    "district": "METTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303801,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303603,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 643219,
    "state": "TAMIL NADU",
    "district": "COONOOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614103,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624317,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624623,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624628,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606911,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606915,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607111,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607113,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 607116,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609120,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 624625,
    "state": "TAMIL NADU",
    "district": "DHARAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629601,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629403,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629852,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627120,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614018,
    "state": "TAMIL NADU",
    "district": "MANNARGUDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123023,
    "state": "HARYANA",
    "district": "BAWAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461771,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786155,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531113,
    "state": "ANDHRA PRADESH",
    "district": "GAJUWAKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732205,
    "state": "WEST BENGAL",
    "district": "RATUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756119,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306116,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757086,
    "state": "ORISSA",
    "district": "BARIPADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845106,
    "state": "BIHAR",
    "district": "MOTIHARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845411,
    "state": "BIHAR",
    "district": "MOTIHARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843120,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841405,
    "state": "BIHAR",
    "district": "GOPALGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 175126,
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 671326,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752102,
    "state": "ORISSA",
    "district": "BHUBANESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521111,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606003,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606108,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608401,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516503,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516217,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516289,
    "state": "ANDHRA PRADESH",
    "district": "KAMALAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518221,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360023,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756086,
    "state": "ORISSA",
    "district": "JALESWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533291,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497220,
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509205,
    "state": "ANDHRA PRADESH",
    "district": "DHANWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670102,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673304,
    "state": "KERALA",
    "district": "CALICUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508111,
    "state": "TELANGANA",
    "district": "NALGONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229305,
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126113,
    "state": "HARYANA",
    "district": "JIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 686515,
    "state": "KERALA",
    "district": "KOTTAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752065,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761015,
    "state": "ORISSA",
    "district": "GAJAPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767035,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466661,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384240,
    "state": "GUJARAT",
    "district": "PATAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344701,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787053,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516216,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325204,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333516,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524410,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635651,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635854,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627854,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627860,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627951,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629168,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629169,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629170,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637212,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637213,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609502,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609503,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609504,
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609608,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611102,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611103,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611112,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612601,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612604,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613703,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613705,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614717,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614809,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625518,
    "state": "TAMIL NADU",
    "district": "GUDALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625521,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625525,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625533,
    "state": "TAMIL NADU",
    "district": "UTHAMAPALAYAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625556,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627201,
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628653,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628656,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621205,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621207,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621214,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621215,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639107,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639112,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628851,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638110,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638313,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638457,
    "state": "TAMIL NADU",
    "district": "ERODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638460,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638462,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 638672,
    "state": "TAMIL NADU",
    "district": "TIRUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635202,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635305,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636812,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627861,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627953,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629204,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629302,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629810,
    "state": "TAMIL NADU",
    "district": "KANYAKUMARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637021,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637203,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637405,
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609103,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609105,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609107,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609112,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609114,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609201,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609202,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609203,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609204,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609205,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609301,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609302,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609303,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609304,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609306,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609307,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609308,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609310,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609311,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609312,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609313,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609314,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609402,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609403,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609701,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609703,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609704,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609811,
    "state": "TAMIL NADU",
    "district": "TINDIVANAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610102,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610103,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610105,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610106,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610107,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610201,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610202,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610204,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610205,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 610206,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611105,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611109,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611110,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 611111,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612605,
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612610,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613704,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614702,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614703,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614705,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614706,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614707,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614710,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614714,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614715,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614716,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614738,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614806,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614807,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614808,
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625522,
    "state": "TAMIL NADU",
    "district": "THENI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612901,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612902,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612903,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612904,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 612905,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621202,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621204,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621208,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621213,
    "state": "TAMIL NADU",
    "district": "TRICHY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621217,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621653,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621703,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621705,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621707,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621709,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621710,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621715,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621716,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621717,
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621718,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621719,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621722,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621730,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621731,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621801,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621803,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621804,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621805,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621806,
    "state": "TAMIL NADU",
    "district": "ARIYALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 621851,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639101,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639103,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639110,
    "state": "TAMIL NADU",
    "district": "KARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 639115,
    "state": "TAMIL NADU",
    "district": "TRICHIRAPPALLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628152,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628211,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628217,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628218,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628252,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628615,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628752,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 628802,
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713147,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784179,
    "state": "ASSAM",
    "district": "BISWANATH CHARIALI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 846009,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 629202,
    "state": "KERALA",
    "district": "IDUKKI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609102,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609405,
    "state": "KERALA",
    "district": "ALATHUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 613701,
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614404,
    "state": "TAMIL NADU",
    "district": "TIRUVARUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605751,
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605766,
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605802,
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 605803,
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606102,
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606704,
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606709,
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608302,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608303,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608304,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608306,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608701,
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609101,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609104,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609108,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 609115,
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825406,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522211,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522256,
    "state": "ANDHRA PRADESH",
    "district": "BHATTIPROLU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522016,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388220,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483336,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741124,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518563,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305401,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414102,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413132,
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521156,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517587,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335526,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334021,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670651,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670663,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670741,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713372,
    "state": "WEST BENGAL",
    "district": "BARAKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731215,
    "state": "WEST BENGAL",
    "district": "BOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741257,
    "state": "WEST BENGAL",
    "district": "NAGARUKHRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741506,
    "state": "WEST BENGAL",
    "district": "MAJDHIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712702,
    "state": "WEST BENGAL",
    "district": "HOOGLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752017,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534327,
    "state": "ANDHRA PRADESH",
    "district": "PODURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522312,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522341,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522259,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522257,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522261,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522310,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522113,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522262,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522268,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521158,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521138,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521164,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521163,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521245,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521250,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521261,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521246,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521247,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521132,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532430,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532211,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 532425,
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521401,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533228,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533237,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533236,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533274,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533345,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534324,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534326,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533285,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533430,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534268,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534266,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534318,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533292,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534195,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534265,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534250,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521340,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521183,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521182,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533222,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533210,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522315,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522325,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522317,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521390,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 535580,
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533290,
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534338,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534267,
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521343,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521003,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521457,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 442107,
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522306,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522308,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522307,
    "state": "ANDHRA PRADESH",
    "district": "KOLAKALUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534126,
    "state": "ANDHRA PRADESH",
    "district": "ALAMURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470229,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788803,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788735,
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 490025,
    "state": "CHHATTISGARH",
    "district": "BHILAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 755003,
    "state": "ORISSA",
    "district": "BARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 246428,
    "state": "UTTARAKHAND",
    "district": "CHAMOLI( GOPESHWAR )",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507163,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507208,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507318,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507164,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 507114,
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509401,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743354,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743351,
    "state": "WEST BENGAL",
    "district": "DIAMOND HARBOUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741163,
    "state": "WEST BENGAL",
    "district": "TEHATTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721439,
    "state": "WEST BENGAL",
    "district": "EGRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 123302,
    "state": "HARYANA",
    "district": "REWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457222,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273412,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 844505,
    "state": "BIHAR",
    "district": "HAZIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623531,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341024,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766013,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766017,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766028,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766103,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767042,
    "state": "ORISSA",
    "district": "BALANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767066,
    "state": "ORISSA",
    "district": "BALANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767032,
    "state": "ORISSA",
    "district": "BALANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767070,
    "state": "ORISSA",
    "district": "JHARSUGUDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770035,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770046,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770070,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770016,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770023,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770018,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768224,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 768228,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 770022,
    "state": "ORISSA",
    "district": "SUNDERGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 505467,
    "state": "ANDHRA PRADESH",
    "district": "HUSNABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 385520,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 614621,
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679580,
    "state": "KERALA",
    "district": "MALAPPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 229801,
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326513,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335041,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603127,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623608,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 623512,
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766015,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 766019,
    "state": "ORISSA",
    "district": "KALAHANDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581308,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480667,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 835303,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742163,
    "state": "WEST BENGAL",
    "district": "SHAKTIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 493101,
    "state": "CHHATTISGARH",
    "district": "BALODABAZAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508258,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 504292,
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 509340,
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752032,
    "state": "ORISSA",
    "district": "PURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752026,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332710,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735212,
    "state": "WEST BENGAL",
    "district": "DHUPGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735219,
    "state": "WEST BENGAL",
    "district": "DHUPGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735233,
    "state": "WEST BENGAL",
    "district": "MAYNAGURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 847306,
    "state": "BIHAR",
    "district": "DARBHANGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 758025,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 685571,
    "state": "KERALA",
    "district": "PARATHODE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 606304,
    "state": "TAMIL NADU",
    "district": "VIRUDHACHALAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517257,
    "state": "ANDHRA PRADESH",
    "district": "MADANAPALLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210501,
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR (UP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 523272,
    "state": "ANDHRA PRADESH",
    "district": "ONGOLE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515164,
    "state": "ANDHRA PRADESH",
    "district": "HINDUPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825408,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 431720,
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382130,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743318,
    "state": "WEST BENGAL",
    "district": "SOUTH 24 PARGANAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756130,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518395,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 201318,
    "state": "UTTAR PRADESH",
    "district": "NOIDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711115,
    "state": "WEST BENGAL",
    "district": "KONA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781306,
    "state": "ASSAM",
    "district": "NALBARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414203,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413702,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274601,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 412106,
    "state": "MAHARASHTRA",
    "district": "TALEGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 209214,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370655,
    "state": "GUJARAT",
    "district": "GANDHIDHAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 273306,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272124,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274409,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723213,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 731130,
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 382230,
    "state": "GUJARAT",
    "district": "AHMEDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233002,
    "state": "UTTAR PRADESH",
    "district": "GAZIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736167,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825311,
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233003,
    "state": "UTTAR PRADESH",
    "district": "GAZIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 233005,
    "state": "UTTAR PRADESH",
    "district": "GAZIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144106,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670691,
    "state": "KERALA",
    "district": "CANNANORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 792110,
    "state": "ARUNACHAL PRADESH",
    "district": "DIBANG VALLEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781367,
    "state": "ASSAM",
    "district": "NALBARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635808,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 425111,
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141204,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274309,
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 274701,
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272189,
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTHA NAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461441,
    "state": "MADHYA PRADESH",
    "district": "HARDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210502,
    "state": "UTTAR PRADESH",
    "district": "KANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 422605,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 824220,
    "state": "BIHAR",
    "district": "GAYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581342,
    "state": "KARNATAKA",
    "district": "HONNAVARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 228131,
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 802312,
    "state": "BIHAR",
    "district": "ARRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 845418,
    "state": "BIHAR",
    "district": "DHAKA E.C",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581361,
    "state": "KARNATAKA",
    "district": "HONNAVARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587315,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587312,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 587120,
    "state": "KARNATAKA",
    "district": "BAGALKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 713143,
    "state": "WEST BENGAL",
    "district": "BURDWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581341,
    "state": "KARNATAKA",
    "district": "HONNAVARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522617,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761143,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761121,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761019,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761031,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761032,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761035,
    "state": "ORISSA",
    "district": "NABARANGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764061,
    "state": "ORISSA",
    "district": "NABARANGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 416701,
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534176,
    "state": "ANDHRA PRADESH",
    "district": "NALLAJERLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522409,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782461,
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192231,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 193221,
    "state": "DELHI",
    "district": "DELHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741223,
    "state": "WEST BENGAL",
    "district": "CHAKDAHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456006,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457777,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461881,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456665,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522646,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828130,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800030,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 843105,
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841427,
    "state": "BIHAR",
    "district": "GOPALGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712305,
    "state": "WEST BENGAL",
    "district": "HOOGLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764086,
    "state": "ORISSA",
    "district": "MALKANGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764087,
    "state": "ORISSA",
    "district": "MALKANGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764076,
    "state": "ORISSA",
    "district": "NABARANGPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764074,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761054,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761007,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761013,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 761042,
    "state": "ORISSA",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 765019,
    "state": "ORISSA",
    "district": "RAYAGADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781126,
    "state": "ASSAM",
    "district": "NALBARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723129,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670708,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581396,
    "state": "KARNATAKA",
    "district": "KARWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743355,
    "state": "WEST BENGAL",
    "district": "MOGRAHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360110,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524308,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635852,
    "state": "TAMIL NADU",
    "district": "TIRUPATTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534216,
    "state": "ANDHRA PRADESH",
    "district": "TANUKU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 635115,
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741316,
    "state": "WEST BENGAL",
    "district": "SERAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636803,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 636807,
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360020,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 210204,
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450116,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480441,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515455,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670672,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756111,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788104,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788106,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788115,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788161,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799013,
    "state": "TRIPURA",
    "district": "AGARTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384135,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384160,
    "state": "GUJARAT",
    "district": "UNJHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721433,
    "state": "WEST BENGAL",
    "district": "CONTAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723152,
    "state": "WEST BENGAL",
    "district": "BAGHMUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 802152,
    "state": "BIHAR",
    "district": "BHOJPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791118,
    "state": "ARUNACHAL PRADESH",
    "district": "KURUNG KUMEY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 524304,
    "state": "ANDHRA PRADESH",
    "district": "NELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 522435,
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516214,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516104,
    "state": "ANDHRA PRADESH",
    "district": "CHITVEL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 231307,
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221307,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 124108,
    "state": "HARYANA",
    "district": "JHAJJAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 506005,
    "state": "TELANGANA",
    "district": "WARANGAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 515775,
    "state": "ANDHRA PRADESH",
    "district": "ANANTHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576113,
    "state": "KARNATAKA",
    "district": "HIRIADKA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742302,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764045,
    "state": "ORISSA",
    "district": "JEYPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841442,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754289,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 370150,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481990,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583220,
    "state": "KARNATAKA",
    "district": "VIJAYANAGARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785675,
    "state": "ASSAM",
    "district": "MORAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788013,
    "state": "ASSAM",
    "district": "SILCHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508002,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 516213,
    "state": "ANDHRA PRADESH",
    "district": "CUDDAPAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 711404,
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481776,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670650,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 815302,
    "state": "BIHAR",
    "district": "GIRIDIH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 825320,
    "state": "BIHAR",
    "district": "GIRIDIH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 625109,
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 754213,
    "state": "ORISSA",
    "district": "CUTTACK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 793008,
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764039,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517423,
    "state": "ANDHRA PRADESH",
    "district": "SANTHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 413503,
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799012,
    "state": "TRIPURA",
    "district": "AGARTALA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 757091,
    "state": "ORISSA",
    "district": "KEONJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517280,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517415,
    "state": "ANDHRA PRADESH",
    "district": "CHITTOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475330,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 503306,
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 797112,
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144629,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 142049,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 848201,
    "state": "BIHAR",
    "district": "BEGUSARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456440,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603305,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 735231,
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202130,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 202280,
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 262545,
    "state": "UTTARAKHAND",
    "district": "DHARCHULA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518218,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 804453,
    "state": "#N/A",
    "district": "#N/A",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144701,
    "state": "#N/A",
    "district": "#N/A",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 533296,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192301,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388180,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 627856,
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591103,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563160,
    "state": "#N/A",
    "district": "#N/A",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 574143,
    "state": "KARNATAKA",
    "district": "MANGALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591311,
    "state": "#N/A",
    "district": "#N/A",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 762023,
    "state": "ORISSA",
    "district": "BOUDH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 276141,
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 388210,
    "state": "GUJARAT",
    "district": "ANAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 767018,
    "state": "ORISSA",
    "district": "BOLANGIR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 508201,
    "state": "TELANGANA",
    "district": "SURYAPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583282,
    "state": "KARNATAKA",
    "district": "HOSPET",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786188,
    "state": "ASSAM",
    "district": "TINSUKIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676542,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500107,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500102,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500103,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500104,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500109,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500110,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500111,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500112,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500114,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 500115,
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 502284,
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 585305,
    "state": "KARNATAKA",
    "district": "GULBARGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 570032,
    "state": "KARNATAKA",
    "district": "MYSORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689572,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 794104,
    "state": "MEGHALAYA",
    "district": "WEST GARO HILL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752084,
    "state": "ORISSA",
    "district": "NAYAGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712413,
    "state": "WEST BENGAL",
    "district": "MAYAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221507,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 272191,
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466114,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723201,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577227,
    "state": "KARNATAKA",
    "district": "SHIMOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741166,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453555,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841239,
    "state": "BIHAR",
    "district": "SIWAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 851211,
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576235,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841425,
    "state": "BIHAR",
    "district": "GOPALGUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 146023,
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723127,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360050,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 811101,
    "state": "BIHAR",
    "district": "BARBIGHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 797103,
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 140108,
    "state": "PUNJAB",
    "district": "ROPAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679341,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 148100,
    "state": "PUNJAB",
    "district": "MOGA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342606,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841219,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 752062,
    "state": "ORISSA",
    "district": "KHURDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691515,
    "state": "KERALA",
    "district": "QUILON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 531083,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783324,
    "state": "ASSAM",
    "district": "DHUBRI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 722146,
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577552,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 394670,
    "state": "GUJARAT",
    "district": "SURAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670107,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736203,
    "state": "WEST BENGAL",
    "district": "ALIPURDWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 792131,
    "state": "ARUNACHAL PRADESH",
    "district": "LONGDING",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781352,
    "state": "ASSAM",
    "district": "KAYAKUCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787032,
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 576120,
    "state": "KARNATAKA",
    "district": "UDUPI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 144523,
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363020,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 756164,
    "state": "ORISSA",
    "district": "BHADRAK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302037,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 581421,
    "state": "KARNATAKA",
    "district": "MURUDESHWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 847226,
    "state": "BIHAR",
    "district": "MADHUBANI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 801302,
    "state": "BIHAR",
    "district": "NALANDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 791121,
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 191111,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 695506,
    "state": "KERALA",
    "district": "TRIVANDRUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 741154,
    "state": "WEST BENGAL",
    "district": "KRISHNANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 192124,
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR+-JK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670103,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670104,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680502,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689106,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 689551,
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670106,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670642,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670649,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670661,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670671,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 670694,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673311,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673312,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 673313,
    "state": "KERALA",
    "district": "KANNUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691016,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 691304,
    "state": "KERALA",
    "district": "KOLLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 402308,
    "state": "MAHARASHTRA",
    "district": "RAIGARH(MH)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 680591,
    "state": "KERALA",
    "district": "THRISSUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799273,
    "state": "TRIPURA",
    "district": "DHALAI DISTRICT TRIPURA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736157,
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 603101,
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466221,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 251003,
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465106,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 712301,
    "state": "WEST BENGAL",
    "district": "HOOGLY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 212105,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284135,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 211021,
    "state": "UTTAR PRADESH",
    "district": "ALLAHABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 284127,
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248014,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 248013,
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517236,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 518216,
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 517123,
    "state": "ANDHRA PRADESH",
    "district": "TIRUPATI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583235,
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242223,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242226,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 676523,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679581,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 387570,
    "state": "GUJARAT",
    "district": "KHEDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 242405,
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR -UP",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788119,
    "state": "ASSAM",
    "district": "CACHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781307,
    "state": "ASSAM",
    "district": "BARPETA (AS)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742235,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 534222,
    "state": "ANDHRA PRADESH",
    "district": "RAJAHMUNDRY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 583218,
    "state": "KARNATAKA",
    "district": "BELLARY",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 491881,
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 497111,
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 591244,
    "state": "KARNATAKA",
    "district": "BELGAUM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782442,
    "state": "ASSAM",
    "district": "NAOGAON",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785697,
    "state": "ASSAM",
    "district": "SIBSAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785102,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785105,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 785110,
    "state": "ASSAM",
    "district": "JORHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784150,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784010,
    "state": "ASSAM",
    "district": "TEZPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 600131,
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 221313,
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363520,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828120,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 126115,
    "state": "HARYANA",
    "district": "HISSAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 828204,
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 812007,
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 800028,
    "state": "BIHAR",
    "district": "PATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 764021,
    "state": "ORISSA",
    "district": "KORAPUT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742104,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732127,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732210,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 732140,
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742409,
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742408,
    "state": "WEST BENGAL",
    "district": "BAHARAMPORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 721654,
    "state": "WEST BENGAL",
    "district": "MEDINIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 577544,
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 829202,
    "state": "JHARKHAND",
    "district": "RANCHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 571606,
    "state": "KARNATAKA",
    "district": "MANDYA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 723126,
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781308,
    "state": "ASSAM",
    "district": "BARPETA (AS)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 131022,
    "state": "HARYANA",
    "district": "KUNDLI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 784116,
    "state": "ASSAM",
    "district": "DARRANG",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 174037,
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR  ( H.P.)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 637401,
    "state": "TAMIL NADU",
    "district": "SALEM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 781314,
    "state": "ASSAM",
    "district": "BARPETA (AS)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 363530,
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 271204,
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 360022,
    "state": "GUJARAT",
    "district": "RAJKOT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 743294,
    "state": "WEST BENGAL",
    "district": "BARASAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 492101,
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 782127,
    "state": "ASSAM",
    "district": "JAGIROAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 786103,
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 788127,
    "state": "ASSAM",
    "district": "CACHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 679339,
    "state": "KERALA",
    "district": "KOTTAKKAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 384005,
    "state": "GUJARAT",
    "district": "MEHSANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 563128,
    "state": "KARNATAKA",
    "district": "HOSAKOTE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 521402,
    "state": "ANDHRA PRADESH",
    "district": "VIJAYAWADA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 787061,
    "state": "ASSAM",
    "district": "DHEMAJI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 365440,
    "state": "GUJARAT",
    "district": "AMRELI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 631052,
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341020,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 841213,
    "state": "BIHAR",
    "district": "CHAPRA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 141206,
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 736221,
    "state": "WEST BENGAL",
    "district": "ALIPURDWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311301,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312025,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312207,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313024,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323303,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323304,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323305,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325208,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331303,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334402,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335051,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335707,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335801,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342604,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306105,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334302,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335002,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306603,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326518,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333028,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331302,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334804,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303008,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303105,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342603,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328025,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333023,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334201,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335062,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302036,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321611,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332709,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342605,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303329,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331506,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331701,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331802,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314036,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325601,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312606,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332706,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333502,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332719,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314403,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314406,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303009,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321406,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311201,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331501,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321206,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304505,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303604,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321404,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304503,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303305,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303326,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321205,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305205,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305206,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335708,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303701,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303803,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303804,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303805,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303806,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303807,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305627,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305628,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305629,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305811,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325004,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325009,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303602,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303107,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303110,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303119,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303120,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303348,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303908,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303601,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303003,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305207,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303001,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325602,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451449,
    "state": "MADHYA PRADESH",
    "district": "KENDRAPARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342023,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305012,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305631,
    "state": "RAJASTHAN",
    "district": "AJMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301018,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301021,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301023,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301024,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301025,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301027,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301028,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301035,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301401,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301403,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301406,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301407,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301409,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301410,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301412,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301413,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301414,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301415,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301416,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301427,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301604,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301703,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301704,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301708,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301709,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301713,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 301714,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321605,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321606,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321607,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321633,
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327021,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327027,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327031,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327032,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327601,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327602,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327603,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327604,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327605,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327606,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 327801,
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325207,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325209,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325217,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325222,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325223,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325224,
    "state": "RAJASTHAN",
    "district": "BARAN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344011,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344012,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344025,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344026,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344027,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344035,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344037,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344043,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344501,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344502,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344703,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344705,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344706,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344708,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 344801,
    "state": "RAJASTHAN",
    "district": "BARMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321021,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321023,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321024,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321025,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321026,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321028,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321202,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321204,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321301,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321302,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321303,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321402,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321403,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321405,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321407,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321408,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321409,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321410,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321411,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321601,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321614,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321615,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321642,
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311011,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311022,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311023,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311024,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311025,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311026,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311030,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311202,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311203,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311204,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311302,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311401,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311402,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311403,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311407,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311408,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311601,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311603,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311605,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311606,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311802,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311803,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311804,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311805,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 311806,
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331801,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331811,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334022,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334202,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334303,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334305,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334403,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334601,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334602,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334604,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334802,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 334808,
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323021,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323022,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323023,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323024,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323025,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323026,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323301,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323601,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323602,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323616,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323801,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323802,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 323803,
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312022,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312023,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312024,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312027,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312201,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312205,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312206,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312401,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312402,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312403,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312404,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312602,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312603,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312612,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312613,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312614,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312617,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312620,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312622,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312627,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312901,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331021,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331029,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331031,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331301,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331305,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331402,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331411,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331502,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331503,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331504,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331505,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331517,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331518,
    "state": "RAJASTHAN",
    "district": "CHURU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303004,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303302,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303304,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303315,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303323,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303325,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303501,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303502,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303504,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303506,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303507,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303508,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303509,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303510,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303511,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321609,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321610,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321612,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 321613,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322240,
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328022,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328023,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328024,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328026,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328027,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328028,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328029,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328030,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328031,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 328041,
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314011,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314021,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314022,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314023,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314024,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314028,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314029,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314030,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314032,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314034,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314035,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314037,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314038,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314401,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314402,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314404,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314801,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 314804,
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335021,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335022,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335023,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335024,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335027,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335037,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335038,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335039,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335040,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335061,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335703,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335705,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335901,
    "state": "RAJASTHAN",
    "district": "SRIGANGANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335064,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335065,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335502,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335503,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335504,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335511,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335522,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335525,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 335802,
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302038,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302040,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302041,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302042,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302043,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302044,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302045,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 302046,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303005,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303006,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303122,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303123,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 303124,
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345023,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345024,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345026,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345031,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345033,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 345034,
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307030,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307515,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307803,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343021,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343023,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343024,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343025,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343027,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343028,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343030,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343032,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343039,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343040,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343042,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343048,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 343049,
    "state": "RAJASTHAN",
    "district": "JALORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326034,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326035,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326039,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326501,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326512,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326514,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326515,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 326516,
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331025,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331026,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331028,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 331030,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332716,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332746,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333010,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333011,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333012,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333020,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333021,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333024,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333025,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333027,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333030,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333032,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333033,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333034,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333035,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333036,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333041,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333053,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333055,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333302,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333303,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333304,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333305,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333308,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333501,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333503,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333514,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333515,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333701,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333702,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333707,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 333801,
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342021,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342022,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342024,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342025,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342028,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342029,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342030,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342302,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342308,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342309,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342311,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342312,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342314,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 342901,
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322033,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322202,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322203,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322204,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322212,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322213,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322215,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322216,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322218,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322219,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322220,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322234,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322236,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322238,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322242,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322243,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322249,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322251,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322252,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322254,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322255,
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 325214,
    "state": "RAJASTHAN",
    "district": "KOTA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305026,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341021,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341022,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341023,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341025,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341026,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341027,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341028,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341029,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341030,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341031,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341301,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341302,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341304,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341305,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341316,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341317,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341318,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341319,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341501,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341502,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341504,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341507,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341511,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341512,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341513,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341514,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341515,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341517,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341518,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341519,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341520,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341533,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341542,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 341551,
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306021,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306022,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306023,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306102,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306103,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306114,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306119,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306126,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306305,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306306,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306307,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306422,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306501,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306502,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306503,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306504,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306601,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306602,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306702,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306703,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306704,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306705,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306706,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306707,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306901,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 306912,
    "state": "RAJASTHAN",
    "district": "PALI (RJ)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312604,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312615,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312616,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312619,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312623,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312624,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312625,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 312626,
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 305921,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313011,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313202,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313204,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313206,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313321,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313323,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313325,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313327,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313328,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313330,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313333,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313341,
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322023,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322024,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322025,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322026,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322027,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322028,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322029,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322030,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322034,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322205,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322211,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322214,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322701,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322702,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322703,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 322704,
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332002,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332023,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332024,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332026,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332027,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332028,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332029,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332030,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332041,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332042,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332302,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332303,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332304,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332305,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332307,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332312,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332315,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332316,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332317,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332318,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332401,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332405,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332406,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332411,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332601,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332603,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332703,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332705,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332707,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332708,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332711,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332712,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332714,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332718,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332721,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332722,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 332742,
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307019,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307023,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307024,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307028,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307031,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307032,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307043,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307501,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307511,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307512,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307513,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307514,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307801,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307802,
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304023,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304024,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304025,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304026,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304501,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304504,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304507,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304801,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304802,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 304803,
    "state": "RAJASTHAN",
    "district": "TONK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 307025,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313022,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313031,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313201,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313203,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313604,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313701,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313702,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313703,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313704,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313705,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313706,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313708,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313801,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313802,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313803,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313804,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313805,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313901,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313902,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313903,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313904,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313905,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 313906,
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 783361,
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 423106,
    "state": "MAHARASHTRA",
    "district": "NASIK",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 414607,
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 608501,
    "state": "TAMIL NADU",
    "district": "VILLUPURAM+-+TN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 799261,
    "state": "TRIPURA",
    "district": "DHARMANAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 742407,
    "state": "WEST BENGAL",
    "district": "BERHAMPORE -WB",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458470,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475682,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480337,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480338,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483110,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464661,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488333,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486771,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483880,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486450,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465337,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486114,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480551,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458116,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458336,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484330,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472246,
    "state": "MADHYA PRADESH",
    "district": "NIWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476115,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486881,
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460440,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464651,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484551,
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487770,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470118,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475675,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472447,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471111,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471313,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481441,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486338,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 277503,
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473113,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484114,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484117,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484555,
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484776,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485226,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453446,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455221,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455339,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455440,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 455459,
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483001,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483222,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483773,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486892,
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451221,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451442,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464220,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464224,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464331,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483119,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475001,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475220,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475335,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475336,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 814152,
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453220,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450051,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450110,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450114,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450117,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450337,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450551,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450554,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450661,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450771,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450881,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 450991,
    "state": "MADHYA PRADESH",
    "district": "KHANDWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451220,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451225,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451335,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451440,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451441,
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 451881,
    "state": "MADHYA PRADESH",
    "district": "GANJAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453556,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 453661,
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454010,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454335,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 454441,
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456003,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456222,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456313,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456337,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456441,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456550,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456661,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456664,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456668,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456770,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 456776,
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457118,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457119,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457331,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457333,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457336,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457339,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457340,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457441,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457555,
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457770,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457882,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457885,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 457888,
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458113,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458220,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458339,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458389,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458553,
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458556,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458558,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458669,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458771,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458778,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 458895,
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR / DASPURKUNJ",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460004,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460225,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460330,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460553,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460554,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460557,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460663,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460665,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460666,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 460668,
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461110,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461114,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461115,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461116,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461122,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461221,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461446,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461551,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 461668,
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462040,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462100,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462101,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 462120,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 463111,
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464111,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464113,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464114,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464226,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464240,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464258,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464334,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464337,
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464570,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464573,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464671,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464672,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464774,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464986,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 464990,
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465110,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465113,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465116,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465118,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465220,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465223,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465227,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465230,
    "state": "MADHYA PRADESH",
    "district": "AGARMALWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465335,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465339,
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465550,
    "state": "MADHYA PRADESH",
    "district": "AGARMALWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465677,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465685,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465687,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 465689,
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466111,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466113,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466118,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466120,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466125,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466448,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466554,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466651,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 466665,
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470003,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470021,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470051,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470115,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470120,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470125,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470221,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470223,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470228,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470232,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470337,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470339,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470340,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470663,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470664,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470666,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470669,
    "state": "MADHYA PRADESH",
    "district": "SAGAR(MP)",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470672,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470673,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470675,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470771,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470772,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470775,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470880,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 470881,
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472337,
    "state": "MADHYA PRADESH",
    "district": "NIWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472445,
    "state": "MADHYA PRADESH",
    "district": "NIWARI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473105,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473110,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473111,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473115,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473118,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473222,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473249,
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473330,
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473332,
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473335,
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473440,
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473444,
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473445,
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476332,
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476335,
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476339,
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476355,
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480003,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480105,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480107,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480109,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480110,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480111,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480112,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480115,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480221,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480223,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480224,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480331,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480447,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480449,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480555,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480557,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480559,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480771,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480880,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480881,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480882,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480884,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480887,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480888,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480990,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480991,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480994,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480996,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480997,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480999,
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481051,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481102,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481105,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481117,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481224,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481332,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481335,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481337,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481449,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481551,
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481662,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481663,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481664,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481665,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481666,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481668,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481672,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481768,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481771,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481778,
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481879,
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481882,
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481883,
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481884,
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481885,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481995,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481996,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 481998,
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 482051,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483053,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483105,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483113,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483220,
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483330,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483331,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483332,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483334,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483440,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483442,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 483990,
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484113,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484116,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484120,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484220,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484336,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484440,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484444,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484446,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484447,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484660,
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484664,
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484665,
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484669,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484770,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484771,
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484881,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484886,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 484887,
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485111,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485112,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485113,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485114,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485115,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485221,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485331,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485334,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485441,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485447,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485551,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485661,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485666,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485772,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485773,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485774,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485778,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 485881,
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486003,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486005,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486006,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486115,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486117,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486123,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486220,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486223,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486333,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486335,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486340,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486341,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486440,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486445,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486446,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486447,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486448,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486550,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486553,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486556,
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486666,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486669,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486670,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486675,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486775,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486776,
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487110,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487114,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487225,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487330,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487334,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487337,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487441,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487555,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487661,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 487881,
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488050,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488059,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488220,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488222,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488441,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488442,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488443,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488446,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 488448,
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471101,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471105,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471301,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471315,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471318,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471405,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471408,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471411,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471501,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471510,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471515,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471516,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471525,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 471625,
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472005,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472010,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472101,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472111,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472115,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472118,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472221,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472331,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 472339,
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473585,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473638,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473662,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473665,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473670,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473775,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473781,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473865,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473880,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 473885,
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475002,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475115,
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475671,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475673,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 475685,
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476134,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476219,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476221,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476224,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476228,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 476554,
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477105,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477111,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477222,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477227,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477331,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477332,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477333,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477335,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477441,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477446,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477447,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477449,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477450,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477555,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477566,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 477660,
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 480108,
    "state": "MADHYA PRADESH",
    "district": "CHINDWARA",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486882,
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486884,
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  },
  {
    "pincode": 486887,
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "pickUpStatus": "Normal Pick Up Service Available",
    "deliveryStatus": "All Goods"
  }
];